"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37376],{

/***/ 88259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var stores_company_useGetCompanyInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25610);




var useBestBidOfferData = function(data, symbol) {
    var defaultMarketStatus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var timeLeftSeconds = (data === null || data === void 0 ? void 0 : data.time_left_seconds) || 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showBestBid = ref[0], setShowBestBid = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(data), bestBidData = ref1[0], setBestBidData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isBlured = ref2[0], setIsBlured = ref2[1];
    var getCompanyInfo = (0,stores_company_useGetCompanyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.getCompanyInfo;
    });
    var companyData = (0,stores_company_useGetCompanyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.data;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (symbol && !defaultMarketStatus) {
            getCompanyInfo(symbol);
        }
    }, [
        symbol,
        defaultMarketStatus
    ]);
    // update data from websocket
    var setBestBidOffer = function(newData) {
        var bestBid = newData.bestBid, bestOffer = newData.bestOffer;
        if (bestBid) {
            setBestBidData(function(prevData) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prevData), {
                    bid: bestBid
                });
            });
        }
        if (bestOffer) {
            setBestBidData(function(prevData) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prevData), {
                    offer: bestOffer
                });
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (data) {
            setBestBidData(data);
            setShowBestBid(true);
        }
        return function() {
            setShowBestBid(false);
        };
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref, ref1;
        var marketStatus = defaultMarketStatus || ((ref = companyData[symbol]) === null || ref === void 0 ? void 0 : (ref1 = ref.market_hour) === null || ref1 === void 0 ? void 0 : ref1.status);
        var hasBestBidOffer = data && showBestBid;
        if (marketStatus) {
            setIsBlured(marketStatus === "open" && hasBestBidOffer);
        } else {
            setIsBlured(false);
        }
        return function() {
            setIsBlured(false);
        };
    }, [
        companyData,
        symbol,
        data,
        defaultMarketStatus,
        showBestBid
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timeout = null;
        if (timeLeftSeconds > 0) {
            timeout = setTimeout(function() {
                setShowBestBid(false);
                setIsBlured(false);
            }, timeLeftSeconds * 1000);
        }
        return function() {
            clearTimeout(timeout);
        };
    }, [
        timeLeftSeconds
    ]);
    return {
        showBestBid: showBestBid,
        bestBidData: bestBidData,
        isBlured: isBlured,
        setBestBidOffer: setBestBidOffer
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useBestBidOfferData);


/***/ }),

/***/ 13799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ specialMonitoring; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/constants/contents/special-monitoring.ts
var SESSION_A = [
    {
        session: 1,
        orderCollection: "09:00 - 09:55",
        randomClosing: "09:53 - 09:55",
        orderMatching: "09:55 - 10:00"
    },
    {
        session: 2,
        orderCollection: "10:00 - 10:55",
        randomClosing: "10:53 - 10:55",
        orderMatching: "10:55 - 11:00"
    },
    {
        session: 3,
        orderCollection: "11:00 - 11:55",
        randomClosing: "11:53 - 11:55",
        orderMatching: "11:55 - 12:00"
    },
    {
        session: 4,
        orderCollection: "14:00 - 14:55",
        randomClosing: "14:53 - 14:55",
        orderMatching: "14:55 - 15:00"
    },
    {
        session: 5,
        orderCollection: "15:00 - 15:55",
        randomClosing: "15:53 - 15:55",
        orderMatching: "15:55 - 16:00"
    }, 
];
var SESSION_B = [
    {
        session: 1,
        orderCollection: "09:00 - 09:55",
        randomClosing: "09:53 - 09:55",
        orderMatching: "09:55 - 10:00"
    },
    {
        session: 2,
        orderCollection: "10:00 - 11:25",
        randomClosing: "11:23 - 11:25",
        orderMatching: "11:25 - 11:30"
    },
    {
        session: 3,
        orderCollection: "14:00 - 14:55",
        randomClosing: "14:53 - 14:55",
        orderMatching: "14:55 - 15:00"
    },
    {
        session: 4,
        orderCollection: "15:00 - 15:55",
        randomClosing: "15:53 - 15:55",
        orderMatching: "15:55 - 16:00"
    }, 
];
var CRITERIA = [
    {
        id: 1,
        content: "Harga rata-rata saham selama enam bulan terakhir di pasar reguler kurang dari Rp51. Kriteria ini tidak berlaku untuk perusahaan tercatat yang ada di papan akselerasi."
    },
    {
        id: 2,
        content: "Laporan keuangan auditan terakhir perusahaan terdapat disclaimer. Dengan aturan ini, bursa tidak perlu menunggu perusahaan tercatat mendapat opini disclaimer dua kali, tetapi bursa bisa langsung memasukkan perusahaan ke dalam pemantauan khusus."
    },
    {
        id: 3,
        content: "Memiliki ekuitas negatif pada laporan keuangan terakhir. Pada saat ini, bursa tidak menunggu laporan keuangan tahunan, tapi berdasarkan laporan keuangan interim per Maret, Juni, atau September."
    },
    {
        id: 4,
        content: "Memiliki anak perusahaan yang kontribusi pendapatannya material bagi perusahaan tercatat, dan juga anak perusahaan tersebut dalam kondisi dimohonkan PKPU atau pailit."
    }, 
];
var SPECIAL_INFO = {
    date: "25 Maret 2024",
    auction: "Full Call Auction"
};
var SESSION_A_EXISTING = [
    {
        session: "I",
        orderCollection: "09.00 - 11.55 WIB",
        processingOrder: "11.55 - 12.00 WIB"
    },
    {
        session: "II",
        orderCollection: "13.25 - 15.55 WIB",
        processingOrder: "15.55 - 16.00 WIB"
    }, 
];
var SESSION_B_EXISTING = [
    {
        session: "I",
        orderCollection: "09.00 - 11.25 WIB",
        processingOrder: "11.25 - 11.30 WIB"
    },
    {
        session: "II",
        orderCollection: "13.55 - 15.55 WIB",
        processingOrder: "15.55 - 16.00 WIB"
    }, 
];
var SPECIAL_INFO_EXISTING = {
    date: "12 Juni 2023",
    auction: "Hybrid Call Auction"
};
var FULL_CALL_AUCTION = [
    {
        label: "Input Order",
        inclusion: [
            true,
            false,
            false
        ]
    },
    {
        label: "Amend",
        inclusion: [
            true,
            false,
            false
        ]
    },
    {
        label: "Withdraw",
        inclusion: [
            true,
            false,
            true
        ]
    }, 
];
var EXISTING_CONTENT = {
    SESSION_A: SESSION_A_EXISTING,
    SESSION_B: SESSION_B_EXISTING,
    CRITERIA: CRITERIA,
    SPECIAL_INFO: SPECIAL_INFO_EXISTING,
    FULL_CALL_AUCTION: FULL_CALL_AUCTION
};
/* harmony default export */ var special_monitoring = ({
    SESSION_A: SESSION_A,
    SESSION_B: SESSION_B,
    CRITERIA: CRITERIA,
    SPECIAL_INFO: SPECIAL_INFO,
    FULL_CALL_AUCTION: FULL_CALL_AUCTION
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/securities/static/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  overflow: auto;\n\n  &::-webkit-scrollbar {\n    width: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StaticPageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2852a370-0"
})(_templateObject(), function(props) {
    return props.mode === "dark" ? "#121212" : color/* default.light */.Z.light;
});

// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: 1px dashed;\n  border-color: ",
        ";\n  border-width: 1px 0 0;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  padding-bottom: 20px;\n  margin: 0 auto;\n  max-width: 500px;\n\n  @media screen and (max-width: 500px) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid\n    ",
        ";\n  border-radius: 4px;\n  margin-top: 20px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 20px;\n  border-bottom: 1px solid\n    ",
        ";\n\n  h1 {\n    font-size: 14px;\n    font-family: var(--bold-font);\n    line-height: 19px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 20px;\n\n  .special-monitoring-session-container {\n    margin-top: 20px;\n\n    p {\n      margin-bottom: 8px;\n    }\n\n    .special-monitoring-session-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n\n  ul {\n    padding-inline-start: 24px;\n\n    li {\n      margin-bottom: 20px;\n\n      &::marker {\n        color: ",
        ";\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Divider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-30ff954e-0"
})(styled_templateObject(), function(props) {
    return props.mode === "dark" ? "rgb(238 238 238 / 25%)" : "rgb(238 238 238 / 95%)";
});
var SpecialMonitoringContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-1"
})(_templateObject1());
var SpecialMonitoringCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-2"
})(_templateObject2(), function(props) {
    return props.mode === "dark" ? "#2e2e2e" : color/* default.downgray */.Z.downgray;
});
var SpecialMonitoringHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-3"
})(_templateObject3(), function(props) {
    return props.mode === "dark" ? "#2e2e2e" : color/* default.downgray */.Z.downgray;
});
var SpecialMonitoringBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-4"
})(_templateObject4(), function(props) {
    return props.mode === "dark" ? color/* default.lowgray */.Z.lowgray : color/* default.highempahis */.Z.highempahis;
});

// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/components/SessionItem.tsx




function SessionItem(param) {
    var session = param.session, idx = param.idx, color = param.color, _isExisting = param.isExisting, isExisting = _isExisting === void 0 ? false : _isExisting;
    var sessionContent = session;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justify: "space-between",
        width: "100%",
        // @ts-expect-error
        mt: "14px",
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "12px",
                color: color,
                width: "40px",
                children: [
                    "Sesi ",
                    sessionContent.session
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        width: "98px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "12px",
                                color: "#858585",
                                mb: "4px",
                                children: "Order Collection"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "12px",
                                family: "bold",
                                color: color,
                                children: sessionContent.orderCollection
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: !isExisting,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                width: "98px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Random Closing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        family: "bold",
                                        color: color,
                                        children: sessionContent.randomClosing
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                width: "98px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Order Matching"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        family: "bold",
                                        color: color,
                                        children: sessionContent.orderMatching
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }, "".concat(sessionContent.session, "-").concat(idx + 1, "-session-a"));
};

;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/index.tsx










var SpecialMonitoringInformation = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "light" : _mode;
    var CONTENT = special_monitoring;
    var textColor = (0,react.useMemo)(function() {
        return mode === "dark" ? color/* default.lowgray */.Z.lowgray : color/* default.highempahis */.Z.highempahis;
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticPageContainer, {
        mode: mode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                color: textColor,
                                children: "Kapan transaksi saya akan diproses?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringBody, {
                            mode: mode,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: textColor,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Order saat Full Call Auction"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justify: "space-between",
                                    width: "100%",
                                    mt: "12px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: textColor,
                                            width: "70px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Order Collection"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Random Closing"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Order Matching"
                                        })
                                    ]
                                }),
                                CONTENT.FULL_CALL_AUCTION.map(function(content, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justify: "space-between",
                                        width: "100%",
                                        // @ts-expect-error
                                        mt: "12px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "12px",
                                                color: textColor,
                                                width: "70px",
                                                family: "bold",
                                                children: content.label
                                            }),
                                            content.inclusion.map(function(inclusion) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    align: "center",
                                                    justify: "center",
                                                    width: "70px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: inclusion ? "/icon/ic-check-green.svg" : "/icon/ic-close-red.svg"
                                                    })
                                                });
                                            })
                                        ]
                                    }, "".concat(content.label, "-").concat(idx + 1, "-fca"));
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                                    mode: mode,
                                    dashed: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: textColor,
                                    children: [
                                        "Transaksi kamu akan diproses pada masa",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "Order Matching"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    direction: "column",
                                    my: "20px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: textColor,
                                            children: "Senin-Kamis"
                                        }),
                                        CONTENT.SESSION_A.map(function(session, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionItem, {
                                                session: session,
                                                idx: idx,
                                                color: textColor
                                            }, "".concat(session.session, "-").concat(idx + 1, "-session-a"));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                                    mode: mode,
                                    dashed: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    direction: "column",
                                    my: "20px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: textColor,
                                            children: "Jumat"
                                        }),
                                        CONTENT.SESSION_B.map(function(session, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionItem, {
                                                session: session,
                                                idx: idx,
                                                color: textColor
                                            }, "".concat(session.session, "-").concat(idx + 1, "-session-b"));
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                color: textColor,
                                children: "Kenapa saya tidak bisa langsung beli saham ini?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringBody, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: textColor,
                                children: [
                                    "Per tanggal ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: CONTENT.SPECIAL_INFO.date
                                    }),
                                    ", Bursa Efek Indonesia menerapkan mekanisme",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: CONTENT.SPECIAL_INFO.auction
                                    }),
                                    " untuk saham di papan pemantauan khusus."
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                color: textColor,
                                children: "Apa kriteria saham dalam pemantauan khusus?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringBody, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: special_monitoring.CRITERIA.map(function(criteria, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: textColor,
                                            children: criteria.content
                                        })
                                    }, "".concat(criteria.id, "-").concat(idx + 1, "-criteria"));
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var specialMonitoring = (SpecialMonitoringInformation);


/***/ }),

/***/ 66019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ transaction_ModuleFederationForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/typings/theme.ts
var theme = __webpack_require__(33270);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts
var useTermsAndConditionStore = __webpack_require__(24383);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var types = __webpack_require__(20620);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useSyariah.ts
var useSyariah = __webpack_require__(47060);
// EXTERNAL MODULE: ./src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(34400);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/Securities/stores/useCashInfoStore.ts
var useCashInfoStore = __webpack_require__(11806);
// EXTERNAL MODULE: ./src/lib/flipt/hooks/index.ts + 1 modules
var hooks = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./src/hooks/useIsSecuritiesMainAccount.ts
var useIsSecuritiesMainAccount = __webpack_require__(87315);
// EXTERNAL MODULE: ./src/features/fast-order/FastOrderSkeleton/styled.ts + 2 modules
var styled = __webpack_require__(72294);
// EXTERNAL MODULE: ./src/features/fast-order/Flex/index.ts + 1 modules
var Flex = __webpack_require__(55524);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/transaction/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f7f7f7;\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  position: relative;\n  margin: 8px 0;\n\n  &:before {\n    content: '';\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    background: #f7f7f7;\n    display: block;\n    position: absolute;\n    left: 20%;\n    top: -8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RangeSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eb9fe6a1-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/features/transaction/Skeleton.tsx




var TradingFormSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
        direction: "column",
        justify: "space-between",
        style: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
            direction: "column",
            p: 16,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                        width: 180,
                        height: 12
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        gap: 16,
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 140,
                                height: 12
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        gap: 16,
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        gap: 16,
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        gap: 16,
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 140,
                                height: 12
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        gap: 16,
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 140,
                                height: 12
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        gap: 16,
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                width: 80,
                                height: 12
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Skeleton = (TradingFormSkeleton);

// EXTERNAL MODULE: ./src/features/transaction/useTradingStore.ts
var useTradingStore = __webpack_require__(93918);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePrice.ts
var useLivePrice = __webpack_require__(39767);
;// CONCATENATED MODULE: ./src/features/transaction/useBuySellDatafeed.ts



var useBuySellDatafeed = function(symbol) {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    (0,useLivePrice/* useLivePrice */.L)([
        symbol
    ], liveprice_store_types/* LivePriceSymbolsKeyEnum.TRANSACTION_FORM */.j.TRANSACTION_FORM, "transaction_form", function(data) {
        queryClient.setQueryData([
            "@trailing-stop/datafeed/liveprice"
        ], function() {
            return data;
        });
    });
};

;// CONCATENATED MODULE: ./src/features/transaction/ModuleFederationForm.tsx



























var BuySellRemote = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 26645).then(__webpack_require__.t.bind(__webpack_require__, 26645, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26645)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {});
    }
});
var WidgetManager = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61000).then(__webpack_require__.t.bind(__webpack_require__, 61000, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61000)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {});
    }
});
var ModuleFederationForm = function(param) {
    var initialData = param.initialData, formId = param.formId, customPrice = param.customPrice, onSwitchTab = param.onSwitchTab;
    useBuySellDatafeed(initialData.currentSymbol);
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var isDayTradeEnabled = true;
    var isMarketOrderEnabled = true;
    var isTrailingStopEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.TRAILING_STOP */.O.TRAILING_STOP);
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var getUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue;
    });
    var orderType = (0,store/* default */.Z)(function(s) {
        return s.orderType;
    });
    var isGtc = (0,store/* default */.Z)(function(s) {
        return s.isGtc;
    });
    var setModal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setModal;
    });
    var openFromWidget = (0,useTradingStore/* default */.Z)(function(s) {
        return s.openFromWidget;
    });
    var loadCashInfo = (0,useCashInfoStore/* default */.Z)(function(s) {
        return s.loadCashInfo;
    });
    var ref = (0,useSyariah/* default */.Z)(), isSyariahUser = ref.isUserSyariah, checkSyariahTradeableStatus = ref.checkSyariahTradeableStatus;
    var orderList = (0,tradingData/* default */.Z)(function(s) {
        return s.orderHistory;
    });
    var isMainAccount = (0,useIsSecuritiesMainAccount/* default */.Z)();
    var showTradingLimit = isMainAccount;
    var loadTnC = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadTnC;
    });
    var termsData = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.termsData;
    });
    var loadTnCAcceptance = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadTnCAcceptance;
    });
    var loadSubAccountStatus = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadSubAccountStatus;
    });
    var ref1 = (0,react.useState)(null), portoUpdateTime = ref1[0], setPortoUpdateTime = ref1[1];
    (0,react.useEffect)(function() {
        if (orderList) {
            var currentTime = moment_default()().format("YYYYMMDDHHmmssSSS");
            setPortoUpdateTime(currentTime);
        }
    }, [
        orderList
    ]);
    var loadDayTradeTncStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", loadTnCAcceptance([
                            termsAndCondition/* TnCFeaturesIDEnum.TRADING_LIMIT */.el.TRADING_LIMIT,
                            termsAndCondition/* TnCFeaturesIDEnum.DAY_TRADE */.el.DAY_TRADE, 
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadDayTradeTncStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadDayTradeSubAccountStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var subAccountActive;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        subAccountActive = getUIValue("dayTradeSubAccountActive");
                        if (!subAccountActive) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", subAccountActive);
                    case 3:
                        return _ctx.abrupt("return", loadSubAccountStatus(termsAndCondition/* SubAccountType.DAY_TRADE */.RD.DAY_TRADE));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadDayTradeSubAccountStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var getDayTradeTncStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var checkShown, isActive, dayTradeTncShown, dayTradeTnc, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        checkShown = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                        if (!isSyariahUser) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 3:
                        if (termsData) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return loadDayTradeTncStatus();
                    case 6:
                        _ctx.next = 8;
                        return loadDayTradeSubAccountStatus();
                    case 8:
                        isActive = _ctx.sent;
                        if (!isActive) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 11:
                        dayTradeTncShown = getUIValue("dayTradeTncShown");
                        if (!(dayTradeTncShown !== undefined && checkShown)) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", dayTradeTncShown);
                    case 14:
                        dayTradeTnc = getUIValue("dayTradeTnc");
                        if (!(dayTradeTnc !== undefined)) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", dayTradeTnc);
                    case 17:
                        return _ctx.abrupt("return", loadDayTradeTncStatus());
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getDayTradeTncStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenModalDayTrade = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(open, callback) {
            var isDayTradeAccepted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!open) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return getDayTradeTncStatus(false);
                    case 3:
                        isDayTradeAccepted = _ctx.sent;
                        if (!isDayTradeAccepted) {
                            setModal(types/* MODAL_TYPE.DAY_TRADE_TNC */.fG.DAY_TRADE_TNC, {
                                onSubmitDayTradeTnC: function() {
                                    callback();
                                    setModal("", {
                                        onSubmitDayTradeTnC: undefined
                                    });
                                }
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOpenModalDayTrade(open, callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowTradingLimitTnc = function(open, callback) {
        if (open) {
            loadTnC(termsAndCondition/* TnCFeatureIDEnum.FEATURE_TRADING_LIMIT */.hO.FEATURE_TRADING_LIMIT, /**
         * If user is not yet accepted the TnC,
         * then show the modal using the callback
         */ function() {
                setUIValue("tradingLimitTnc", false);
                setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
                setModal(types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC);
                setModal(types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC, {
                    onSubmitTradingLimitTnC: function() {
                        callback();
                        setModal("", {
                            onSubmitTradingLimitTnC: undefined
                        });
                    }
                });
            }, /**
         * If user was accepted the TnC before,
         * then show continue their action to use the Trading limit as payment
         */ function() {
                setUIValue("tradingLimitTnc", true);
                setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit);
                if (!openFromWidget) setModal(types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
            });
        }
    };
    var getShariaTradableStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isBuy, isShariaTradable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY;
                        if (!(!isSyariahUser || !isBuy)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 3:
                        _ctx.next = 5;
                        return checkSyariahTradeableStatus(initialData.currentSymbol);
                    case 5:
                        isShariaTradable = _ctx.sent;
                        if (isShariaTradable) {
                            _ctx.next = 9;
                            break;
                        }
                        setModal(types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE);
                        return _ctx.abrupt("return", false);
                    case 9:
                        return _ctx.abrupt("return", true);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getShariaTradableStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePlaceOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getShariaTradableStatus();
                    case 2:
                        if (_ctx.sent) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        setModal(types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW, {
                            previewData: (0,_object_spread/* default */.Z)({}, data, isGtc !== undefined ? {
                                gtc: isGtc
                            } : {})
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePlaceOrder(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useKeyPress/* default */.Z)([
        "Enter"
    ], function() {
        var customEvent = new CustomEvent("host-buysell", {
            detail: {
                name: "submit-order",
                id: formId
            }
        });
        window.dispatchEvent(customEvent);
    });
    (0,react.useEffect)(function() {
        if (initialData.currentSymbol && [
            trading/* ORDER_TYPE.BUY */.Jm.BUY,
            trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY
        ].includes(orderType)) {
            loadCashInfo(initialData.currentSymbol);
        }
    }, [
        initialData.currentSymbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                margin: "0 -12px",
                flexGrow: 1
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetManager, {
                value: {
                    channel: 0,
                    tabId: "",
                    widgetId: ""
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuySellRemote, {
                    formId: formId,
                    themeMode: theme/* ThemeMode.Light */.h.Light,
                    platform: "web",
                    queryClient: queryClient,
                    initalFormData: initialData,
                    showIcon: true,
                    showTradingLimit: showTradingLimit,
                    enabledDayTrade: isDayTradeEnabled,
                    isMainAccount: isMainAccount,
                    openDeposit: function() {
                        return window.open("".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV, "/securities/deposit"));
                    },
                    openPreview: handlePlaceOrder,
                    marketEnabled: isMarketOrderEnabled,
                    isSyariahUser: isSyariahUser,
                    openDayTradeTnC: handleOpenModalDayTrade,
                    openTradingLimitTnC: handleShowTradingLimitTnc,
                    portoUpdateTime: portoUpdateTime,
                    useEnterToSubmit: false,
                    isActive: true,
                    portalId: openFromWidget ? undefined : "buy-sell-portal",
                    isOrderOnProcess: false,
                    disableInitialAutofocus: openFromWidget,
                    customPrice: customPrice,
                    onUpdateFormType: onSwitchTab,
                    featureFlags: {
                        trailingStopEnabled: isTrailingStopEnabled,
                        bracketOrderEnabled: false
                    }
                })
            })
        })
    });
};
/* harmony default export */ var transaction_ModuleFederationForm = (/*#__PURE__*/(0,react.memo)(ModuleFederationForm));


/***/ }),

/***/ 48481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ModalNames; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var ModalNames;
(function(ModalNames) {
    ModalNames["ARA_ARB_ESTIMATION"] = "ARA_ARB_ESTIMATION";
})(ModalNames || (ModalNames = {}));
var useDatafeedModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        activeModal: null,
        modalData: undefined,
        openModal: function(modalName, modalData) {
            return set({
                activeModal: modalName,
                modalData: modalData
            });
        },
        closeModal: function() {
            return set({
                activeModal: null,
                modalData: undefined
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedModalStore);


/***/ }),

/***/ 82093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InfoButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  background: none;\n  border: none;\n  padding: 4px 0;\n  margin: 0;\n\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var InfoButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-3a702b20-0"
})(_templateObject());


/***/ }),

/***/ 37212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Slider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/trading/Slider.js
var Slider = __webpack_require__(22613);
;// CONCATENATED MODULE: ./src/global/Securities/components/Slider/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 0;\n  border-radius: 4px;\n\n  &:hover .ant-slider-handle {\n    border-color: #00ab6b !important;\n  }\n\n  & > .ant-slider-handle {\n    transition: left 0.1s linear;\n    will-change: left;\n\n    z-index: 3;\n    border-color: #00ab6b;\n    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);\n\n    &:hover {\n      border-color: #00ab6b !important;\n    }\n\n    :focus {\n      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);\n    }\n\n    :active {\n      box-shadow: 0 0 0 5px rgb(0, 171, 107, 0.12);\n    }\n  }\n\n  & > .ant-slider-rail {\n    display: block;\n    z-index: 1;\n    background-color: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  & > .ant-slider-track {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  cursor: pointer;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  pointer-events: none;\n  padding: 4px 0;\n  display: flex;\n\n  transition: clip-path 0.1s linear;\n  will-change: clip-path;\n\n  & > div {\n    border-radius: 0;\n    clip-path: polygon(\n      calc(0% + ",
        "px) 0%,\n      100% 0%,\n      calc(100% - ",
        "px) 100%,\n      0% 100%\n    );\n\n    :last-child {\n      border-radius: 0 4px 4px 0;\n      clip-path: polygon(\n        calc(0% + ",
        "px) 0%,\n        100% 0%,\n        100% 100%,\n        0% 100%\n      );\n    }\n\n    :first-child {\n      border-radius: 4px 0 0 4px;\n      clip-path: polygon(\n        0% 0%,\n        100% 0%,\n        calc(100% - ",
        "px) 100%,\n        0% 100%\n      );\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "%;\n  background-color: ",
        ";\n  height: 4px;\n  transition: 0.15s background-color ease-out;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ac9da2e-0"
})(_templateObject());
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ac9da2e-1"
})(_templateObject1());
var SliderTrack = (0,styled_components_browser_esm/* default */.ZP)(Slider/* default */.Z).withConfig({
    componentId: "sc-4ac9da2e-2"
})(_templateObject2());
var TrackWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ac9da2e-3"
})(_templateObject3(), function(param) {
    var cutSize = param.cutSize;
    return cutSize;
}, function(param) {
    var cutSize = param.cutSize;
    return cutSize;
}, function(param) {
    var cutSize = param.cutSize;
    return cutSize;
}, function(param) {
    var cutSize = param.cutSize;
    return cutSize;
});
var Track = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ac9da2e-4"
})(_templateObject4(), function(param) {
    var _width = param.width, width = _width === void 0 ? 100 : _width;
    return width;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});

;// CONCATENATED MODULE: ./src/global/Securities/components/Slider/index.tsx





var Slider_Slider = function(_param) {
    var _tracksWidth = _param.tracksWidth, tracksWidth = _tracksWidth === void 0 ? [] : _tracksWidth, _tracksColor = _param.tracksColor, tracksColor = _tracksColor === void 0 ? [
        "#00AB6B",
        "#8277F8"
    ] : _tracksColor, defaultValue = _param.defaultValue, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "tracksWidth",
        "tracksColor",
        "defaultValue",
        "onChange"
    ]);
    var ref = (0,react.useState)(defaultValue), clipValue = ref[0], setClipValue = ref[1];
    var isControlled = typeof props.value !== "undefined";
    var sliderValue = isControlled ? props.value : clipValue;
    var getLimitNumber = function(value) {
        var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
        return Math.min(Math.max(value, min), max);
    };
    var clipWidth = (0,react.useMemo)(function() {
        var maxSliderValue = props.max || 100;
        var clipPercentage = sliderValue / maxSliderValue * 100;
        // Based on 100% css clip-path width - clipPercentage
        var width = 100 - getLimitNumber(clipPercentage);
        return width || 0;
    }, [
        sliderValue,
        props.max
    ]);
    var handleValueChange = function(value) {
        setClipValue(value);
        onChange(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderTrack, (0,_object_spread/* default */.Z)({
                    onChange: handleValueChange,
                    tooltipVisible: false,
                    defaultValue: defaultValue
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackWrapper, {
                    style: {
                        clipPath: "polygon(0% 0%, calc(100% - ".concat(clipWidth, "%) 0%, calc(100% - ").concat(clipWidth, "%) 100%, 0% 100%)")
                    },
                    cutSize: 2,
                    children: tracksWidth.length > 0 ? tracksWidth.map(function(width, idx) {
                        return width > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                            width: width,
                            backgroundColor: tracksColor[idx] || "#00AB6B"
                        }, idx.toString());
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                        backgroundColor: "#00AB6B"
                    }, "tracks")
                })
            ]
        })
    });
};
/* harmony default export */ var components_Slider = (Slider_Slider);


/***/ }),

/***/ 32293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useOrderbookCompanies; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/features/orderbook/utils.ts
var utils = __webpack_require__(51346);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/exodus.ts
var exodus = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/global/Securities/api/orderbook.ts


var getOrderbookCompanies = function(symbol) {
    return exodus/* exodusApiInstance.defaultInstance.get */.l.defaultInstance.get(apiEndpoint/* orderbookEndpoint.orderbookCompanies */.I6.orderbookCompanies(symbol));
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/useOrderbookCompanies.ts








var initialState = {
    data: {},
    isLoading: false
};
var useOrderbookCompanies = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadOrderbookCompanies: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, data, transformedData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getOrderbookCompanies(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            transformedData = (0,utils/* transformNewOrderbookListToExisting */.M6)(data);
                            set({
                                data: transformedData,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", transformedData);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOrderbookCompanies: function() {
            set({
                data: {}
            });
        },
        setBidOffer: function(param) {
            var bid = param.bid, offer = param.offer;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (bid) {
                    var ref;
                    state.data.bid = (0,_object_spread/* default */.Z)({}, (ref = state.data) === null || ref === void 0 ? void 0 : ref.bid, bid);
                }
                if (offer) {
                    var ref1;
                    state.data.offer = (0,_object_spread/* default */.Z)({}, (ref1 = state.data) === null || ref1 === void 0 ? void 0 : ref1.offer, offer);
                }
            }));
        },
        setHeader: function(livePrice) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.data = (0,_object_spread/* default */.Z)({}, state.data, livePrice);
            }));
        },
        setIepIev: function(payload) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                var ref, ref1, ref2, ref3, ref4;
                state.data.iepiev = payload ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref = state.data) === null || ref === void 0 ? void 0 : ref.iepiev), {
                    iep: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref1 = state.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.iepiev) === null || ref2 === void 0 ? void 0 : ref2.iep), {
                        raw: payload.iep
                    }),
                    iev: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref3 = state.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.iepiev) === null || ref4 === void 0 ? void 0 : ref4.iev), {
                        raw: payload.iev / 100
                    })
                }) : null;
            }));
        },
        setBestBidOffer: function(payload) {
            var bestBid = payload.bestBid, bestOffer = payload.bestOffer;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (bestBid) {
                    var ref, ref1, ref2;
                    state.data.iepiev = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref = state.data) === null || ref === void 0 ? void 0 : ref.iepiev), {
                        best_bid_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref1 = state.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.iepiev) === null || ref2 === void 0 ? void 0 : ref2.best_bid_offer), {
                            bid: bestBid
                        })
                    });
                }
                if (bestOffer) {
                    var ref3, ref4, ref5;
                    state.data.iepiev = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref3 = state.data) === null || ref3 === void 0 ? void 0 : ref3.iepiev), {
                        best_bid_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref4 = state.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.iepiev) === null || ref5 === void 0 ? void 0 : ref5.best_bid_offer), {
                            offer: bestOffer
                        })
                    });
                }
            }));
        }
    });
});
/* harmony default export */ var stores_useOrderbookCompanies = (useOrderbookCompanies);


/***/ }),

/***/ 52595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20539);
/* harmony import */ var hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47002);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29658);
/* harmony import */ var lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91154);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62974);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36902);
/* harmony import */ var global_TradingModal_components_NumberInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93951);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29097);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45605);
/* harmony import */ var global_Securities_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2941);
/* harmony import */ var _components_FormItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27892);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51520);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53616);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61227);


















function FormExercise(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), getCashOnHand = ref.getCashOnHand, cashOnHand = ref.cashOnHand, company = ref.company, _configFormula = ref.configFormula, formula = _configFormula.data.formula;
    var symbol = company.data.symbol;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getCashOnHand();
    }, []);
    var getPortfolioDetail = (0,hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(symbol);
    var exercise_data = getPortfolioDetail.exercise_data, stock_on_hand = getPortfolioDetail.stock_on_hand;
    var price = exercise_data.price;
    var available_cash_on_hand = cashOnHand.data.available_cash_on_hand;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(), shares = ref.shares, setShares = ref.setShares;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used by eval
    var PRICE = price;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used by eval
    var LOT = shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_10__/* .lotSize */ .CQ;
    // eslint-disable-next-line no-eval -- formula passed from the server
    var exerciseAmount = eval(formula.buy_amount_invested);
    var exceedCashOnHand = exerciseAmount > available_cash_on_hand;
    var disableSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return shares < 1 || exceedCashOnHand;
    }, [
        shares,
        exceedCashOnHand
    ]);
    var exerciseWarningText = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "Order Exercise yang sudah disubmit tidak dapat dibatalkan. Setelah exercise berhasil dilakukan, kamu hanya bisa menjual di pasar reguler dalam satuan lot ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: "(1 lot = 100 lembar)."
            })
        ]
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (exceedCashOnHand) {
            (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__/* .clevertapExerciseError */ .sW)();
        }
    }, [
        exceedCashOnHand
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setShares(stock_on_hand);
    }, [
        stock_on_hand
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__/* .clevertapExerciseViewed */ .LF)({
            symbol: symbol,
            share: stock_on_hand
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                style: {
                    background: "#fcf6ff",
                    borderRadius: 4
                },
                // @ts-expect-error
                p: "8px 12px",
                mb: "16px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    children: exerciseWarningText
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_12__/* .FormExerciseFieldWrapper */ .hn, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        label: "Cash on Hand",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            family: "bold",
                            children: (0,global_Securities_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_15__/* .getFormattedCurrency */ .c)(available_cash_on_hand, {
                                currencyPrefix: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        label: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_14__/* .Slider */ .iR, {
                                    min: 0,
                                    max: stock_on_hand,
                                    value: shares,
                                    tipFormatter: null,
                                    onChange: function(s) {
                                        return setShares(s);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    ml: "5px",
                                    width: "80px",
                                    children: (0,utils_number__WEBPACK_IMPORTED_MODULE_7__/* .formatPercentage */ .rl)(shares / stock_on_hand * 100, false)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        label: "Exercised Amount",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            family: "bold",
                            children: [
                                "Rp ",
                                (0,utils_number__WEBPACK_IMPORTED_MODULE_7__/* .formatNumber */ .uf)(exerciseAmount, false)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        label: "Exercised Price",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            family: "bold",
                            children: [
                                "Rp ",
                                (0,utils_number__WEBPACK_IMPORTED_MODULE_7__/* .formatNumber */ .uf)(price, false)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        label: "Shares Exercised",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_TradingModal_components_NumberInput__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            defaultValue: stock_on_hand,
                            value: shares,
                            min: 0,
                            max: stock_on_hand,
                            step: 1,
                            onChange: function(s) {
                                return setShares(s);
                            },
                            onInput: function(e) {
                                (e === "" || null) && setShares(0);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                condition: exceedCashOnHand,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_12__/* .ErrorBox */ .Tv, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            style: {
                                color: "#ee4a49",
                                marginRight: 7
                            }
                        }),
                        "Nilai exercise kamu melebihi cash on hand yang kamu miliki."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                disabled: disableSubmit,
                onClick: function() {
                    (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_6__/* .clevertapExerciseSelected */ .Uj)({
                        symbol: symbol,
                        share: shares,
                        stockOnHandPercentage: shares / stock_on_hand * 100
                    });
                    onSubmit();
                },
                type: "primary",
                radius: "4px",
                block: true,
                height: "40px",
                // @ts-expect-error
                py: "12px",
                px: "24px",
                style: {
                    position: "absolute",
                    left: 0,
                    bottom: -36,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    align: "inherit",
                    color: "inherit",
                    family: "bold",
                    size: "18px",
                    children: "Exercise"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormExercise);


/***/ }),

/***/ 51520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ SpecialMonitoringModalContainer; },
/* harmony export */   "Jn": function() { return /* binding */ SpecialMonitoringButton; },
/* harmony export */   "RP": function() { return /* binding */ BalanceButton; },
/* harmony export */   "Tv": function() { return /* binding */ ErrorBox; },
/* harmony export */   "V$": function() { return /* binding */ FieldsWrapper; },
/* harmony export */   "_C": function() { return /* binding */ BuySellPortal; },
/* harmony export */   "a": function() { return /* binding */ TransactionModalWrapper; },
/* harmony export */   "f$": function() { return /* binding */ ItemWrapper; },
/* harmony export */   "fx": function() { return /* binding */ SliderPercentText; },
/* harmony export */   "hn": function() { return /* binding */ FormExerciseFieldWrapper; },
/* harmony export */   "p7": function() { return /* binding */ SelectForm; },
/* harmony export */   "vQ": function() { return /* binding */ TransactionForm; }
/* harmony export */ });
/* unused harmony export HeaderWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92961);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71230);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86123);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #f7aead;\n  background-color: #fef6f6;\n  align-items: center;\n  margin-top: 32px;\n  color: #333333;\n\n  .icon {\n    position: relative;\n    display: inline-block;\n    color: #ee4a49;\n    background: #fff;\n    border: 1px solid #ee4a49;\n    border-radius: 50%;\n    width: 14px;\n    height: 14px;\n    margin-right: 5px;\n    margin-bottom: 2px;\n\n    &::before {\n      position: absolute;\n      content: 'i';\n      left: 42%;\n      font-size: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-close {\n    margin-top: 24px;\n    margin-right: 14px;\n  }\n\n  .special-monitoring__content {\n    height: 560px;\n    overflow-y: scroll;\n    position: relative;\n    padding: 0 30px 30px;\n\n    &::-webkit-scrollbar {\n      width: 0;\n    }\n\n    & .special-monitoring__card {\n      border: 1px solid ",
        ";\n      border-radius: 4px;\n      margin-top: 20px;\n\n      &:first-child {\n        margin-top: 0;\n      }\n\n      & .special-monitoring__header {\n        padding: 16px 20px;\n        border-bottom: 1px solid ",
        ";\n      }\n\n      & .special-monitoring__body {\n        padding: 16px 20px;\n\n        & ul {\n          padding-inline-start: 24px;\n\n          & li {\n            margin-bottom: 20px;\n\n            &::marker {\n              color: ",
        ";\n            }\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n          }\n        }\n\n        & .special-monitoring__session-container {\n          margin-top: 20px;\n\n          & p {\n            margin-bottom: 8px;\n          }\n\n          & .special-monitoring__session-item {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -55px;\n  width: 100%;\n\n  :disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #bcbcbc;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: 5px;\n  width: 40px;\n  white-space: nowrap;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > div {\n    padding: 16px 0;\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  padding: 0;\n\n  & > span {\n    margin-left: 6px;\n  }\n\n  &:disabled {\n    cursor: unset;\n  }\n\n  .multiplier-chip {\n    font-size: 14px;\n    line-height: 19px;\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 8px;\n    margin-left: 4px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 40px;\n\n  & div.ant-form-item-explain {\n    width: calc(100% + 40px);\n  }\n\n  & div.ant-form-item-control {\n    max-width: 160px;\n  }\n\n  & .slider-form-item div.ant-form-item-control {\n    max-width: unset;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > div.ant-form-item {\n    margin-bottom: 20px;\n\n    :last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n\n  & > span {\n    display: inline-flex;\n    color: #00ab6b;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: bold;\n  width: 100%;\n\n  &.hide-icon ",
        " span {\n    display: none;\n  }\n\n  .ant-select-arrow {\n    width: 20px;\n    height: 20px;\n    top: 40%;\n    right: 8px;\n\n    svg {\n      display: none;\n    }\n\n    .anticon {\n      width: 20px;\n      height: 20px;\n      background: url('",
        "/icon/chevron/chevron-down.svg');\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n\n  padding-right: 36px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div {\n    z-index: 9999 !important;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-auto-columns: 1fr;\n  grid-template-columns: ",
        ";\n  gap: 0px 30px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}







// eslint-disable-next-line import/prefer-default-export
var ErrorBox = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4af7c9b5-0"
})(_templateObject());
var SpecialMonitoringModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4af7c9b5-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highempahis */ .Z.highempahis);
var SpecialMonitoringButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4af7c9b5-2"
})(_templateObject2());
var SliderPercentText = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4af7c9b5-3"
})(_templateObject3());
var FormExerciseFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4af7c9b5-4"
})(_templateObject4());
var BalanceButton = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-4af7c9b5-5"
})(_templateObject5());
var TransactionForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4af7c9b5-6"
})(_templateObject6());
var FieldsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4af7c9b5-7"
})(_templateObject7());
var ItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4af7c9b5-8"
})(_templateObject8());
var SelectForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4af7c9b5-9"
})(_templateObject9(), ItemWrapper, constants_app__WEBPACK_IMPORTED_MODULE_5__/* .assetPrefix */ .Vc);
var HeaderWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4af7c9b5-10"
})(_templateObject10());
var BuySellPortal = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4af7c9b5-11"
})(_templateObject11());
var TransactionModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4af7c9b5-12"
})(_templateObject12(), function(param) {
    var showOrderbook = param.showOrderbook;
    return showOrderbook ? "330px 480px" : "480px";
});


/***/ }),

/***/ 55039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jg": function() { return /* binding */ generateTradingVariable; },
/* harmony export */   "KK": function() { return /* binding */ checkIsAutoOrderTncAgreed; },
/* harmony export */   "xl": function() { return /* binding */ calculateLotAmendTransaction; }
/* harmony export */ });
/* unused harmony export getInvestmentFee */
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83153);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29097);
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable no-unused-vars */ /* eslint-disable no-eval */ 


var calculateLotAmendTransaction = function(previous_buy_price, previous_lot, price, lot) {
    // Prevent user increase lot with previous trade price
    // updating to use calculation procedure based on legacy
    // https://gitlab.com/stockbitgroup/stockbit/web/web/-/blob/staging/app/routes/securities/component/trade/ModalBuy.js#L351
    if (price === previous_buy_price && lot > previous_lot) {
        return previous_lot;
    }
    return lot;
};
var calculateInitialTradingBalance = function(stock_type, order_type, cash_on_hand, trading_balance, cash_onhand_amended, trading_balance_amended) {
    var isDayTrade = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    if (stock_type.toLowerCase() === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_TYPE.right */ .L2.right) {
        return order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY ? cash_onhand_amended : cash_on_hand;
    }
    if (order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY && isDayTrade) {
        return trading_balance;
    }
    return order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY ? trading_balance_amended : trading_balance;
};
// eslint-disable-next-line import/prefer-default-export
var generateTradingVariable = function(param) {
    var configFormula = param.configFormula, cash_on_hand = param.cash_on_hand, trading_balance = param.trading_balance, price = param.price, lot = param.lot, trigger_price = param.trigger_price, config_type = param.config_type, order_type = param.order_type, previous_buy_price = param.previous_buy_price, previous_lot = param.previous_lot, stock_type = param.stock_type, trading_balance_amended = param.trading_balance_amended, cash_onhand_amended = param.cash_onhand_amended, _isDayTrade = param.isDayTrade, isDayTrade = _isDayTrade === void 0 ? false : _isDayTrade;
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        var _formula = configFormula.formula, fee_buy = _formula.fee_buy, fee_buy_day_trade = _formula.fee_buy_day_trade, buy_amount_invested = _formula.buy_amount_invested, buy_amount_invested_fee = _formula.buy_amount_invested_fee, buy_amount_fee = _formula.buy_amount_fee, buy_amount_broker_fee = _formula.buy_amount_broker_fee, buy_amount_exchange_fee = _formula.buy_amount_exchange_fee, preview_fee = configFormula.preview_fee, day_trade = configFormula.day_trade;
        var ref = isDayTrade ? day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee : preview_fee, broker_fee = ref.broker_fee, exchange = ref.exchange;
        var PRICE = Number(price);
        var LOT = Math.round(Number(lot));
        var TRIGGER_PRICE = Number(trigger_price);
        var CONFIG_TYPE = Number(config_type);
        if (order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY) {
            LOT = calculateLotAmendTransaction(previous_buy_price, previous_lot, PRICE, LOT);
        }
        var FEE_BUY = isDayTrade ? Number(fee_buy_day_trade) : Number(fee_buy);
        var BROKER_FEE = Number(broker_fee);
        var EXCHANGE_FEE_TOTAL_BUY = Number(exchange.exchange_fee_total_buy);
        // if the source of eval script comes from controlled env (e.g. backend),
        // its relatively safe to use eval (https://stackoverflow.com/a/23175542)
        // so I add nosemgrep, to surprass nosemgrep
        var BUY_AMOUNT = eval(buy_amount_invested); // nosemgrep
        var BUY_AMOUNT_FEE = eval(buy_amount_invested_fee); // nosemgrep
        var BUY_FEE = eval(buy_amount_fee); // nosemgrep
        var STOCKBIT_FEE = eval(buy_amount_broker_fee); // nosemgrep
        var EXCHANGE_FEE = eval(buy_amount_exchange_fee); // nosemgrep
        var TRADING_BALANCE = calculateInitialTradingBalance(stock_type, order_type, cash_on_hand, trading_balance, cash_onhand_amended, trading_balance_amended, isDayTrade);
        var BUY_PRICE_WITH_FEE = (PRICE * FEE_BUY + PRICE) * global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_2__/* .lotSize */ .CQ;
        var LIMIT_LOT = Math.floor(TRADING_BALANCE / BUY_PRICE_WITH_FEE);
        return {
            TRADING_BALANCE: TRADING_BALANCE,
            BUY_AMOUNT_FEE: BUY_AMOUNT_FEE,
            BUY_AMOUNT: BUY_AMOUNT,
            PRICE: PRICE,
            BUY_FEE: BUY_FEE,
            STOCKBIT_FEE: STOCKBIT_FEE,
            EXCHANGE_FEE: EXCHANGE_FEE,
            LOT: LOT,
            LIMIT_LOT: LIMIT_LOT,
            TRIGGER_PRICE: TRIGGER_PRICE,
            CONFIG_TYPE: CONFIG_TYPE
        };
    }
    return null;
};
// eslint-disable-next-line import/prefer-default-export
var getInvestmentFee = function(param) {
    var configFormula = param.configFormula, price = param.price, lot = param.lot;
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        var _formula = configFormula.formula, fee_buy = _formula.fee_buy, buy_amount_invested_fee = _formula.buy_amount_invested_fee;
        var PRICE = Number(price);
        var LOT = Math.round(Number(lot));
        var FEE_BUY = Number(fee_buy);
        // if the source of eval script comes from controlled env (e.g. backend),
        // its relatively safe to use eval (https://stackoverflow.com/a/23175542)
        // so I add nosemgrep, to surprass nosemgrep
        var BUY_AMOUNT_FEE = eval(buy_amount_invested_fee); // nosemgrep
        return BUY_AMOUNT_FEE;
    }
    return 0;
};
var checkIsAutoOrderTncAgreed = function(userName, autoOrderType) {
    var logTnc = JSON.parse(localStorage.getItem("logTnc"));
    if (!logTnc) return false;
    var usernameFound = logTnc.find(function(item) {
        return item.username === userName && item.product === autoOrderType;
    });
    if (usernameFound) return true;
    return false;
};


/***/ }),

/***/ 98203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TradingModal_RealTradingModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/global/Securities/types/autoOrder.ts
var types_autoOrder = __webpack_require__(48453);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts
var useTermsAndConditionStore = __webpack_require__(24383);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/features/transaction/useTradingStore.ts
var useTradingStore = __webpack_require__(93918);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 1 modules
var BaseSecuritiesModal = __webpack_require__(48871);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/TradingLimitTncModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  margin-top: 20px;\n  box-sizing: border-box;\n  min-height: 408px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 408px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9f83084-0"
})(_templateObject());
var AgreementWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9f83084-1"
})(_templateObject1());
var AgreementLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-b9f83084-2"
})(_templateObject2());
var TnCFrameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9f83084-3"
})(_templateObject3());
var TnCFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-b9f83084-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/TradingLimitTncModal/index.tsx
















var TradingLimitTncModal = function(_param) {
    var _title = _param.title, title = _title === void 0 ? "Syarat & Ketentuan" : _title, _checkboxText = _param.checkboxText, checkboxText = _checkboxText === void 0 ? "Saya menyetujui Syarat & Ketentuan Penggunaan Trading Limit di atas." : _checkboxText, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "checkboxText",
        "onSubmit"
    ]);
    var FEATURE_ID = termsAndCondition/* TnCFeatureIDEnum.FEATURE_TRADING_LIMIT */.hO.FEATURE_TRADING_LIMIT;
    var ref = (0,react.useState)(false), tncAgreed = ref[0], setTncAgreed = ref[1];
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var isSubmitting = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.isSubmitting;
    });
    var contents = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.contents;
    });
    var postAcceptance = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.postAcceptance;
    });
    var onSubmitTradingLimitTnC = (0,useTradingStore/* default */.Z)(function(s) {
        return s.onSubmitTradingLimitTnC;
    });
    var handleCheckboxChange = function(event) {
        setTncAgreed(event.target.checked);
    };
    var handleTncSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tradingLimitContents, _acceptanceLetters, content;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (tncAgreed) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        tradingLimitContents = contents[FEATURE_ID];
                        _acceptanceLetters = (0,_sliced_to_array/* default */.Z)(tradingLimitContents.acceptanceLetters, 1), content = _acceptanceLetters[0];
                        _ctx.next = 6;
                        return postAcceptance(FEATURE_ID, content.version);
                    case 6:
                        setUIValue("tradingLimitTnc", true);
                        setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit);
                        onSubmitTradingLimitTnC === null || onSubmitTradingLimitTnC === void 0 ? void 0 : onSubmitTradingLimitTnC();
                        onSubmit();
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTncSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var iframeSrc = "";
    if (contents && contents[FEATURE_ID]) {
        var tradingLimitContents = contents[FEATURE_ID];
        var _acceptanceLetters = (0,_sliced_to_array/* default */.Z)(tradingLimitContents.acceptanceLetters, 1), content = _acceptanceLetters[0];
        iframeSrc = "".concat(content.url);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        submitText: "Lanjut",
        submitProps: {
            disabled: !tncAgreed,
            loading: isSubmitting
        },
        onSubmit: handleTncSubmit
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrameWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                        title: "trading-limit-tnc",
                        src: iframeSrc
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        onChange: handleCheckboxChange,
                        children: checkboxText
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Modal_TradingLimitTncModal = (TradingLimitTncModal);

// EXTERNAL MODULE: ./src/features/day-trade/components/Modals/index.ts + 17 modules
var Modals = __webpack_require__(12104);
;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/SplitOrderInfoModal/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-body {\n    padding: 40px;\n\n    & > div,\n    & > p {\n      margin-bottom: 16px;\n\n      :last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  & .ant-modal-close-x {\n    margin-top: 22px;\n    margin-right: 20px;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > p {\n    margin: 0 0 4px;\n\n    :last-child {\n      margin: 0;\n    }\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 14px;\n  font-weight: ",
        ";\n  line-height: 19px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components_browser_esm/* default */.ZP)(BaseSecuritiesModal/* default */.Z).withConfig({
    componentId: "sc-c603f783-0"
})(styled_templateObject());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c603f783-1"
})(styled_templateObject1());
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c603f783-2"
})(styled_templateObject2(), function(param) {
    var _weight = param.weight, weight = _weight === void 0 ? "normal" : _weight;
    return weight;
});

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/SplitOrderInfoModal/constants.ts
var SPLIT_ORDER_MODAL_CONTENT = {
    DEFAULT: [
        {
            title: "Split Quantity",
            description: "The number of divided (smaller) orders your order will be split into."
        },
        {
            title: "Split Range Lot",
            description: "Sets the min and max lot size for each split order."
        }, 
    ],
    SPLIT_METHOD: [
        {
            title: "Random",
            description: "Sets the min and max lot size for each split order. Should not exceed original lot size."
        },
        {
            title: "Equal",
            description: "The number of divided (smaller) orders your order will be split into. Should not exceed original lot size."
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/SplitOrderInfoModal/index.tsx






var SplitOrderInfoModal = function(_param) /*#__PURE__*/ {
    var _title = _param.title, title = _title === void 0 ? "Split Order" : _title, _description = _param.description, description = _description === void 0 ? "Split your order into multiple smaller orders for better trading strategy management." : _description, _info = _param.info, info = _info === void 0 ? SPLIT_ORDER_MODAL_CONTENT.DEFAULT : _info, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "info"
    ]);
    return (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        hideSubmit: true
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: description
            }),
            info.map(function(infoItem, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            weight: "700",
                            children: infoItem.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            children: infoItem.description
                        })
                    ]
                }, idx.toString());
            })
        ]
    }));
};
/* harmony default export */ var Modal_SplitOrderInfoModal = (SplitOrderInfoModal);

// EXTERNAL MODULE: ./src/global/Securities/stores/useTradingInfoStore.ts + 1 modules
var useTradingInfoStore = __webpack_require__(21734);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var types_trading = __webpack_require__(6421);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTransactionFormStore.ts
var useTransactionFormStore = __webpack_require__(52870);
// EXTERNAL MODULE: ./src/typings/transactionForm.ts
var transactionForm = __webpack_require__(93134);
// EXTERNAL MODULE: ./src/global/GlobalModalManager/stores/useGlobalModalStore.ts
var useGlobalModalStore = __webpack_require__(14467);
// EXTERNAL MODULE: ./src/global/GlobalModalManager/types/index.ts
var types = __webpack_require__(30682);
// EXTERNAL MODULE: ./src/features/fast-order/stores/useFastOrderStore.ts
var useFastOrderStore = __webpack_require__(5562);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useSyariah.ts
var useSyariah = __webpack_require__(47060);
// EXTERNAL MODULE: ./src/hooks/useGetPortfolioData.ts
var useGetPortfolioData = __webpack_require__(47002);
// EXTERNAL MODULE: ./src/lib/flipt/hooks/index.ts + 1 modules
var hooks = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./src/features/trade/components/AutoOrder/index.tsx + 3 modules
var AutoOrder = __webpack_require__(19382);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderDetailStore.ts
var useOrderDetailStore = __webpack_require__(87127);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var common_Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var common_Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/styled.ts
var styled = __webpack_require__(61227);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/OrderTypeModal.tsx







var limitOrderDesc = "adalah perintah untuk membeli saham pada harga tertentu sesuai harga yang telah kamu tentukan.";
var autoBuyDesc = "adalah perintah untuk membeli saham dengan kondisi <i>(Trigger Price)</i> yang sudah kamu tentukan. Jika kondisi harga saham terpenuhi, maka order beli akan dikirim secara otomatis";
function OrderTypeModal(param) {
    var visible = param.visible, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Modal/* default */.Z, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "20px",
                align: "center",
                family: "bold",
                padding: "15px",
                children: "Order Type"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TabWrapper */.UE, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Tabs */.mQ, {
                    defaultActiveKey: "1",
                    centered: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TabPane */.Jm, {
                            tab: "Limit Order",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                padding: "15px",
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/img/limit-order.svg",
                                        alt: "limit-order"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                        family: "bold",
                                        my: "15px",
                                        children: [
                                            "Limit Order",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                style: {
                                                    display: "inline"
                                                },
                                                children: limitOrderDesc
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "1"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TabPane */.Jm, {
                            tab: "Auto Buy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                padding: "20px",
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/img/auto-buy.svg",
                                        alt: "limit-order"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                        family: "bold",
                                        my: "15px",
                                        children: [
                                            "Auto Buy",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                style: {
                                                    display: "inline"
                                                },
                                                children: (0,html_react_parser/* default */.ZP)(autoBuyDesc)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "2")
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var TransactionModal_OrderTypeModal = (OrderTypeModal);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/utils/securities/analytics.ts
var analytics = __webpack_require__(67600);
// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/lib/stores/tradingOperation.ts + 1 modules
var tradingOperation = __webpack_require__(31532);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var TradingModal_store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var TradingModal_styled = __webpack_require__(76805);
// EXTERNAL MODULE: ./src/global/Securities/constants/transactionForm.ts
var constants_transactionForm = __webpack_require__(9657);
// EXTERNAL MODULE: ./src/stores/sharetrade/useShareTradeShare.ts
var useShareTradeShare = __webpack_require__(75774);
// EXTERNAL MODULE: ./src/typings/api/shareTradeShare.ts
var shareTradeShare = __webpack_require__(10529);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
// EXTERNAL MODULE: ./src/features/day-trade/utils/formater.ts
var formater = __webpack_require__(22733);
// EXTERNAL MODULE: ./src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(34400);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/global/Securities/components/Table/SplitLotRow/styled.ts

function SplitLotRow_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    SplitLotRow_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SplitLotRow_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    SplitLotRow_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SplitLotRow_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 12px;\n  width: 100%;\n  flex-direction: column;\n\n  & > div {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 4px;\n\n    &:last-child {\n      margin: 0;\n    }\n\n    & > p {\n      color: #969696;\n    }\n  }\n"
    ]);
    SplitLotRow_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-914dccaa-0"
})(SplitLotRow_styled_templateObject(), function(param) {
    var isSplitOrder = param.isSplitOrder;
    return isSplitOrder ? "#f2f1fe" : "";
});
var TotalLotWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-914dccaa-1"
})(SplitLotRow_styled_templateObject1());
var ListWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-914dccaa-2"
})(SplitLotRow_styled_templateObject2());

;// CONCATENATED MODULE: ./src/global/Securities/components/Table/SplitLotRow/index.tsx







var SplitLotRow = function(param) {
    var _lot = param.lot, lot = _lot === void 0 ? 0 : _lot, disabled = param.disabled;
    var splittedLot = (0,react.useMemo)(function() {
        if (lot <= trading/* SPLIT_ORDER_LOT */.pr) return [];
        var splitLength = Math.floor(lot / trading/* SPLIT_ORDER_LOT */.pr);
        var leftOver = lot - trading/* SPLIT_ORDER_LOT */.pr * splitLength;
        var leftOverArray = leftOver > 0 ? [
            {
                start: splitLength + 1,
                end: null,
                lot: leftOver
            }
        ] : [];
        return [
            {
                start: 1,
                end: splitLength > 1 ? splitLength : null,
                lot: trading/* SPLIT_ORDER_LOT */.pr
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(leftOverArray));
    }, [
        lot
    ]);
    var isSplitOrder = (0,react.useMemo)(function() {
        return splittedLot.length > 0 && !disabled;
    }, [
        splittedLot
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        "data-cy": "split-order-container",
        isSplitOrder: isSplitOrder,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalLotWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        "data-cy": "lot-label",
                        children: "Lot"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        "data-cy": "lot-value",
                        children: (0,number/* formatNumber */.uf)(lot)
                    })
                ]
            }),
            isSplitOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                children: splittedLot.map(function(param, i) {
                    var start = param.start, end = param.end, lotItemValue = param.lot;
                    return(// eslint-disable-next-line react/no-array-index-key -- no unique id key
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                "data-cy": "list-lot-label-".concat(i),
                                children: [
                                    "Order ",
                                    start,
                                    end ? " - ".concat(end) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                "data-cy": "list-lot-value-".concat(i),
                                children: [
                                    end ? "@" : "",
                                    (0,number/* formatNumber */.uf)(lotItemValue)
                                ]
                            })
                        ]
                    }, "split-lot-row-".concat(i)));
                })
            }) : null
        ]
    });
};
/* harmony default export */ var Table_SplitLotRow = (SplitLotRow);

// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var formula = __webpack_require__(98202);
;// CONCATENATED MODULE: ./src/global/Securities/constants/transaction.ts


var orderMaxLot = 50000;
var orderMaxQuantity = 50;
var _obj;
var SPLIT_ORDER_COPY = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* SplitOrderMethodEnum.UNSPECIFIED */.PH.UNSPECIFIED, "Unspecified"), (0,_define_property/* default */.Z)(_obj, transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL, "Equal"), (0,_define_property/* default */.Z)(_obj, transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM, "Random"), _obj);

// EXTERNAL MODULE: ./src/global/TradingModal/utils/generateFeeData.ts
var generateFeeData = __webpack_require__(54202);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/store.ts
var RealTradingModal_store = __webpack_require__(53616);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/SellPreview.tsx



















var getOrderType = function(type) {
    if (type === "Market") return "Market Order";
    return type || "Limit Order";
};
var SellPreview = function(param) {
    var showExchangeFee = param.showExchangeFee, data = param.data;
    var ref = (0,tradingData/* default */.Z)(), company = ref.company, portfolioDetail = ref.portfolioDetail, _configFormula = ref.configFormula, configFormula = _configFormula.data;
    var price = data.price, shares = data.shares, symbol = data.symbol, isSplitOrderActive = data.isSplitOrderActive, splitQuantity = data.splitQuantity, splitRangeMin = data.splitRangeMin, splitRangeMax = data.splitRangeMax, type = data.type, amendOrderType = data.amendOrderType, gtc = data.gtc, companyType = data.companyType;
    var expiry = constant/* expiryOption */.$r[gtc];
    var isMarket = type === transaction/* SellOrderType.MarketOrder */.qK.MarketOrder;
    var isLimit = type === transaction/* SellOrderType.LimitOrder */.qK.LimitOrder;
    var isDayTrade = data.isDayTrade && isLimit;
    var splitMethod = (0,RealTradingModal_store/* default */.Z)().splitMethod;
    var _data = company.data, productType = _data.type_company;
    var price_average_fee = portfolioDetail.data.price_average_fee;
    var lot = shares / constant/* lotSize */.CQ;
    var isCorporateAction = (0,react.useMemo)(function() {
        return trading/* CorporateActionStockType.includes */.dB.includes(productType.toLowerCase());
    }, [
        productType
    ]);
    var generatedSellData = (0,generateFeeData/* generateSellData */.z)(configFormula, lot, price, price_average_fee, isDayTrade, companyType);
    var brokerFee = generatedSellData.STOCKBIT_FEE, exchangeFee = generatedSellData.TOTAL_EXCHANGE_FEE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewContainer */.VA, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        height: "19px",
                        children: "Stock"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        height: "19px",
                        family: "bold",
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        height: "19px",
                        children: "Order Type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        height: "19px",
                        children: getOrderType(amendOrderType || type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        height: "19px",
                        children: "Expiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        height: "19px",
                        children: isMarket ? "Fill and Kill" : constants_transactionForm/* expiryOptions */.Me[expiry]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SplitLotRow, {
                lot: lot,
                disabled: isSplitOrderActive || !(0,utils/* isRedirectToNewCore */.JI)()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                condition: !isMarket,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            height: "19px",
                            children: "Price"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            height: "19px",
                            children: (0,number/* formatNumber */.uf)(price, false, "0,00", true)
                        })
                    ]
                })
            }),
            isSplitOrderActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                height: "19px",
                                children: "Split Quantity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                height: "19px",
                                children: (0,number/* formatNumber */.uf)(splitQuantity, false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                height: "19px",
                                children: "Split Method"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                height: "19px",
                                children: SPLIT_ORDER_COPY[splitMethod]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                        condition: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    height: "19px",
                                    children: "Split Range Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    height: "19px",
                                    children: "".concat((0,number/* formatNumber */.uf)(splitRangeMin, false), " - ").concat((0,number/* formatNumber */.uf)(splitRangeMax, false))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        height: "19px",
                        children: [
                            isMarket ? "Estimated " : "",
                            "Proceed Amount"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        height: "19px",
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(price * lot * constant/* lotSize */.CQ, false, "0,00", true)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        height: "19px",
                        children: [
                            isMarket ? "Estimated " : "",
                            "Broker Fee"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        height: "19px",
                        children: brokerFee === 0 ? "Free" : "Rp ".concat((0,number/* formatNumber */.uf)(brokerFee, false, "0,00", true))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                    height: "19px",
                                    children: [
                                        isMarket ? "Estimated " : "",
                                        "Exchange Fee"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/information.svg",
                                    alt: "fee-info",
                                    onClick: showExchangeFee,
                                    style: {
                                        marginLeft: "5px",
                                        width: "12px",
                                        cursor: "pointer"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        height: "19px",
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(exchangeFee, false, "0,00", true)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                            height: "19px",
                            family: "bold",
                            children: [
                                isMarket ? "Estimated " : "",
                                "Proceeds (Net Fee)"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        height: "19px",
                        family: "bold",
                        children: [
                            "Rp",
                            " ",
                            (0,number/* formatNumber */.uf)((0,formula/* getSellAmountInvestedFee */.B1)(lot, price, isCorporateAction, isDayTrade), false)
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PreviewOrderModal_SellPreview = (SellPreview);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Securities/stores/useCashInfoStore.ts
var useCashInfoStore = __webpack_require__(11806);
// EXTERNAL MODULE: ./src/global/Securities/components/Chips/index.tsx
var Chips = __webpack_require__(17348);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
;// CONCATENATED MODULE: ./src/assets/customIcon/GreaterThanEqual.tsx

var GreaterThanEqual = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icon/Stockbit/Menu Portfolio/Chevron Right",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group 6356642",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector",
                        d: "M4.5 10L11.5 6L4.5 2",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector_2",
                        d: "M12 14H4",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var customIcon_GreaterThanEqual = (GreaterThanEqual);

;// CONCATENATED MODULE: ./src/assets/customIcon/LessThanEqual.tsx

var LessThanEqual = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Icon/Stockbit/Menu Portfolio/Chevron Right",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group 6356642",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector",
                        d: "M11.5 10L4.5 6L11.5 2",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector_2",
                        d: "M4 14H12",
                        stroke: color,
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var customIcon_LessThanEqual = (LessThanEqual);

;// CONCATENATED MODULE: ./src/global/TradingModal/utils/generateInvestmentBalance.ts
/* eslint-disable no-new-func */ var generateInvestmentBalance = function(configFormula, price, lot) {
    var multiplier = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dayTradeLeverage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    var formula = configFormula.formula, day_trade = configFormula.day_trade;
    var LOT = lot;
    var PRICE = price;
    var DAY_TRADE_LEVERAGE = dayTradeLeverage;
    var totalInvestment = new Function("LOT", "PRICE", "return ".concat(formula.buy_amount_invested, ";"))(LOT, PRICE);
    var PORTION_DEDUCT_TO_TB = day_trade.portion_deduct_to_tb;
    var STOCK_MULTIPLIER = multiplier;
    var dayTradeUnrealized = new Function("LOT", "PRICE", "PORTION_DEDUCT_TO_TB", "STOCK_MULTIPLIER", "return ".concat(formula.day_trade_debt_unrealized, ";"))(LOT, PRICE, PORTION_DEDUCT_TO_TB, STOCK_MULTIPLIER);
    var ORDER_UNREALIZED_DAY_TRADE_DEBT = dayTradeUnrealized;
    var investmentDayTrade = new Function("ORDER_UNREALIZED_DAY_TRADE_DEBT", "DAY_TRADE_LEVERAGE", "const min = Math.min;\n    return ".concat(formula.day_trade_investment_day_trade, ";"))(ORDER_UNREALIZED_DAY_TRADE_DEBT, DAY_TRADE_LEVERAGE);
    var INVESTMENT_DAY_TRADE = investmentDayTrade;
    var investmentTradingBalance = new Function("LOT", "PRICE", "INVESTMENT_DAY_TRADE", "return ".concat(formula.day_trade_investment_portion_tb, ";"))(LOT, PRICE, INVESTMENT_DAY_TRADE);
    return {
        totalInvestment: totalInvestment,
        investmentDayTrade: investmentDayTrade,
        investmentTradingBalance: investmentTradingBalance
    };
};
/* harmony default export */ var utils_generateInvestmentBalance = (generateInvestmentBalance);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/BuyPreview.tsx


























var getType = function(type) {
    if (type === "Auto Buy") return transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy;
    return type;
};
var BuyPreview_getOrderType = function(type) {
    if (type === "Market") return "Market Order";
    if (type === "AutoBuy") return "Limit If Touched";
    return type || "Limit Order";
};
var BuyPreview = function(param) {
    var showExchangeFee = param.showExchangeFee, data = param.data;
    var ref = (0,react.useState)(false), openInvestment = ref[0], setOpenInvestment = ref[1];
    var ref1 = (0,tradingData/* default */.Z)(), _configFormula = ref1.configFormula, configFormula = _configFormula.data;
    var price = data.price, shares = data.shares, triggerPrice = data.triggerPrice, gtc = data.gtc, symbol = data.symbol, isSplitOrderActive = data.isSplitOrderActive, splitQuantity = data.splitQuantity, splitRangeMin = data.splitRangeMin, splitRangeMax = data.splitRangeMax, multiplier = data.multiplier, configType = data.configType;
    var expiry = constant/* expiryOption */.$r[gtc];
    var dayTradeMultiplier = Number(multiplier);
    var type = getType(data.type);
    var amendType = getType(data.amendOrderType);
    var isMarket = type === transaction/* BuyOrderType.MarketOrder */.dY.MarketOrder;
    var isAutoBuy = type === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy;
    var isLimit = type === transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder;
    var isDayTrade = data.isDayTrade && isLimit;
    var splitMethod = (0,RealTradingModal_store/* default */.Z)().splitMethod;
    var dayTradeLeverage = (0,useCashInfoStore/* default */.Z)(function(s) {
        return s.dayTradeLeverage;
    }, shallow/* default */.Z);
    var lot = shares / constant/* lotSize */.CQ;
    var ref2 = (0,generateFeeData/* generateBuyFeeData */.V)(configFormula, lot, price, isDayTrade), investmentPlusFee = ref2.investmentPlusFee, brokerFee = ref2.brokerFee, exchangeFee = ref2.exchangeFee;
    var ref3 = utils_generateInvestmentBalance(configFormula, price, lot, dayTradeMultiplier, dayTradeLeverage), totalInvestment = ref3.totalInvestment, investmentDayTrade = ref3.investmentDayTrade, investmentTradingBalance = ref3.investmentTradingBalance;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewContainer */.VA, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Stock"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        family: "bold",
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Order Type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: BuyPreview_getOrderType(amendType || type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Expiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: isMarket ? "Fill and Kill" : constants_transactionForm/* expiryOptions */.Me[expiry]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                condition: isDayTrade,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            children: "Leverage"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItemRow */.ww, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: Icons/* LightningSvg */.Sf
                                        }),
                                        "".concat(dayTradeMultiplier, "x")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "Day Trade"
                                })
                            ]
                        })
                    ]
                })
            }),
            isAutoBuy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Trigger Price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TriggerPriceInfo */.av, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon",
                                children: configType === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(customIcon_GreaterThanEqual, {
                                    width: 12,
                                    height: 12
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(customIcon_LessThanEqual, {
                                    width: 12,
                                    height: 12
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                children: triggerPrice
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                condition: !isMarket,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                            children: [
                                isAutoBuy && "Limit ",
                                " Price"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            children: (0,number/* formatNumber */.uf)(price, false)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SplitLotRow, {
                lot: lot,
                disabled: isSplitOrderActive || !(0,utils/* isRedirectToNewCore */.JI)()
            }),
            isSplitOrderActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                children: "Split Quantity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                children: (0,number/* formatNumber */.uf)(splitQuantity, false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                children: "Split Method"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                children: SPLIT_ORDER_COPY[splitMethod]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                        condition: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "Split Range Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "".concat((0,number/* formatNumber */.uf)(splitRangeMin, false), " - ").concat((0,number/* formatNumber */.uf)(splitRangeMax, false))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        onClick: function() {
                            if (!isDayTrade) return;
                            setOpenInvestment(!openInvestment);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                children: [
                                    isMarket ? "Estimated " : "",
                                    " Investment"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                condition: isDayTrade,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/chevron-".concat(!openInvestment ? "down" : "up", ".svg"),
                                    alt: "dropdown",
                                    style: {
                                        marginLeft: "5px",
                                        width: "16px",
                                        cursor: "pointer"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(totalInvestment, false)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                condition: isDayTrade && openInvestment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* InvestmentWrapper */.Qi, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* InvestmentDetail */.yH, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                        children: "Trading Balance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                        children: [
                                            "Rp ",
                                            (0,number/* formatNumber */.uf)(investmentTradingBalance, false)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                        children: "Day Trade"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                        children: [
                                            "Rp ",
                                            (0,number/* formatNumber */.uf)(investmentDayTrade, false)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        children: [
                            isMarket ? "Estimated " : "",
                            "Broker Fee"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(brokerFee)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                children: [
                                    isMarket ? "Estimated " : "",
                                    "Exchange Fee"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/information.svg",
                                alt: "fee-info",
                                onClick: showExchangeFee,
                                style: {
                                    marginLeft: "5px",
                                    width: "12px",
                                    cursor: "pointer"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(exchangeFee, false)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                            family: "bold",
                            children: [
                                isMarket ? "Total Estimated " : "",
                                "Investment (Plus Fee)"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        family: "bold",
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(investmentPlusFee)
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PreviewOrderModal_BuyPreview = (BuyPreview);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/ExercisePreview.tsx








function ExercisePreview() {
    var ref = (0,tradingData/* default */.Z)(), company = ref.company, portfolioDetail = ref.portfolioDetail;
    var ref1 = (0,RealTradingModal_store/* default */.Z)(), shares = ref1.shares, expiry = ref1.expiry;
    var symbol = company.data.symbol;
    var exercise_data = portfolioDetail.data.exercise_data;
    var price = exercise_data.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewContainer */.VA, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Stock"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        family: "bold",
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Expiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: constants_transactionForm/* expiryOptions */.Me[expiry]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Exercise Price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: (0,number/* formatNumber */.uf)(price, false)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: "Shares"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: shares
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        family: "bold",
                        children: "Exercise Amount"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                        family: "bold",
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(shares * price, false)
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var PreviewOrderModal_ExercisePreview = (ExercisePreview);

// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/ProfitLoss.tsx








function ProfitLoss(param) {
    var priceAverageFee = param.priceAverageFee, isCorporateAction = param.isCorporateAction;
    var ref = (0,useTradingStore/* default */.Z)(function(s) {
        return s.previewData;
    }), price = ref.price, shares = ref.shares;
    var lot = shares / constant/* lotSize */.CQ;
    var sellAmountInvestedFee = (0,formula/* getSellAmountInvestedFee */.B1)(lot, price, isCorporateAction);
    var buyAmountInvestedAveragePriceFee = (0,formula/* getBuyAmountInvested */.yq)(lot, priceAverageFee);
    var sellProfitLoss = (0,formula/* getProfitLoss */.fY)(sellAmountInvestedFee, buyAmountInvestedAveragePriceFee);
    var sellGain = (0,formula/* getSellGain */.Sd)(sellProfitLoss, buyAmountInvestedAveragePriceFee);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        align: "center",
        justify: "center",
        padding: "16px 20px",
        width: "100%",
        style: {
            border: "1px solid #dadada",
            borderRadius: "5px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justify: "space-between",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    children: "Profit/Loss"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                    color: (0,general/* getColorBasedOnNumber */.pV)(sellProfitLoss),
                    children: [
                        sellProfitLoss > 0 && "+",
                        (0,number/* formatNumber */.uf)(sellProfitLoss, false),
                        " (",
                        sellProfitLoss > 0 && "+",
                        sellGain === Infinity ? "0.0%" : (0,number/* formatPercentage */.rl)(sellGain, false),
                        ")"
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var PreviewOrderModal_ProfitLoss = (ProfitLoss);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/utils.ts + 1 modules
var RealTradingModal_utils = __webpack_require__(67964);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/constants.ts
var buyPreviewTitle = "Buy Order Preview";
var sellPreviewTitle = "Sell Order Preview";
var defaultPreviewModalTitle = "Order Preview";
var previewModalTitle = {
    BUY: buyPreviewTitle,
    AMEND_BUY: buyPreviewTitle,
    VIRTUAL_BUY: buyPreviewTitle,
    VIRTUAL_AMEND_BUY: buyPreviewTitle,
    SELL: sellPreviewTitle,
    VIRTUAL_SELL: sellPreviewTitle,
    AMEND_SELL: sellPreviewTitle,
    VIRTUAL_AMEND_SELL: sellPreviewTitle,
    EXERCISE: defaultPreviewModalTitle,
    BOND: defaultPreviewModalTitle
};

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var RealTradingModal_types = __webpack_require__(20620);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/index.tsx
/* eslint-disable no-console */ 













































var expiryOption = [
    transaction/* Expiry.GoodForDay */.ZM.GoodForDay,
    transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled
];
var PreviewOrderModal_getType = function(type) {
    if (type === "Auto Buy") return transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy;
    return type;
};
var getModalType = function(type) {
    if (type === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy || type === transaction/* AmendSellOrderType.LimitIfTouched */.YQ.LimitIfTouched || type === transaction/* AmendSellOrderType.StopLoss */.YQ.StopLoss || type === transaction/* AmendSellOrderType.TakeProfit */.YQ.TakeProfit) {
        return RealTradingModal_types/* MODAL_TYPE.SMART_ORDER_PLACED */.fG.SMART_ORDER_PLACED;
    }
    return RealTradingModal_types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED;
};
function PreviewOrderModal(param) {
    var visible = param.visible, showExchangeFee = param.showExchangeFee, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var previewData = (0,useTradingStore/* default */.Z)(function(s) {
        return s.previewData;
    });
    var portfolioData = (0,useGetPortfolioData/* default */.Z)(previewData.symbol, true, false, previewData.isDayTrade);
    var ref1 = (0,TradingModal_store/* default */.Z)(function(s) {
        return {
            orderid: s.orderid,
            modalData: s.modalData,
            setModalState: s.setModalState
        };
    }, shallow/* default */.Z), orderid = ref1.orderid, modalData = ref1.modalData, setModalState = ref1.setModalState;
    var ref2 = (0,tradingData/* default */.Z)(function(s) {
        var ref, ref1;
        return {
            exerciseData: (ref = s.exercise) === null || ref === void 0 ? void 0 : ref.data,
            getExercise: s.getExercise,
            productType: (ref1 = s.company.data) === null || ref1 === void 0 ? void 0 : ref1.type_company
        };
    }, shallow/* default */.Z), exerciseData = ref2.exerciseData, getExercise = ref2.getExercise, productType = ref2.productType;
    var ref3 = (0,tradingOperation/* default */.Z)(), postTradeBuy = ref3.postTradeBuy, postDayTradeBuy = ref3.postDayTradeBuy, postSmartOrder = ref3.postSmartOrder, postTradeAmend = ref3.postTradeAmend, postDayTradeAmend = ref3.postDayTradeAmend, postTradeSell = ref3.postTradeSell, postRequestExercise = ref3.postRequestExercise, editSmartOrder = ref3.editSmartOrder, postDayTradeSell = ref3.postDayTradeSell;
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var price = previewData.price, shares = previewData.shares, triggerPrice = previewData.triggerPrice, gtc = previewData.gtc, symbol = previewData.symbol, orderType = previewData.orderType, isSplitOrderActive = previewData.isSplitOrderActive, splitQuantity = previewData.splitQuantity, splitRangeMin = previewData.splitRangeMin, splitRangeMax = previewData.splitRangeMax, multiplier = previewData.multiplier, configType = previewData.configType, companyType = previewData.companyType;
    var type = PreviewOrderModal_getType(previewData.type);
    var amendType = PreviewOrderModal_getType(previewData.amendOrderType);
    var expiry = expiryOption[gtc];
    var dayTradeMultiplier = Number(multiplier);
    var isMarket = type === transaction/* BuyOrderType.MarketOrder */.dY.MarketOrder;
    var isLimit = type === transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder;
    var isDayTrade = previewData.isDayTrade && isLimit;
    var platform_order_type = function() {
        if (isMarket) return transaction/* PlatformOrderTypes.FAK */.F4.FAK;
        if (isLimit) return transaction/* PlatformOrderTypes.LIMIT */.F4.LIMIT;
        return transaction/* PlatformOrderTypes.UNSPECIFIED */.F4.UNSPECIFIED;
    };
    var ref4 = (0,RealTradingModal_store/* default */.Z)(), stockCode = ref4.stockCode, resetOrderData = ref4.resetOrderData, splitMethod = ref4.splitMethod, storeShares = ref4.shares;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.setOrderType,
            s.setExpiry,
            s.setIsDayTrade
        ];
    }, shallow/* default */.Z), 3), setShareOrderType = ref5[0], setShareExpiry = ref5[1], setIsDayTrade = ref5[2];
    var setShareTransactionData = (0,useShareTradeShare/* default */.Z)(function(s) {
        return s.setTransactionData;
    });
    var dayTrade = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return {
            dayTrade: s.dayTrade
        };
    }).dayTrade;
    var isCorporateAction = (0,react.useMemo)(function() {
        return trading/* CorporateActionStockType.includes */.dB.includes(productType === null || productType === void 0 ? void 0 : productType.toLowerCase());
    }, [
        productType
    ]);
    var lot = shares / constant/* lotSize */.CQ;
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY || orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY;
    var isSell = orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isExercise = orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE;
    var onClose = function() {
        (0,autoOrder/* trackAutoBuyConfirmOrderCanceled */._3)(stockCode, trading/* BUY_ORDER_TYPE_TEXT */.x4[type], constants_transactionForm/* expiryOptions */.Me[expiry], triggerPrice, price, shares);
        onCancel();
    };
    var handleSetTransactionData = function(orderId, isBuyOrder) {
        var shareOrderType = isBuyOrder ? shareTradeShare/* ShareOrderType.Buy */.y.Buy : shareTradeShare/* ShareOrderType.Sell */.y.Sell;
        (0,securities/* clevertapOrderConfirmedSuccess */.xh)({
            orderId: orderId,
            orderType: orderType,
            price: price,
            shares: shares,
            symbol: symbol,
            expiry: expiry
        });
        setShareTransactionData({
            order_id: orderId,
            price: price,
            status: shareTradeShare/* ShareOrderStatus.Open */.F.Open,
            symbol: symbol,
            type: shareOrderType,
            order_time: new Date().toISOString(),
            qty: shares,
            total_investment: price * shares
        });
    };
    var submitOrderBuy = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, dayTradeData, result, result1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Set default payment method to Trading Balance
                        setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
                        if (!isDayTrade) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        dayTradeData = {
                            symbol: symbol,
                            price: price,
                            shares: (lot * constant/* lotSize */.CQ).toString(),
                            multiplier: dayTradeMultiplier
                        };
                        _ctx.next = 7;
                        return postDayTradeBuy(dayTradeData);
                    case 7:
                        result = _ctx.sent;
                        handleSetTransactionData((ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.order_id, true);
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 10:
                        _ctx.next = 12;
                        return postTradeBuy((0,_object_spread/* default */.Z)({
                            accountType: "stockbit",
                            orderkey: "W-BUY-".concat(Date.now()),
                            symbol: symbol,
                            price: price,
                            shares: lot * 100,
                            boardtype: "RG",
                            gtc: expiry,
                            platform_order_type: platform_order_type()
                        }, (0,RealTradingModal_utils/* getSplitOrderPayload */.xb)({
                            splitOrderActive: isSplitOrderActive,
                            splitQuantity: splitQuantity,
                            splitRangeMin: splitRangeMin,
                            splitRangeMax: splitRangeMax,
                            splitMethod: splitMethod
                        })));
                    case 12:
                        result1 = _ctx.sent;
                        handleSetTransactionData(result1 === null || result1 === void 0 ? void 0 : (ref = result1.data) === null || ref === void 0 ? void 0 : ref.order_id, true);
                        return _ctx.abrupt("return", Boolean(result1 && !result1.error));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitOrderBuy() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitSmartOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var reqBodyBuy, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        reqBodyBuy = (0,RealTradingModal_utils/* generateStopOrderParams */.qz)(symbol, shares, price, types_trading/* SmartOrderLabel.AB */.D0.AB, companyType, triggerPrice !== null && triggerPrice !== void 0 ? triggerPrice : 0, configType, String(gtc));
                        _ctx.next = 3;
                        return postSmartOrder(reqBodyBuy);
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitSmartOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitAmend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, result, data1, result1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isDayTrade) {
                            _ctx.next = 6;
                            break;
                        }
                        data = {
                            orderid: orderid,
                            price: price,
                            shares: (lot * constant/* lotSize */.CQ).toString(),
                            multiplier: dayTradeMultiplier
                        };
                        _ctx.next = 4;
                        return postDayTradeAmend(data);
                    case 4:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 6:
                        data1 = {
                            price: price,
                            shares: lot * constant/* lotSize */.CQ,
                            order_id: orderid
                        };
                        _ctx.next = 9;
                        return postTradeAmend([
                            data1
                        ]);
                    case 9:
                        result1 = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result1 && !result1.error));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitAmend() {
            return _ref.apply(this, arguments);
        };
    }();
    var editAutoBuy = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var reqBodyAmend, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        reqBodyAmend = (0,RealTradingModal_utils/* generateStopOrderAmendParams */.Sz)(lot * constant/* lotSize */.CQ, price, triggerPrice !== null && triggerPrice !== void 0 ? triggerPrice : 0, configType);
                        _ctx.next = 3;
                        return editSmartOrder(orderid)(reqBodyAmend);
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function editAutoBuy() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitOrderSell = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, result, data, result1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!isDayTrade) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        _ctx.next = 5;
                        return postDayTradeSell({
                            symbol: symbol,
                            price: price,
                            shares: (lot * constant/* lotSize */.CQ).toString()
                        });
                    case 5:
                        result = _ctx.sent;
                        handleSetTransactionData((ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.order_id, false);
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 8:
                        data = (0,_object_spread/* default */.Z)({
                            accountType: "stockbit",
                            orderkey: "W-SELL-".concat(Date.now()),
                            symbol: symbol,
                            price: price,
                            shares: lot * 100,
                            boardtype: "RG",
                            gtc: expiry,
                            platform_order_type: platform_order_type()
                        }, (0,RealTradingModal_utils/* getSplitOrderPayload */.xb)({
                            splitOrderActive: isSplitOrderActive,
                            splitQuantity: splitQuantity,
                            splitRangeMin: splitRangeMin,
                            splitRangeMax: splitRangeMax,
                            splitMethod: splitMethod
                        }));
                        _ctx.next = 11;
                        return postTradeSell(data);
                    case 11:
                        result1 = _ctx.sent;
                        handleSetTransactionData((ref = result1.data) === null || ref === void 0 ? void 0 : ref.order_id, false);
                        return _ctx.abrupt("return", Boolean(result1 && !result1.error));
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitOrderSell() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitRequestExercise = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = {
                            orderKey: "W-EXERCISE-".concat(Date.now()),
                            stockCode: stockCode,
                            shares: storeShares
                        };
                        _ctx.next = 3;
                        return postRequestExercise(data);
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitRequestExercise() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAPIResponse = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(apiCall) {
            var result, isAmend, modalType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return apiCall();
                    case 4:
                        result = _ctx.sent;
                        if (result) {
                            isAmend = orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
                            modalType = getModalType(isAmend ? amendType : type);
                            onSubmit(modalType, isAmend ? previewData.amendOrderType : type);
                            resetOrderData();
                        } else onCancel();
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                    case 11:
                        _ctx.prev = 11;
                        setIsLoading(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function handleAPIResponse(apiCall) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBuyOrderRequest = function() {
        var _obj;
        var buyOrderRequest = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder, submitOrderBuy), (0,_define_property/* default */.Z)(_obj, transaction/* BuyOrderType.MarketOrder */.dY.MarketOrder, submitOrderBuy), (0,_define_property/* default */.Z)(_obj, transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy, submitSmartOrder), _obj);
        setShareExpiry(expiry);
        setShareOrderType(type);
        setIsDayTrade(isDayTrade);
        handleAPIResponse(buyOrderRequest[type] || submitOrderBuy);
    };
    var handleSellOrderRequest = function() {
        var _obj;
        var sellOrderRequest = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* SellOrderType.LimitOrder */.qK.LimitOrder, submitOrderSell), (0,_define_property/* default */.Z)(_obj, transaction/* SellOrderType.MarketOrder */.qK.MarketOrder, submitOrderSell), (0,_define_property/* default */.Z)(_obj, transaction/* SellOrderType.StopLoss */.qK.StopLoss, submitSmartOrder), (0,_define_property/* default */.Z)(_obj, transaction/* SellOrderType.TakeProfit */.qK.TakeProfit, submitSmartOrder), _obj);
        setShareExpiry(expiry);
        setShareOrderType(type);
        setIsDayTrade(isDayTrade);
        handleAPIResponse(sellOrderRequest[type] || submitOrderSell);
    };
    var onConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isAmend;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        (0,autoOrder/* trackAutoBuyOrderConfirmed */.FY)(stockCode, trading/* BUY_ORDER_TYPE_TEXT */.x4[type], constants_transactionForm/* expiryOptions */.Me[expiry], triggerPrice, price, shares);
                        isAmend = orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
                        if (isAmend && type === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) {
                            handleAPIResponse(editAutoBuy);
                        } else if (isAmend) {
                            handleAPIResponse(submitAmend);
                        }
                        if (orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY) {
                            handleBuyOrderRequest();
                        }
                        if (orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL) {
                            handleSellOrderRequest();
                        }
                        if (orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE) {
                            handleAPIResponse(submitRequestExercise);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirm = function() {
        if (isRealTrading) {
            (0,securities/* clevertapOrderConfirmed */.y8)({
                symbol: symbol,
                price: price,
                shares: shares,
                orderType: orderType,
                type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading,
                expiry: constants_transactionForm/* expiryOptions */.Me[expiry],
                orderTypeStatus: (0,analytics/* generateOrderTypeLabel */.JH)(type),
                splitOrder: isSplitOrderActive,
                dayTrade: isDayTrade
            });
        }
        onConfirm();
        if (modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget) {
            setModalState({
                modalData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalData), {
                    openFromWidget: false
                })
            });
        }
    };
    var loadExercisableData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getExercise(symbol);
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        onClose();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function loadExercisableData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (visible) {
            (0,securities/* clevertapOrderPreviewed */.J2)({
                symbol: symbol,
                orderType: orderType
            });
            (0,autoOrder/* trackAutoBuyPreviewOrderView */.jU)();
            if (orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE) loadExercisableData();
        }
    }, [
        symbol,
        visible
    ]);
    var isNeedToRenderInfo = false;
    if (exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.time_server) {
        var timeServer = new Date(exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.time_server);
        var secondsInDay = timeServer.getSeconds() + timeServer.getMinutes() * 60 + timeServer.getHours() * 3600;
        var limitCutOff = 10 * 3600; // 10:00 AM
        isNeedToRenderInfo = secondsInDay > limitCutOff;
    }
    var closeHour = (0,formater/* formatHourMinutes */.d7)(dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_open, dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_close).close;
    (0,useKeyPress/* default */.Z)([
        "Enter"
    ], function() {
        if (visible) handleConfirm();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* PreviewModalContainer */.__, {
        visible: visible,
        closable: false,
        centered: true,
        width: "100%",
        style: {
            maxWidth: 480
        },
        transitionName: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                direction: "column",
                align: "center",
                padding: "40px 20px",
                style: {
                    gap: 16
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        family: "bold",
                        size: "18px",
                        height: "24px",
                        children: previewModalTitle[orderType] || defaultPreviewModalTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        justify: "center",
                        padding: "16px 20px",
                        style: {
                            border: "1px solid #dadada",
                            borderRadius: "5px",
                            width: "100%"
                        },
                        children: [
                            isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_BuyPreview, {
                                showExchangeFee: showExchangeFee,
                                data: previewData
                            }),
                            isSell && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_SellPreview, {
                                showExchangeFee: showExchangeFee,
                                data: previewData
                            }),
                            isExercise && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_ExercisePreview, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isBuy && isDayTrade,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* DayTradeInfoBanner */.hv, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                children: [
                                    "Saham yang dibeli dengan Day Trade akan terjual otomatis hari ini pukul ",
                                    closeHour,
                                    " WIB."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isExercise && isNeedToRenderInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            color: color/* default.highgray */.Z.highgray,
                            align: "center",
                            mt: "15px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "exercise-information",
                                children: [
                                    "Penebusan ini akan diproses ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " di hari bursa berikutnya karena sudah melewati cut-off kami pukul 10:00 WIB."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isSell && !isMarket,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_ProfitLoss, {
                            priceAverageFee: portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.price_average_fee,
                            isCorporateAction: isCorporateAction
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                style: {
                    position: "absolute",
                    bottom: "-60px",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            setIsLoading(false);
                            if (isRealTrading) {
                                (0,securities/* clevertapOrderCanceled */.bQ)({
                                    symbol: symbol,
                                    price: price,
                                    shares: shares,
                                    orderType: orderType,
                                    type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading
                                });
                            }
                            onClose();
                        },
                        type: "secondary",
                        radius: "4px",
                        block: true,
                        height: "44px",
                        style: {
                            width: "49%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            align: "inherit",
                            color: "inherit",
                            family: "bold",
                            size: "14px",
                            height: "19px",
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleConfirm,
                        loading: isLoading,
                        radius: "4px",
                        block: true,
                        height: "44px",
                        style: {
                            width: "49%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            align: "inherit",
                            color: color/* default.primary */.Z.primary,
                            family: "bold",
                            size: "14px",
                            height: "19px",
                            children: "Confirm"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var RealTradingModal_PreviewOrderModal = (PreviewOrderModal);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/ExchangeFeeModal.tsx











function ExchangeFeeModal(param) {
    var visible = param.visible, closeModal = param.closeModal, orderType = param.orderType;
    var companyType = (0,useTradingStore/* default */.Z)(function(s) {
        var ref;
        return (ref = s.previewData) === null || ref === void 0 ? void 0 : ref.companyType;
    });
    var isStockCorporateActions = trading/* CORPORATE_ACTION_STOCK_TYPE.indexOf */.Do.indexOf(companyType.toUpperCase()) > -1;
    var securitiesPreviewFeeData = localStorage.getItem("securitiesPreviewFeeData");
    var securitiesPreviewFeeDataDayTrade = localStorage.getItem("securitiesPreviewFeeDataDayTrade");
    var dayTradeActive = (0,RealTradingModal_store/* default */.Z)().dayTradeActive;
    var previewFeeData = dayTradeActive ? securitiesPreviewFeeDataDayTrade : securitiesPreviewFeeData;
    var ref = JSON.parse(previewFeeData) || {
        exchange: {}
    }, _exchange = ref.exchange, title = _exchange.title, desc = _exchange.desc, subtitle = _exchange.subtitle, compositionsRaw = _exchange.compositions, exchange_fee_total_title = _exchange.exchange_fee_total_title, feeTotalBuy = _exchange.exchange_fee_total_buy, feeTotalSell = _exchange.exchange_fee_total_sell, feeTotalCaSell = _exchange.exchange_fee_total_ca_sell, feeTotalCaBuy = _exchange.exchange_fee_total_ca_buy;
    var compositions = compositionsRaw;
    compositions = isStockCorporateActions ? compositions.filter(function(com) {
        return com.type !== 2;
    }) : compositions;
    var isSell = orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL || orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL;
    (0,react.useEffect)(function() {
        if (visible) (0,securities/* clevertapExchangeFee */.Sv)(orderType);
    }, [
        visible
    ]);
    var exchangeFeeTotal = (0,react.useMemo)(function() {
        // Warrant, ETF, Right
        if (isStockCorporateActions) {
            if (isSell) return feeTotalCaSell;
            return feeTotalCaBuy;
        }
        // Stock
        if (isSell) return feeTotalSell;
        return feeTotalBuy;
    }, [
        isSell,
        feeTotalCaSell,
        feeTotalCaBuy,
        feeTotalSell,
        feeTotalBuy
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Modal/* default */.Z, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        closable: false,
        width: "420px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                style: {
                    position: "absolute",
                    left: "30px",
                    top: "20px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    size: "25px",
                    className: "icon-notification_back",
                    onClick: closeModal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "16px",
                align: "center",
                family: "bold",
                padding: "20px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                padding: "10px 35px 30px 35px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        children: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        mt: "10px",
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        padding: "15px",
                        // @ts-expect-error
                        mt: "10px",
                        width: "100%",
                        style: {
                            border: "1px solid #dadada",
                            borderRadius: "5px"
                        },
                        children: [
                            compositions.map(function(param) {
                                var name = param.name, value = param.value, type = param.type;
                                if (type === 3 || isSell) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* FeeItem */.A5, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                                children: [
                                                    value,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, value);
                                }
                                return null;
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* FeeItem */.A5, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                        family: "bold",
                                        py: "8px",
                                        children: exchange_fee_total_title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                        family: "bold",
                                        children: [
                                            exchangeFeeTotal * 100,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var PreviewOrderModal_ExchangeFeeModal = (ExchangeFeeModal);

// EXTERNAL MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx + 1 modules
var OrderPlacedModal = __webpack_require__(70536);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/AnnouncementModal/index.tsx












function AnnouncementModal(param) {
    var visible = param.visible, orderType = param.orderType, closeModal = param.closeModal, onSubmit = param.onSubmit, showTransactionModal = param.showTransactionModal;
    var isExerciseType = orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE;
    var ref = (0,tradingData/* default */.Z)(), _rightTradeable = ref.rightTradeable, rightData = _rightTradeable.data, _exercise = ref.exercise, exerciseData = _exercise.data;
    var showModal = (0,TradingModal_store/* default */.Z)().showModal;
    var is_tradeable = rightData === null || rightData === void 0 ? void 0 : rightData.is_tradeable;
    var not_tradeable_type;
    var not_tradeable_reason = rightData === null || rightData === void 0 ? void 0 : rightData.message;
    var end_date_exercise;
    var is_exerciseable = true;
    var not_exerciseable_type;
    var not_exerciseable_reason;
    var differentTradeable = (rightData === null || rightData === void 0 ? void 0 : rightData.is_tradeable) && exerciseData && !exerciseData.is_tradeable;
    if (!rightData || differentTradeable) {
        is_tradeable = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.is_tradeable;
        not_tradeable_type = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_tradeable_type;
        not_tradeable_reason = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_tradeable_reason;
    }
    if (exerciseData) {
        is_exerciseable = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.is_exerciseable;
        not_exerciseable_reason = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_exerciseable_reason;
        end_date_exercise = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.end_date_exercise;
        not_exerciseable_type = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_exerciseable_type;
        if (!is_tradeable && !not_tradeable_type) {
            not_tradeable_type = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_tradeable_type;
        }
    }
    var showDates = [
        "MAX_EXERCISE_AT",
        "SELL_RECOMMEND"
    ];
    var announcementType = isExerciseType ? not_exerciseable_type : not_tradeable_type;
    var isOutOfSession = announcementType === "OUT_OF_SESSION";
    var messageReasonToRender = isExerciseType ? not_exerciseable_reason : not_tradeable_reason;
    var handleClick = function() {
        if (announcementType === "SELL_RECOMMEND") {
            showModal({
                orderType: trading/* ORDER_TYPE.SELL */.Jm.SELL
            });
            showTransactionModal();
            return;
        }
        var isExercisable = isExerciseType && is_exerciseable;
        var notExerciseTradeable = !isExerciseType && is_tradeable;
        var notExerciseRightTradable = !isExerciseType && (rightData === null || rightData === void 0 ? void 0 : rightData.is_tradeable) && !isOutOfSession;
        if (isExercisable || notExerciseTradeable || notExerciseRightTradable) {
            showTransactionModal();
            return;
        }
        if (onSubmit) onSubmit();
        else closeModal();
    };
    var broadcast = "/images/broadcast.svg";
    var not_found = "/images/data_not_found.svg";
    var icon = {
        DEFAULT: broadcast,
        OUT_OF_SESSION: not_found
    };
    var titles = {
        OUT_OF_SESSION: "Transaksi Tidak Dapat Dilakukan",
        DEFAULT: "Perhatian"
    };
    var buttons = {
        EXPIRED: "Lanjut",
        MAX_EXERCISE_AT: isExerciseType ? "Oke, Mengerti" : "Lanjut",
        SELL_RECOMMEND: "Sell",
        DEFAULT: "Oke, Mengerti"
    };
    var buttonTypes = {
        SELL_RECOMMEND: "danger",
        DEFAULT: "primary"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Modal/* default */.Z, {
        visible: visible,
        closable: false,
        centered: true,
        width: "375px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                align: "center",
                padding: "30px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: icon[announcementType] || icon.DEFAULT,
                        alt: "Announcement"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        align: "center",
                        family: "bold",
                        size: "16px",
                        my: "16px",
                        children: titles[announcementType] || titles.DEFAULT
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        align: "center",
                        color: color/* default.dimgray */.Z.dimgray,
                        children: (0,html_react_parser/* default */.ZP)(messageReasonToRender || "-")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showDates.includes(announcementType) && end_date_exercise,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            color: "#f5931b",
                            family: "bold",
                            pt: "15px",
                            children: end_date_exercise
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "space-between",
                style: {
                    position: "absolute",
                    bottom: "-50px",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: buttonTypes[announcementType] || buttonTypes.DEFAULT,
                    radius: "4px",
                    block: true,
                    height: "40px",
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        align: "inherit",
                        color: "white",
                        family: "bold",
                        size: "16px",
                        children: buttons[announcementType] || buttons.DEFAULT
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var RealTradingModal_AnnouncementModal = (AnnouncementModal);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/utils.ts
var TransactionModal_utils = __webpack_require__(55039);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/lib/api/smartOrder.ts
var smartOrder = __webpack_require__(59140);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/AutoOrderTncModal.tsx
















var title = "Dengan menggunakan fitur Auto Order, saya menyatakan dan memahami bahwa:";
var checkboxDescription = "Saya menyetujui Syarat & Ketentuan Penggunaan Auto Order di atas.";
var tnc = [
    "Saya mengerti risiko penggunaan fitur Auto Order.",
    "Fitur Auto Order hanya membantu proses otomatisasi dalam bertransaksi. Pemesanan melalui Auto Order adalah sepenuhnya tanggung jawab pengguna, PT. Stockbit Sekuritas Digital tidak bertanggung jawab atas segala kerugian yang mungkin bisa terjadi.",
    "Sistem akan mulai melakukan pengecekan harga pada pukul 09:00:00 WIB.",
    "Proses pembentukan harga pada saat sesi pembukaan dapat mempengaruhi order saya.",
    "Eksekusi Auto Order bergantung pada antrian di bursa dimana ada kemungkinan terjadinya jeda waktu.",
    "Pemesanan melalui Auto Order tidak menjamin akan sesuai dengan harga dan jumlah yang saya harapkan.",
    "Stockbit berhak melakukan penghentian sementara fasilitas automated trading jika terdapat resiko perdagangan yang mungkin timbul untuk menghindari kerugian yang tidak diinginkan", 
];
function AutoOrderTncModal(param) {
    var autoOrderType = param.autoOrderType, visible = param.visible, closeModal = param.closeModal, onAccept = param.onAccept;
    var setOrderType = (0,RealTradingModal_store/* default */.Z)(function(s) {
        return s.setOrderType;
    });
    var setOrderTypeGen = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setOrderType;
    });
    var openFromWidget = (0,useTradingStore/* default */.Z)(function(s) {
        return s.openFromWidget;
    });
    var onSubmitAutoOrderTnC = (0,useTradingStore/* default */.Z)(function(s) {
        return s.onSubmitAutoOrderTnC;
    });
    var setAutoBuy = (0,TradingModal_store/* default */.Z)(function(state) {
        return state.setAutoBuy;
    });
    var ref = (0,react.useState)(false), isTncAgree = ref[0], setTncAgree = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), username = ref1.data.username;
    var saveLogTnc = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, logTnc, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        logTnc = JSON.parse(localStorage.getItem("logTnc")) || [];
                        _ctx.next = 5;
                        return (0,smartOrder/* postSmartOrderTnC */.xB)({
                            product: autoOrderType
                        });
                    case 5:
                        response = _ctx.sent;
                        if (!((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message) !== "success")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        if (!(0,TransactionModal_utils/* checkIsAutoOrderTncAgreed */.KK)(username, autoOrderType)) {
                            logTnc.push({
                                username: username,
                                product: autoOrderType
                            });
                            localStorage.setItem("logTnc", JSON.stringify(logTnc));
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function saveLogTnc() {
            return _ref.apply(this, arguments);
        };
    }();
    var onTncAgreed = function() {
        saveLogTnc();
        if (openFromWidget) {
            setOrderTypeGen(transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy);
        } else setOrderType(transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy);
        setAutoBuy(true);
        if (onSubmitAutoOrderTnC) {
            setTimeout(onSubmitAutoOrderTnC, 200);
        } else onAccept === null || onAccept === void 0 ? void 0 : onAccept();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Modal/* default */.Z, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "20px",
                align: "center",
                family: "bold",
                padding: "15px",
                children: "Syarat & Ketentuan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                padding: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        padding: "20px",
                        style: {
                            border: "1px solid rgb(237, 237, 237)",
                            borderRadius: "5px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                family: "bold",
                                mb: "10px",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                style: {
                                    marginLeft: "-20px"
                                },
                                children: tnc.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                            padding: "5px",
                                            children: item
                                        })
                                    }, item);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Checkbox */.XZ, {
                        onChange: function() {
                            return setTncAgree(!isTncAgree);
                        },
                        style: {
                            marginTop: "15px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            children: checkboxDescription
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AutoBuySubmitButton */.yJ, {
                disabled: !isTncAgree,
                onClick: onTncAgreed,
                type: "primary",
                radius: "4px",
                block: true,
                height: "40px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "inherit",
                    color: "inherit",
                    family: "bold",
                    size: "16px",
                    children: "Submit"
                })
            })
        ]
    });
}
/* harmony default export */ var TransactionModal_AutoOrderTncModal = (AutoOrderTncModal);

// EXTERNAL MODULE: ./src/features/securities/static/information/specialMonitoring/index.tsx + 4 modules
var specialMonitoring = __webpack_require__(13799);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/styled.ts
var TransactionModal_styled = __webpack_require__(51520);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/SpecialMonitoringModal.tsx




var SpecialMonitoringModal = function(param) {
    var visible = param.visible, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* SpecialMonitoringModalContainer */.Ck, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "18px",
                align: "center",
                family: "bold",
                padding: "40px 30px 16px",
                children: "Informasi Pemantauan Khusus"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "special-monitoring__content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_styled/* SpecialMonitoringButton */.Jn, {
                onClick: closeModal,
                type: "primary",
                radius: "4px",
                block: true,
                height: "40px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "inherit",
                    color: "inherit",
                    family: "bold",
                    size: "16px",
                    children: "Oke"
                })
            })
        ]
    });
};
/* harmony default export */ var TransactionModal_SpecialMonitoringModal = (SpecialMonitoringModal);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ShariaUnavailableModal/index.tsx






function ShariaUnavailableModal(param) {
    var visible = param.visible, onClose = param.onClose;
    var handleClick = function() {
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Modal/* default */.Z, {
        visible: visible,
        centered: true,
        width: "500px",
        onCancel: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            direction: "column",
            align: "center",
            padding: "50px 30px 20px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/syariah/unavailable.svg",
                    alt: "Unavailable"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "center",
                    family: "bold",
                    size: "16px",
                    my: "16px",
                    children: "Bukan Saham Syariah"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justify: "center",
                    style: {
                        width: "100%"
                    },
                    mt: "40px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "primary",
                        radius: "4px",
                        block: true,
                        height: "40px",
                        width: "200px",
                        onClick: handleClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            align: "inherit",
                            color: "white",
                            family: "bold",
                            size: "16px",
                            children: "Oke"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var RealTradingModal_ShariaUnavailableModal = (ShariaUnavailableModal);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore.ts
var useBondsModalStore = __webpack_require__(81557);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics.ts
var useBondsAnalytics = __webpack_require__(29735);
// EXTERNAL MODULE: ./src/global/Securities/types/stockType.ts
var stockType = __webpack_require__(56644);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/SpecialMonitoringBanner/styled.ts

function SpecialMonitoringBanner_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 5px 0 10px;\n  padding: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fef4e8;\n  border: 0.5px solid #f5931b;\n  border-radius: 4px;\n  cursor: pointer;\n\n  p {\n    margin-bottom: 0;\n  }\n\n  i {\n    color: #f5931b;\n    font-weight: 700;\n  }\n"
    ]);
    SpecialMonitoringBanner_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SpecialMonitoringBanner_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n\n  .special-monitoring-banner__title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 4px !important;\n\n    & > span {\n      font-size: 12px;\n      line-height: 16px;\n      color: ",
        ";\n    }\n  }\n\n  .special-monitoring-banner__desc {\n    font-size: 12px;\n    line-height: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    SpecialMonitoringBanner_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SpecialMonitoringBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e9ab748-0"
})(SpecialMonitoringBanner_styled_templateObject());
var SpecialMonitoringBannerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e9ab748-1"
})(SpecialMonitoringBanner_styled_templateObject1(), color/* default.highgray */.Z.highgray, color/* default.highempahis */.Z.highempahis);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/SpecialMonitoringBanner/index.tsx


var SpecialMonitoringBanner = function(param) {
    var onClick = param.onClick, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringBannerContainer, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringBannerContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "special-monitoring-banner__title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Full Call Auction"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "special-monitoring-banner__desc",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "icon-trading_back reverse"
            })
        ]
    });
};
/* harmony default export */ var components_SpecialMonitoringBanner = (SpecialMonitoringBanner);

// EXTERNAL MODULE: ./src/features/transaction/ModuleFederationForm.tsx + 3 modules
var ModuleFederationForm = __webpack_require__(66019);
// EXTERNAL MODULE: ./src/hooks/useCustomEvent/index.ts + 3 modules
var useCustomEvent = __webpack_require__(45939);
;// CONCATENATED MODULE: ./src/typings/customEvent/buysell.ts
var BuySellEventName;
(function(BuySellEventName) {
    BuySellEventName["OrderModalHide"] = "@buy-sell/order-modal/hide";
    BuySellEventName["OrderModalClose"] = "@buy-sell/order-modal/close";
})(BuySellEventName || (BuySellEventName = {}));

;// CONCATENATED MODULE: ./src/typings/customEvent/index.ts


// EXTERNAL MODULE: ./src/global/TradingModal/TableOrderbook/index.tsx + 14 modules
var TableOrderbook = __webpack_require__(3215);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderbookCompanies.ts + 1 modules
var useOrderbookCompanies = __webpack_require__(32293);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx + 1 modules
var SearchCompany = __webpack_require__(77017);
// EXTERNAL MODULE: ./src/global/TradingModal/components/BidOfferBox.tsx
var BidOfferBox = __webpack_require__(75671);
// EXTERNAL MODULE: ./src/global/TradingModal/components/styled.ts
var components_styled = __webpack_require__(80713);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionTag.tsx
var CorpActionTag = __webpack_require__(66988);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts + 1 modules
var Notation_styled = __webpack_require__(69836);
// EXTERNAL MODULE: ./src/global/Notation/PopoverNotation.tsx
var PopoverNotation = __webpack_require__(63631);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/TradingCompanyTags.tsx









var TradingCompanyTags = function(param) {
    var company = param.company;
    var symbol = company.symbol, name = company.name, uma = company.uma, corp_action = company.corp_action, indexes = company.indexes, notation = company.notation, market_hour = company.market_hour;
    var isXNotationEnabled = market_hour.suspend_info;
    var isDBX = indexes.indexOf("DBX") > -1;
    var isSyariah = indexes.indexOf("JII") > -1 || indexes.indexOf("ISSI") > -1;
    var hasNotation = notation.length > 0;
    var hasXNotation = notation.find(function(value) {
        return value.notation_code === "X";
    });
    var onlyHasXNotation = notation.length === 1 && notation[0].notation_code === "X";
    var checkIndicator = hasNotation && !onlyHasXNotation;
    var showIndicator = isXNotationEnabled ? checkIndicator : hasNotation;
    var showXIcon = isXNotationEnabled && hasXNotation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showIndicator,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                    symbol: symbol,
                    name: name,
                    notation: notation,
                    uma: uma,
                    type: "indicator",
                    placement: "bottom",
                    isNotationBadges: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showXIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                    symbol: symbol,
                    name: name,
                    notation: notation,
                    uma: uma,
                    type: "x",
                    placement: "bottom",
                    isNotationBadges: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: corp_action.active,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionTag/* default */.Z, {
                    corpAction: corp_action,
                    isCorpActionBadges: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: uma,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                    symbol: symbol,
                    name: name,
                    notation: notation,
                    uma: uma,
                    type: "uma",
                    placement: "bottom",
                    isNotationBadges: true,
                    isPopover: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverNotation/* default */.Z, {
                company: company
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDBX,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_styled/* BadgeLabelWrapper */.lw, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "DBX"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isSyariah,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_styled/* BadgeLabelWrapper */.lw, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "Syariah"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_TradingCompanyTags = (TradingCompanyTags);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormTypeSelect.tsx










var CircleCheck = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "6",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.59961 7.99844L6.73016 9.2232C6.92026 9.42914 7.24249 9.43863 7.44438 9.24422L10.3996 6.39844",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
};
var FormTypeSelect = function(param) {
    var onChange = param.onChange;
    var ref = (0,_sliced_to_array/* default */.Z)((0,TradingModal_store/* default */.Z)(function(s) {
        return [
            s.showTabs,
            s.showOrderbook, 
        ];
    }), 2), showTabs = ref[0], showOrderbook = ref[1];
    var orderType = (0,useTradingStore/* default */.Z)(function(s) {
        return s.orderType;
    });
    var classicSymbol = (0,useTradingStore/* default */.Z)(function(s) {
        return s.symbol;
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTransactionFormStore/* default */.Z)(function(s) {
        return [
            s.formType,
            s.setFormType, 
        ];
    }), 2), formType = ref1[0], setFormType = ref1[1];
    var setSymbol = (0,useFastOrderStore/* default */.Z)(function(s) {
        return s.setSymbol;
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useGlobalModalStore/* default */.Z)(function(s) {
        return [
            s.setActiveModal
        ];
    }), 1), setActiveModal = ref2[0];
    var handleSelectChange = function(value) {
        setSymbol(classicSymbol); // Update symbol used by classic form to fast order form
        setFormType(value);
        setActiveModal(types/* GlobalModalType.FastOrder */.C.FastOrder, {
            switchFormConfig: {
                orderType: orderType,
                showTabs: showTabs,
                showOrderbook: showOrderbook
            }
        });
        onChange(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_styled/* SelectForm */.p7, {
        className: "hide-icon",
        value: formType,
        onChange: handleSelectChange,
        options: [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* ItemWrapper */.f$, {
                    children: [
                        "Classic",
                        formType === transactionForm/* TransactionFormType.Classic */.b.Classic && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleCheck, {})
                        })
                    ]
                }),
                value: transactionForm/* TransactionFormType.Classic */.b.Classic
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* ItemWrapper */.f$, {
                    children: [
                        "Fast Order",
                        formType === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleCheck, {})
                        })
                    ]
                }),
                value: transactionForm/* TransactionFormType.FastOrder */.b.FastOrder
            }, 
        ]
    });
};
/* harmony default export */ var TransactionModal_FormTypeSelect = (FormTypeSelect);

// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/TransactionTypeSwitch/styled.tsx

function TransactionTypeSwitch_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  border: 1px solid #ededed;\n  background-color: #f6f6f6;\n  height: 32px;\n  border-radius: 2px;\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    TransactionTypeSwitch_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TransactionTypeSwitch_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #ffffff;\n  height: 100%;\n  transition: 0.3s left ease-out, 0.3s width ease-out;\n"
    ]);
    TransactionTypeSwitch_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TransactionTypeSwitch_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n"
    ]);
    TransactionTypeSwitch_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  padding: 0;\n\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 24px;\n\n  &.buy {\n    color: #00ab6b;\n  }\n\n  &.sell {\n    color: #ee4a49;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b16cbc9c-0"
})(TransactionTypeSwitch_styled_templateObject());
var BackgroundHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b16cbc9c-1"
})(TransactionTypeSwitch_styled_templateObject1());
var SwitchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b16cbc9c-2"
})(TransactionTypeSwitch_styled_templateObject2());
var SwitchButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b16cbc9c-3"
})(styled_templateObject3());

;// CONCATENATED MODULE: ./src/global/TradingModal/components/TransactionTypeSwitch/index.tsx







var TransactionTypeSwitch = function(param) {
    var _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _defaultValue, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, formTypeSelectVisible = param.formTypeSelectVisible;
    var _obj;
    var switchRefs = (0,react.useRef)((_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* TransactionType.Buy */.iU.Buy, /*#__PURE__*/ (0,react.createRef)()), (0,_define_property/* default */.Z)(_obj, transaction/* TransactionType.Sell */.iU.Sell, /*#__PURE__*/ (0,react.createRef)()), _obj));
    var ref = (0,react.useState)(defaultValue), activeTransactionType = ref[0], setActiveTransactionType = ref[1];
    var ref1 = (0,react.useState)({
        width: 0,
        left: 0
    }), highlightConfig = ref1[0], setHighlightConfig = ref1[1];
    var handleSetHighlightConfig = function(transactionType) {
        setHighlightConfig((0,immer_esm/* default */.ZP)(highlightConfig, function(draft) {
            var ref, ref1;
            draft.width = ((ref = switchRefs.current[transactionType].current) === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;
            draft.left = ((ref1 = switchRefs.current[transactionType].current) === null || ref1 === void 0 ? void 0 : ref1.offsetLeft) || 0;
        }));
    };
    var handleSwitchTransactionType = function(transactionType) {
        return function() {
            setActiveTransactionType(transactionType);
            onChange(transactionType);
        };
    };
    (0,react.useEffect)(function() {
        handleSetHighlightConfig(activeTransactionType);
    }, [
        activeTransactionType,
        formTypeSelectVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundHighlight, {
                style: (0,_object_spread/* default */.Z)({}, highlightConfig)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                        ref: switchRefs.current[transaction/* TransactionType.Buy */.iU.Buy],
                        className: "buy",
                        onClick: handleSwitchTransactionType(transaction/* TransactionType.Buy */.iU.Buy),
                        disabled: disabled,
                        children: "Buy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                        ref: switchRefs.current[transaction/* TransactionType.Sell */.iU.Sell],
                        className: "sell",
                        onClick: handleSwitchTransactionType(transaction/* TransactionType.Sell */.iU.Sell),
                        disabled: disabled,
                        children: "Sell"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TransactionTypeSwitch = (TransactionTypeSwitch);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/Header.tsx
/* eslint-disable arrow-body-style */ 




























function TransactionHeader(param) {
    var orderType = param.orderType, _defaultTabsValue = param.defaultTabsValue, defaultTabsValue = _defaultTabsValue === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _defaultTabsValue, isSearchActive = param.isSearchActive, _disableTabs = param.disableTabs, disableTabs = _disableTabs === void 0 ? false : _disableTabs, _showTabs = param.showTabs, showTabs = _showTabs === void 0 ? false : _showTabs, _formTypeSelectVisible = param.formTypeSelectVisible, formTypeSelectVisible = _formTypeSelectVisible === void 0 ? false : _formTypeSelectVisible, _setIsSearchActive = param.setIsSearchActive, setIsSearchActive = _setIsSearchActive === void 0 ? function() {} : _setIsSearchActive, _onUpdateSymbol = param.onUpdateSymbol, onUpdateSymbol = _onUpdateSymbol === void 0 ? function() {} : _onUpdateSymbol, _onFormTypeChange = param.onFormTypeChange, onFormTypeChange = _onFormTypeChange === void 0 ? function() {} : _onFormTypeChange, _onTabsChange = param.onTabsChange, onTabsChange = _onTabsChange === void 0 ? function() {} : _onTabsChange, _borderless = param.borderless, borderless = _borderless === void 0 ? false : _borderless;
    var stockInputRef = (0,react.useRef)();
    var data = (0,tradingData/* default */.Z)(function(s) {
        return s.company;
    }).data;
    var trailingStop = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.trailingStop;
    });
    var modalData = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.modalData;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOrderbookCompanies/* default */.Z)(function(s) {
        return [
            s.data.lastprice,
            s.data.change,
            s.data.percentage_change
        ];
    }, shallow/* default */.Z), 3), priceOrderbook = ref[0], changeOrderbook = ref[1], percentageOrderbook = ref[2];
    var ref1 = data || {}, icon_url = ref1.icon_url, name = ref1.name, symbol = ref1.symbol, orderbook = ref1.orderbook, priceCompany = ref1.price, changeCompany = ref1.change, percentageCompany = ref1.percentage;
    var price = priceOrderbook || priceCompany;
    var change = changeOrderbook || changeCompany;
    var percentage = percentageOrderbook || percentageCompany;
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY;
    var isAmendSell = orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    (0,react.useEffect)(function() {
        if (isSearchActive) {
            setTimeout(function() {
                var ref;
                (ref = stockInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }, 100);
        }
    }, [
        isSearchActive
    ]);
    var transactionTitle = (0,react.useMemo)(function() {
        if (isAmendSell) {
            var label = (modalData !== null && modalData !== void 0 ? modalData : {}).label;
            if (label === types_trading/* SmartOrderLabel.SL */.D0.SL) return "Amend Stop Loss";
            if (label === types_trading/* SmartOrderLabel.TP */.D0.TP) return "Amend Take Profit";
        }
        if (trailingStop) return "Amend Trailing Stop";
        var label1 = modalData.label;
        if (orderType === "AMEND_BUY" && label1 === types_trading/* SmartOrderLabel.AB */.D0.AB || orderType === "AMEND_SELL" && label1 === types_trading/* SmartOrderLabel.LIT_SELL */.D0.LIT_SELL) {
            return "Amend Limit If Touched";
        }
        return "".concat(orderType.split("_").map(function(s) {
            return (0,general/* capitalizeFirstLetter */.fm)(s);
        }).join(" ")).concat(orderType === "EXERCISE" ? " ".concat(symbol) : "");
    }, [
        trailingStop,
        orderType,
        symbol,
        modalData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                style: {
                    position: "relative",
                    width: "100%",
                    height: 32,
                    paddingRight: 24,
                    marginBottom: 20,
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        align: "center",
                        justify: "center",
                        width: "100%",
                        height: "32px",
                        style: {
                            position: "absolute"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: !showTabs,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                family: "bold",
                                size: "20px",
                                align: "center",
                                // @ts-expect-error
                                m: "0",
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_TITLE */.eG.HEADER_TITLE,
                                children: transactionTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: formTypeSelectVisible,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 7,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormTypeSelect, {
                                onChange: onFormTypeChange
                            })
                        })
                    }),
                    showTabs && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: formTypeSelectVisible ? 16 : 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TransactionTypeSwitch, {
                            defaultValue: defaultTabsValue,
                            disabled: disableTabs,
                            onChange: onTabsChange,
                            formTypeSelectVisible: Boolean(formTypeSelectVisible)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* FormHeader */.ph, {
                style: {
                    paddingTop: showTabs ? 15 : 0
                },
                className: !borderless ? "has-border" : "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        width: "100%",
                        style: {
                            display: isSearchActive ? "none" : "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "flex-start",
                                children: [
                                    !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styled/* SymbolAvatar */.Mu, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                            color: "white",
                                            family: "bold",
                                            size: "16px",
                                            children: symbol[0]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: icon_url,
                                        style: {
                                            width: "40px",
                                            height: "40px",
                                            background: "white"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        direction: "column",
                                        pl: "15px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                        family: "bold",
                                                        size: "16px",
                                                        children: symbol
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TradingCompanyTags, {
                                                        company: data
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                mt: "3px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                        size: "14px",
                                                        color: color/* default.midgray */.Z.midgray,
                                                        mr: "5px",
                                                        children: name
                                                    }),
                                                    isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                                        className: "icon-tradesmall_pencil2",
                                                        size: "14px",
                                                        hoverColor: color/* default.highgray */.Z.highgray,
                                                        onClick: function() {
                                                            setIsSearchActive();
                                                        },
                                                        "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_CHANGE_EMITEN_BUTTON_PENCIL */.eG.HEADER_CHANGE_EMITEN_BUTTON_PENCIL
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styled/* PriceWrapper */.vN, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                family: "bold",
                                                as: "div",
                                                children: (0,number/* formatNumber */.uf)(price, false)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                                    color: (0,general/* getColorBasedOnNumber */.pV)(Number(change)),
                                                    as: "span",
                                                    size: "12px",
                                                    children: [
                                                        Number(change),
                                                        " (",
                                                        percentage > 0 && " +",
                                                        numeral_default()(percentage).format("0.00"),
                                                        "%)"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BidOfferBox/* default */.Z, {
                                        orderbook: orderbook
                                    })
                                ]
                            })
                        ]
                    }),
                    isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                            ref: stockInputRef,
                            isInTradingModal: true,
                            updateSymbol: function(newSymbol, isBond) {
                                (0,securities/* clevertapChangeStock */.EQ)();
                                onUpdateSymbol(newSymbol, isBond);
                            }
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Header = (TransactionHeader);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormExercise.tsx
var FormExercise = __webpack_require__(52595);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/TransactionMFModal.tsx






























var TransactionMFModal_obj;
var transactionToOrderType = (TransactionMFModal_obj = {}, (0,_define_property/* default */.Z)(TransactionMFModal_obj, transaction/* TransactionType.Buy */.iU.Buy, trading/* ORDER_TYPE.BUY */.Jm.BUY), (0,_define_property/* default */.Z)(TransactionMFModal_obj, transaction/* TransactionType.Sell */.iU.Sell, trading/* ORDER_TYPE.SELL */.Jm.SELL), TransactionMFModal_obj);
var TransactionMFModal = function(param) {
    var visible = param.visible, onUpdateSymbol = param.onUpdateSymbol, onSubmitExercise = param.onSubmitExercise, closeModal = param.closeModal, onSwitchTab = param.onSwitchTab;
    var isFastOrderEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.FAST_ORDER */.O.FAST_ORDER);
    var ref = (0,react.useState)(false), isSearchActive = ref[0], setIsSearchActive = ref[1];
    var resetCashInfo = (0,useCashInfoStore/* default */.Z)(function(s) {
        return s.resetCashInfo;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var ref1 = (0,TradingModal_store/* default */.Z)(), showOrderbook = ref1.showOrderbook, showTabs = ref1.showTabs, orderid = ref1.orderid, price = ref1.price, setPrice = ref1.setPrice, setToMaxLot = ref1.setToMaxLot;
    var orderType = (0,useTradingStore/* default */.Z)(function(s) {
        return s.orderType;
    });
    var formType = (0,useTradingStore/* default */.Z)(function(s) {
        return s.formType;
    });
    var resetOrderData = (0,RealTradingModal_store/* default */.Z)(function(s) {
        return s.resetOrderData;
    });
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var openBondsBuyModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openBuyModal;
    });
    var company = (0,tradingData/* default */.Z)(function(s) {
        var ref;
        return (ref = s.company) === null || ref === void 0 ? void 0 : ref.data;
    });
    var setModal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setModal;
    });
    var marketHour = company === null || company === void 0 ? void 0 : company.market_hour;
    var isExercise = orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE;
    var isAmend = (0,react.useMemo)(function() {
        return [
            trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL
        ].includes(orderType);
    }, [
        orderType
    ]);
    var ref2 = (0,react.useState)(false), isModalHidden = ref2[0], setIsModalHidden = ref2[1];
    var isFormTypeSelectVisible = (0,react.useMemo)(function() {
        var ref;
        return isFastOrderEnabled && [
            trading/* ORDER_TYPE.BUY */.Jm.BUY,
            trading/* ORDER_TYPE.SELL */.Jm.SELL
        ].includes(orderType) && [
            stockType/* StockType.Saham */.Z.Saham,
            stockType/* StockType.Waran */.Z.Waran,
            stockType/* StockType.Right */.Z.Right,
            stockType/* StockType.Etf */.Z.Etf, 
        ].includes(company === null || company === void 0 ? void 0 : (ref = company.type_company) === null || ref === void 0 ? void 0 : ref.toLowerCase());
    }, [
        isFastOrderEnabled,
        isAmend
    ]);
    var defaultTabValue = (0,react.useMemo)(function() {
        if ([
            (trading/* ORDER_TYPE.BUY */.Jm.BUY, trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY)
        ].includes(orderType)) {
            return transaction/* TransactionType.Buy */.iU.Buy;
        }
        if ([
            trading/* ORDER_TYPE.SELL */.Jm.SELL,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL
        ].includes(orderType)) {
            return transaction/* TransactionType.Sell */.iU.Sell;
        }
        return transaction/* TransactionType.Buy */.iU.Buy;
    }, [
        orderType
    ]);
    var handleUpdateSymbol = function(selected, isBonds) {
        if (isBonds) {
            openBondsBuyModal(selected);
            FRBondActionTrackers.onOrderButtonClicked("Buy", selected, "Search Company Page");
            closeModal();
            return;
        }
        onUpdateSymbol(selected);
        setIsSearchActive(false);
    };
    var handleClose = function() {
        resetCashInfo();
        closeModal();
        resetOrderData();
        (0,autoOrder/* trackAutoBuyOrderCanceled */.fY)();
        setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
    };
    var handleFormTypeChange = function(value) {
        if (value === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder) handleClose();
    };
    var handleSwitchTab = function(value) {
        onSwitchTab(transactionToOrderType[value]);
    };
    var showSpecialMonitoringModal = function() {
        setModal(RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING);
    };
    var symbol = (0,useTradingStore/* default */.Z)(function(s) {
        return s.symbol;
    });
    var initialData = {
        orderType: orderType,
        orderid: orderid,
        currentSymbol: symbol,
        type: formType !== null && formType !== void 0 ? formType : transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder,
        setToMaxLot: setToMaxLot
    };
    (0,useCustomEvent/* useCustomEvent */.ji)({
        eventName: BuySellEventName.OrderModalHide,
        onSignal: function(param) {
            var detail = param.detail;
            var isHidden = detail.isHidden;
            setIsModalHidden(isHidden);
        }
    });
    (0,useCustomEvent/* useCustomEvent */.ji)({
        eventName: BuySellEventName.OrderModalClose,
        onSignal: function() {
            handleClose();
        }
    });
    (0,react.useEffect)(function() {
        if (visible) {
            if (orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY) {
                (0,securities/* clevertapBuyOrderViewed */.A2)(symbol);
            } else if (orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL) {
                (0,securities/* clevertapSellOrderViewed */.B0)(symbol);
            }
        }
    }, [
        orderType,
        symbol,
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_styled/* BuySellPortal */._C, {
                id: "buy-sell-portal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* TransactionModalContainer */.md, {
                width: "auto",
                "data-cy": "transaction-modal-real",
                style: {
                    display: isModalHidden ? "none" : undefined
                },
                maskStyle: {
                    display: isModalHidden ? "none" : undefined
                },
                visible: visible,
                onCancel: handleClose,
                transitionName: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* TransactionModalWrapper */.a, {
                    showOrderbook: showOrderbook && !isExercise,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: showOrderbook && !isExercise,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* ModalFormWrapper */.W_, {
                            children: [
                                isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* FreezeLayer */.VV, {
                                    onClick: function() {
                                        return setIsSearchActive(false);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* FormWrapper */.n5, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                            orderType: orderType,
                                            defaultTabsValue: defaultTabValue,
                                            showTabs: showTabs,
                                            isSearchActive: isSearchActive,
                                            setIsSearchActive: function() {
                                                return setIsSearchActive(!isSearchActive);
                                            },
                                            formTypeSelectVisible: isFormTypeSelectVisible,
                                            onUpdateSymbol: handleUpdateSymbol,
                                            onFormTypeChange: handleFormTypeChange,
                                            onTabsChange: handleSwitchTab,
                                            borderless: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: marketHour === null || marketHour === void 0 ? void 0 : marketHour.suspend_info,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpecialMonitoringBanner, {
                                                onClick: showSpecialMonitoringModal,
                                                title: marketHour === null || marketHour === void 0 ? void 0 : marketHour.suspend_info
                                            })
                                        }),
                                        isExercise && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormExercise/* default */.Z, {
                                            onSubmit: onSubmitExercise
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: !isExercise,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleFederationForm/* default */.Z, {
                                                initialData: initialData,
                                                formId: "trading_window",
                                                customPrice: price,
                                                onSwitchTab: function() {
                                                    if (price) setPrice(null);
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var TransactionModal_TransactionMFModal = (/*#__PURE__*/(0,react.memo)(TransactionMFModal));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/index.js + 5 modules
var common = __webpack_require__(48308);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/features/day-trade/components/BuyLeverage/leverage.styled.ts

function leverage_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n"
    ]);
    leverage_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 15px;\n  font-size: 12px;\n  fonwt-weight: 400;\n  line-height: 16px;\n  padding: 6px 12px;\n  text-align: center;\n  color: #858585;\n  background: #ffffff;\n  border: 1px solid #ededed;\n  cursor: pointer;\n\n"
    ]);
    leverage_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover,\n  &:focus,\n  &:active {\n    color: #858585;\n    border: 1px solid #ededed;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    leverage_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: min-content;\n  display: flex;\n  gap: 5px;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 16px 6px 14px;\n\n  span {\n    margin: 0 !important;\n  }\n"
    ]);
    leverage_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var LeverageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7adabab9-0"
})(leverage_styled_templateObject());
var Chip = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-7adabab9-1"
})(leverage_styled_templateObject1());
var NoneButton = (0,styled_components_browser_esm/* default */.ZP)(Chip).withConfig({
    componentId: "sc-7adabab9-2"
})(leverage_styled_templateObject2(), function(param) {
    var isActive = param.isActive;
    return isActive && "\n    color: #0ba16b;\n    font-weight: 700;\n    border-color: #0ba16b;\n\n    &:hover, &:focus, &:active {\n      color: #0ba16b;\n      border-color: #0ba16b;\n    }\n  ";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && "\n    color: #858585;\n    font-weight: 400;\n    border-color: #EDEDED;\n    cursor: not-allowed;\n\n    &:hover, &:focus, &:active {\n      color: #858585;\n      border-color: #EDEDED;\n    }\n  ";
});
var ActionButton = (0,styled_components_browser_esm/* default */.ZP)(NoneButton).withConfig({
    componentId: "sc-7adabab9-3"
})(leverage_styled_templateObject3());

;// CONCATENATED MODULE: ./src/features/day-trade/components/BuyLeverage/leverage.tsx







function LeverageButton(param) {
    var paymentMethod = param.paymentMethod, multiplier = param.multiplier, _enableDayTrade = param.enableDayTrade, enableDayTrade = _enableDayTrade === void 0 ? false : _enableDayTrade, _isAmend = param.isAmend, isAmend = _isAmend === void 0 ? false : _isAmend, _onMethodChange = param.onMethodChange, onMethodChange = _onMethodChange === void 0 ? function() {} : _onMethodChange, onOpenModalLeverage = param.onOpenModalLeverage;
    var isTradingBalance = paymentMethod === transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance;
    var isTradingLimit = paymentMethod === transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit;
    var isDayTrade = paymentMethod === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
    var isShowBadge = isTradingBalance || isDayTrade;
    var handleNoneButtonClick = function() {
        if (isAmend) return;
        onMethodChange(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        (0,securities/* clevertapDayTradeLeverageSelected */.Am)("None");
    };
    var handleOpenModalLeverage = function() {
        if (isAmend) return;
        onOpenModalLeverage();
        (0,securities/* clevertapDayTradeLeverageSelected */.Am)("Leverage");
    };
    var getDropdownText = function() {
        if (isTradingLimit || !enableDayTrade) {
            return "Trading Limit";
        }
        if (isDayTrade || isAmend) {
            return "".concat(multiplier, "x Day Trade");
        }
        return "Up to ".concat(multiplier, "x");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoneButton, {
                isActive: isTradingBalance,
                isDisabled: isAmend,
                onClick: handleNoneButtonClick,
                children: "None"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionButton, {
                isActive: !isTradingBalance || isAmend,
                onClick: handleOpenModalLeverage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isShowBadge && enableDayTrade,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: Icons/* LightningSvg */.Sf
                        })
                    }),
                    getDropdownText(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: enableDayTrade && !isAmend,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: Icons/* DropDownSvg */.V3
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
// EXTERNAL MODULE: ./src/global/Securities/components/InputStepper/index.tsx + 1 modules
var InputStepper = __webpack_require__(97077);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 49 modules
var es_select = __webpack_require__(92961);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/InfoSvg.tsx
var InfoSvg = __webpack_require__(42958);
// EXTERNAL MODULE: ./src/global/Securities/components/Form/TransactionForm/OrderTypeFormItem/styled.ts
var OrderTypeFormItem_styled = __webpack_require__(82093);
;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/OrderTypeFormItem/index.tsx











var OrderTypeFormItem_obj, _obj1;
var orderTypeOptions = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, transaction/* TransactionType.Buy */.iU.Buy, (OrderTypeFormItem_obj = {}, (0,_define_property/* default */.Z)(OrderTypeFormItem_obj, transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder, "Limit Order"), (0,_define_property/* default */.Z)(OrderTypeFormItem_obj, transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy, "Auto Buy"), OrderTypeFormItem_obj)), (0,_define_property/* default */.Z)(_obj1, transaction/* TransactionType.Sell */.iU.Sell, (0,_define_property/* default */.Z)({}, transaction/* SellOrderType.LimitOrder */.qK.LimitOrder, "Limit Order")), _obj1);
var OrderTypeFormItem = function(param) {
    var form = param.form, _transactionType = param.transactionType, transactionType = _transactionType === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _transactionType, _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder : _defaultValue, _hideInfoIcon = param.hideInfoIcon, hideInfoIcon = _hideInfoIcon === void 0 ? false : _hideInfoIcon, _onInfoIconClick = param.onInfoIconClick, onInfoIconClick = _onInfoIconClick === void 0 ? function() {} : _onInfoIconClick, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange;
    var activeOptions = (0,react.useMemo)(function() {
        return Object.entries(orderTypeOptions[transactionType]);
    }, [
        transactionType
    ]);
    var handleChange = function(value, option) {
        onChange(value, option);
        form.validateFields();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Order type",
                        !hideInfoIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                            type: "button",
                            onClick: onInfoIconClick,
                            "data-cy": constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_BUTTON_INFO */.eG.ORDER_TYPE_BUTTON_INFO,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: InfoSvg/* default */.Z,
                                style: {
                                    fontSize: 16,
                                    color: "#969696",
                                    marginLeft: 4
                                }
                            })
                        })
                    ]
                }),
                name: "orderType",
                initialValue: defaultValue,
                hidden: activeOptions.length <= 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                    onChange: handleChange,
                    onDropdownVisibleChange: function(visible) {
                        if (visible) {
                            (0,securities/* clevertapAutoOrderOptionsViewed */.r8)();
                        }
                    },
                    "data-cy": constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT */.eG.ORDER_TYPE_SELECT,
                    getPopupContainer: function() {
                        return document.getElementById(constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT_DROPDOWN */.eG.ORDER_TYPE_SELECT_DROPDOWN);
                    },
                    children: activeOptions.map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], text = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default.Option */.Z.Option, {
                            value: key,
                            children: text
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT_DROPDOWN */.eG.ORDER_TYPE_SELECT_DROPDOWN,
                "data-cy": constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT_DROPDOWN */.eG.ORDER_TYPE_SELECT_DROPDOWN
            })
        ]
    });
};
/* harmony default export */ var TransactionForm_OrderTypeFormItem = (OrderTypeFormItem);

// EXTERNAL MODULE: ./src/global/TradingModal/components/OverLimitText.tsx
var OverLimitText = __webpack_require__(68890);
// EXTERNAL MODULE: ./src/global/Securities/components/Slider/index.tsx + 1 modules
var Slider = __webpack_require__(37212);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SwapRightOutlined.js + 1 modules
var SwapRightOutlined = __webpack_require__(32198);
;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumber/styled.ts

function InputNumber_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    border-color: #00ab6b;\n  }\n\n  &:focus {\n    border-color: #00ab6b;\n    border-right-width: 1px !important;\n    outline: 0;\n\n    box-shadow: 0 0 0 2px rgba(0, 171, 107, 0.2);\n  }\n"
    ]);
    InputNumber_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputNumber_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border: 1px solid #dadada;\n  padding: 6px 12px;\n  box-sizing: border-box;\n\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #333333;\n\n  border-radius: 2px;\n\n  transition: 0.15s linear;\n  transition-property: border-color, box-shadow;\n  outline: 0;\n\n  ",
        "\n"
    ]);
    InputNumber_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var InputHightlightCss = (0,styled_components_browser_esm/* css */.iv)(InputNumber_styled_templateObject());
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-f42c2e44-0"
})(InputNumber_styled_templateObject1(), function(param) {
    var disableHighlight = param.disableHighlight;
    return !disableHighlight && InputHightlightCss;
});

;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumber/index.tsx






var InputNumber = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, _onBlur = _param.onBlur, onBlur = _onBlur === void 0 ? function() {} : _onBlur, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, propValue = _param.value, _formatter = _param.formatter, formatter = _formatter === void 0 ? "0.[0000]" : _formatter, allowEmptyField = _param.allowEmptyField, disableDecimal = _param.disableDecimal, defaultValue = _param.defaultValue, zeroReplacer = _param.zeroReplacer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "onBlur",
        "onChange",
        "value",
        "formatter",
        "allowEmptyField",
        "disableDecimal",
        "defaultValue",
        "zeroReplacer"
    ]);
    var _$ref = (0,react.useState)(defaultValue ? numeral_default()(defaultValue).format(formatter) : ""), inputValue = _$ref[0], setInputValue = _$ref[1];
    var numeralInputValue = (0,react.useMemo)(function() {
        return numeral_default()(inputValue);
    }, [
        inputValue
    ]);
    var setTextCursor = function(target, position) {
        window.requestAnimationFrame(function() {
            target.focus();
            target.setSelectionRange(position, position);
        });
    };
    var _min, _max;
    var getClampedValue = function(value) {
        return Math.min(Math.max(value, (_min = props.min) !== null && _min !== void 0 ? _min : -Infinity), (_max = props.max) !== null && _max !== void 0 ? _max : Infinity);
    };
    var handleBlur = function(e) {
        onBlur(e);
        if (inputValue === "" && allowEmptyField) return;
        setInputValue(numeral_default()(inputValue).format(formatter));
    };
    var handleChange = function(e) {
        var _target = e.target, eventValue = _target.value, selectionStart = _target.selectionStart;
        if (zeroReplacer !== undefined && (eventValue === "" || eventValue === "0")) {
            setInputValue(zeroReplacer);
            onChange(0, e);
            return;
        }
        // Handle allow empty field when clear all
        if (eventValue === "" && allowEmptyField) {
            setInputValue(eventValue);
            onChange(undefined, e);
            return;
        }
        // Handle initial input when current value is 0, for replacing initial 0
        var currentValue = numeralInputValue.value() || 0;
        var numeralInstance = numeral_default()(currentValue === 0 && (Number(eventValue) < 9 || selectionStart < 2) ? eventValue.replace("0", "") : eventValue);
        // Handle for characters input resulting NaN
        if (Number.isNaN(numeralInstance.value())) return;
        // Handle initial decimal input
        if (eventValue[eventValue.length - 1] === "." && !inputValue.includes(".") && !disableDecimal) {
            setInputValue("".concat(numeralInstance.format(formatter), "."));
            return;
        }
        // Prevent adding value more than maximum or minimum value
        numeralInstance.set(getClampedValue(numeralInstance.value()));
        var value = numeralInstance.value();
        if (eventValue === inputValue) {
            setTextCursor(e.target, selectionStart);
            return;
        }
        // Set final value
        setInputValue(numeralInstance.format(formatter));
        onChange(value, e);
        // Calculate shifting cursor with decimal and thousand separator
        var shiftPos = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.toString().length) - (value === null || value === void 0 ? void 0 : value.toString().length) || 0;
        var newCursor = selectionStart + (numeralInstance.format(formatter).length - numeralInputValue.format(formatter).length + shiftPos);
        setTextCursor(e.target, newCursor <= 0 ? 1 : newCursor);
    };
    var handlePropValueChange = (0,react.useCallback)(function() {
        var isPropValueEmpty = propValue === undefined || propValue === null;
        if (isPropValueEmpty && allowEmptyField) return;
        var isReplaceZero = zeroReplacer !== undefined && propValue === 0;
        setInputValue(isReplaceZero ? zeroReplacer : numeral_default()(getClampedValue(propValue)).format(formatter));
    }, [
        propValue
    ]);
    (0,react.useEffect)(function() {
        handlePropValueChange();
    }, [
        handlePropValueChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: "ant-input ".concat(className),
        onChange: handleChange,
        onBlur: handleBlur,
        value: inputValue
    }, props));
});
/* harmony default export */ var Input_InputNumber = (InputNumber);

;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumberAddon/styled.ts

function InputNumberAddon_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: 2px;\n  border: 1px solid #dadada;\n  padding: 4px 12px;\n"
    ]);
    InputNumberAddon_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputNumberAddon_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & {\n    border: 0;\n    padding: 0;\n    width: 100%;\n    text-align: right;\n    box-shadow: none !important;\n  }\n"
    ]);
    InputNumberAddon_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var InputNumberAddon_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f65c52c-0"
})(InputNumberAddon_styled_templateObject());
var styled_InputNumber = (0,styled_components_browser_esm/* default */.ZP)(Input_InputNumber).withConfig({
    componentId: "sc-2f65c52c-1"
})(InputNumberAddon_styled_templateObject1());

;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumberAddon/index.tsx




var InputNumberAddon = function(_param) /*#__PURE__*/ {
    var addonBefore = _param.addonBefore, addonAfter = _param.addonAfter, props = (0,_object_without_properties/* default */.Z)(_param, [
        "addonBefore",
        "addonAfter"
    ]);
    return (0,jsx_runtime.jsxs)(InputNumberAddon_styled_Container, {
        className: "ant-input",
        children: [
            addonBefore && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    marginRight: 4
                },
                children: addonBefore
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_InputNumber, (0,_object_spread/* default */.Z)({}, props)),
            addonAfter && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    marginLeft: 4
                },
                children: addonAfter
            })
        ]
    });
};
/* harmony default export */ var Input_InputNumberAddon = (InputNumberAddon);

// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
;// CONCATENATED MODULE: ./src/global/Securities/components/Switch/index.tsx

function Switch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 34px;\n  height: 20px;\n\n  & > .ant-switch-handle {\n    width: 18px;\n    height: 18px;\n    top: 1px;\n    left: 1px;\n  }\n\n  &.ant-switch-checked .ant-switch-handle {\n    left: calc(100% - 18px - 1px);\n  }\n"
    ]);
    Switch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Switch = (0,styled_components_browser_esm/* default */.ZP)(es_switch/* default */.Z).withConfig({
    componentId: "sc-fe336cf-0"
})(Switch_templateObject());
/* harmony default export */ var components_Switch = (Switch);

;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/SplitOrderFormItem/useSplitOrderValidation.ts
var getErrorListValidation = function(errorList) {
    for(var i = 0; i < errorList.length; i += 1){
        var errorCondition = errorList[i].errorCondition;
        if (errorCondition) return errorList[i];
    }
    return null;
};
var useSplitOrderValidation = function(transactionType) {
    var getValidateQuantityField = function(quantity, min, max, orderLot) {
        return getErrorListValidation([
            {
                errorCondition: quantity <= 1,
                message: "Split Quantity must be higher than 1"
            },
            {
                errorCondition: quantity > orderLot,
                message: "Split Quantity must be lower or equal to ".concat(transactionType, " Order Lot")
            },
            {
                errorCondition: quantity * min > orderLot && min <= max,
                message: ""
            },
            {
                errorCondition: quantity * max < orderLot && min <= max,
                message: ""
            }, 
        ]);
    };
    var getValidateMinRangeField = function(quantity, min, max, buyOrderLot) {
        return getErrorListValidation([
            {
                errorCondition: min > max,
                message: "Min Range must be lower than Max Range"
            },
            {
                errorCondition: min > buyOrderLot,
                message: "Min Range must be lower than ".concat(transactionType, " Order Lot")
            },
            {
                errorCondition: quantity * min > buyOrderLot,
                message: "Total of Split Quantity and Min Range must not exceed ".concat(transactionType, " Order Lot")
            }, 
        ]);
    };
    var getValidateMaxRangeField = function(quantity, min, max, buyOrderLot) {
        return getErrorListValidation([
            {
                errorCondition: min > max,
                message: "Min Range must be lower than Max Range"
            },
            {
                errorCondition: quantity * max < buyOrderLot,
                message: "Total of Split Quantity and Max Range must be higher or equal to ".concat(transactionType, " Order Lot")
            }, 
        ]);
    };
    return {
        getValidateQuantityField: getValidateQuantityField,
        getValidateMinRangeField: getValidateMinRangeField,
        getValidateMaxRangeField: getValidateMaxRangeField
    };
};
/* harmony default export */ var SplitOrderFormItem_useSplitOrderValidation = (useSplitOrderValidation);

// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 8 modules
var input = __webpack_require__(7648);
;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/SplitOrderFormItem/styled.ts

function SplitOrderFormItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-input:hover,\n  .ant-input:focus,\n  .ant-input-focused {\n    border-color: #dadada;\n    outline: 0;\n    box-shadow: none;\n  }\n\n  &.ant-form-item-has-error {\n    .ant-input:hover,\n    .ant-input:focus,\n    .ant-input-focused {\n      border-color: #ff7875;\n      border-right-width: 1px !important;\n      outline: 0;\n      box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);\n    }\n  }\n\n  & .ant-form-item-explain,\n  .ant-form-item-extra {\n    min-height: unset;\n  }\n"
    ]);
    SplitOrderFormItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SplitOrderFormItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-form-item-explain {\n    color: #ff4d4f;\n  }\n"
    ]);
    SplitOrderFormItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SplitOrderFormItem_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n"
    ]);
    SplitOrderFormItem_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SplitOrderFormItem_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-input-group > .ant-input:first-child,\n  .ant-input-group-addon:first-child {\n    padding-right: 50px;\n    border-radius: 4px;\n    text-align: right;\n  }\n\n  & span.ant-input-group-addon {\n    background: transparent;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    width: fit-content;\n    height: 100%;\n\n    display: flex;\n    align-items: center;\n\n    border: none;\n    color: #858585;\n    z-index: 1;\n  }\n"
    ]);
    SplitOrderFormItem_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #858585;\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  & > div,\n  span {\n    margin-right: 8px;\n\n    :last-child {\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 4px;\n  text-align: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  background: none;\n  border: none;\n  padding: 4px 0;\n  margin: 0;\n\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 10px;\n\n  input[type='radio']:checked + span {\n    color: #00ab6b;\n    border: 1px solid #00ab6b;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 15px;\n  cursor: pointer;\n\n  > input {\n    display: none;\n  }\n\n  > span {\n    font-size: 12px;\n    line-height: 16px;\n    padding: 6px 12px;\n    color: #858585;\n    border: 1px solid #858585;\n    border-radius: 15px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var FormItem = (0,styled_components_browser_esm/* default */.ZP)(es_form/* default.Item */.Z.Item).withConfig({
    componentId: "sc-f9bbead9-0"
})(SplitOrderFormItem_styled_templateObject());
var FormItemError = (0,styled_components_browser_esm/* default */.ZP)(FormItem).withConfig({
    componentId: "sc-f9bbead9-1"
})(SplitOrderFormItem_styled_templateObject1());
var FormItemRange = (0,styled_components_browser_esm/* default */.ZP)(FormItem).withConfig({
    componentId: "sc-f9bbead9-2"
})(SplitOrderFormItem_styled_templateObject2());
var QuantityInput = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.Z).withConfig({
    componentId: "sc-f9bbead9-3"
})(SplitOrderFormItem_styled_templateObject3());
var QuantityAddon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f9bbead9-4"
})(styled_templateObject4());
var RangeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f9bbead9-5"
})(_templateObject5());
var RangeInput = (0,styled_components_browser_esm/* default */.ZP)(Input_InputNumber).attrs({
    disableHighlight: true
}).withConfig({
    componentId: "sc-f9bbead9-6"
})(_templateObject6());
var InfoButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f9bbead9-7"
})(_templateObject7());
var RadioButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f9bbead9-8"
})(_templateObject8());
var RadioButton = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-f9bbead9-9"
})(_templateObject9());

;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/SplitOrderFormItem/index.tsx















var SplitOrderFormItem = function(param) {
    var form = param.form, _orderLot = param.orderLot, orderLot = _orderLot === void 0 ? 10 : _orderLot, _minQuantity = param.minQuantity, minQuantity = _minQuantity === void 0 ? 0 : _minQuantity, _maxQuantity = param.maxQuantity, maxQuantity = _maxQuantity === void 0 ? orderMaxQuantity : _maxQuantity, _minRange = param.minRange, minRange = _minRange === void 0 ? 0 : _minRange, _maxRange = param.maxRange, maxRange = _maxRange === void 0 ? orderMaxLot : _maxRange, _checkedInitialValue = param.checkedInitialValue, checkedInitialValue = _checkedInitialValue === void 0 ? false : _checkedInitialValue, _quantityInitialValue = param.quantityInitialValue, quantityInitialValue = _quantityInitialValue === void 0 ? 0 : _quantityInitialValue, minRangeInitialValue = param.minRangeInitialValue, maxRangeInitialValue = param.maxRangeInitialValue, _transactionType = param.transactionType, transactionType = _transactionType === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _transactionType, _disabledToggle = param.disabledToggle, disabledToggle = _disabledToggle === void 0 ? false : _disabledToggle, _onInfoIconClick = param.onInfoIconClick, onInfoIconClick = _onInfoIconClick === void 0 ? function() {} : _onInfoIconClick, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange, _onSplitMethodInfoClick = param.onSplitMethodInfoClick, onSplitMethodInfoClick = _onSplitMethodInfoClick === void 0 ? function() {} : _onSplitMethodInfoClick;
    var ref = (0,RealTradingModal_store/* default */.Z)(), splitMethod = ref.splitMethod, setSplitMethod = ref.setSplitMethod, setSplitRange = ref.setSplitRange;
    var ref1 = (0,react.useState)(checkedInitialValue), isSplitOrderActive = ref1[0], setSplitOrderActive = ref1[1];
    var ref2 = SplitOrderFormItem_useSplitOrderValidation(transactionType), getValidateQuantityField = ref2.getValidateQuantityField, getValidateMinRangeField = ref2.getValidateMinRangeField, getValidateMaxRangeField = ref2.getValidateMaxRangeField;
    var ref3 = (0,react.useState)(0), quantityValue = ref3[0], setQuantityValue = ref3[1];
    var handleValidateAllFields = function() {
        form.validateFields();
    };
    var handleSwitchChange = function(value) {
        form.resetFields([
            "splitQuantity",
            "splitRangeMin",
            "splitRangeMax"
        ]);
        setSplitOrderActive(value);
        handleValidateAllFields();
        onSwitchChange(value);
    };
    var handleQuantityChange = function(value) {
        setQuantityValue(value);
        handleValidateAllFields();
    };
    var handleInfoIconClick = function(event) {
        event.stopPropagation();
        onInfoIconClick(event);
    };
    var handleValidateQuantity = function(param) {
        var getFieldsValue = param.getFieldsValue, setFields = param.setFields;
        return {
            validator: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, splitQuantity, splitRangeMin, splitRangeMax, isFieldsEmpty, isBuyOrderLotEmpty, errorItem;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = getFieldsValue([
                                "splitQuantity",
                                "splitRangeMin",
                                "splitRangeMax", 
                            ]), splitQuantity = ref.splitQuantity, splitRangeMin = ref.splitRangeMin, splitRangeMax = ref.splitRangeMax;
                            isFieldsEmpty = !(splitQuantity !== undefined && splitRangeMin && splitRangeMax);
                            isBuyOrderLotEmpty = orderLot === 0;
                            setFields([
                                "splitRangeMin",
                                "splitRangeMax"
                            ].map(function(name) {
                                return {
                                    name: name,
                                    errors: undefined
                                };
                            }));
                            if (!(isFieldsEmpty || isBuyOrderLotEmpty)) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", Promise.resolve());
                        case 6:
                            errorItem = getValidateQuantityField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            if (!(errorItem === null || errorItem === void 0 ? void 0 : errorItem.errorCondition)) {
                                _ctx.next = 10;
                                break;
                            }
                            if (errorItem.message.includes("lower")) {
                                form.setFieldsValue({
                                    splitRangeMin: 1,
                                    splitRangeMax: 1
                                });
                            }
                            return _ctx.abrupt("return", Promise.reject(errorItem.message ? new Error(errorItem.message) : undefined));
                        case 10:
                            return _ctx.abrupt("return", Promise.resolve());
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))
        };
    };
    var handleValidateRange = function(param) {
        var setFields = param.setFields, getFieldsValue = param.getFieldsValue;
        return {
            validator: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, splitQuantity, splitRangeMin, splitRangeMax, isFieldsEmpty, isOrderLotEmpty, quantityFieldError, minRangeFieldError, maxRangeFieldError, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = getFieldsValue([
                                "splitQuantity",
                                "splitRangeMin",
                                "splitRangeMax", 
                            ]), splitQuantity = ref.splitQuantity, splitRangeMin = ref.splitRangeMin, splitRangeMax = ref.splitRangeMax;
                            isFieldsEmpty = !(splitQuantity !== undefined && splitRangeMin && splitRangeMax);
                            isOrderLotEmpty = orderLot === 0;
                            setFields([
                                "splitRangeMin",
                                "splitRangeMax"
                            ].map(function(name) {
                                return {
                                    name: name,
                                    errors: undefined
                                };
                            }));
                            if (!(isFieldsEmpty || isOrderLotEmpty)) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", Promise.resolve());
                        case 6:
                            quantityFieldError = getValidateQuantityField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            if (!(quantityFieldError === null || quantityFieldError === void 0 ? void 0 : quantityFieldError.message)) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", Promise.resolve());
                        case 9:
                            minRangeFieldError = getValidateMinRangeField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            maxRangeFieldError = getValidateMaxRangeField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            if (!(minRangeFieldError || maxRangeFieldError)) {
                                _ctx.next = 16;
                                break;
                            }
                            if (minRangeFieldError) {
                                setFields([
                                    {
                                        name: "splitRangeMin",
                                        errors: [
                                            ""
                                        ]
                                    }
                                ]);
                            }
                            if (maxRangeFieldError) {
                                setFields([
                                    {
                                        name: "splitRangeMax",
                                        errors: [
                                            ""
                                        ]
                                    }
                                ]);
                            }
                            ;
                            return _ctx.abrupt("return", Promise.reject(new Error((ref1 = minRangeFieldError === null || minRangeFieldError === void 0 ? void 0 : minRangeFieldError.message) !== null && ref1 !== void 0 ? ref1 : maxRangeFieldError === null || maxRangeFieldError === void 0 ? void 0 : maxRangeFieldError.message)));
                        case 16:
                            return _ctx.abrupt("return", Promise.resolve());
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))
        };
    };
    var handleResetRange = function() {
        form.setFieldsValue({
            splitRangeMin: 0,
            splitRangeMax: 0
        });
        setSplitRange(0, 0);
    };
    var handleSplitMethodSelected = function(e) {
        setSplitMethod(e.target.value);
        if (e.target.value === transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL) {
            handleResetRange();
        }
        setTimeout(function() {
            handleValidateAllFields();
        }, 0);
    };
    // set value setMinRange and setMaxRange if orderLot or splitQuantity change
    var handleSetMinMaxRange = function() {
        var splitQuantity = form.getFieldsValue([
            "splitQuantity",
            "splitRangeMin",
            "splitRangeMax", 
        ]).splitQuantity;
        if (splitMethod === transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL) {
            handleResetRange();
            return;
        }
        if (!splitQuantity || !orderLot) {
            form.setFieldsValue({
                splitRangeMin: 0,
                splitRangeMax: 0
            });
            setSplitRange(0, 0);
            return;
        }
        var orderPerQuantity = orderLot / splitQuantity;
        var formattedOrderPerQuantity = orderPerQuantity > 1 ? orderPerQuantity : 1;
        // Minimum Lot Size as 50% of the average lot size, rounding down any decimal result.
        // Maximum Lot Size as 150% of the average lot size, rounding up any decimal result.
        var calculadteMin = Math.floor(formattedOrderPerQuantity * 0.5);
        var calculadteMax = Math.ceil(formattedOrderPerQuantity * 1.5);
        var formattedMin = calculadteMin > 0 ? calculadteMin : 1;
        var rangeMin = formattedMin > orderMaxLot ? orderMaxLot : formattedMin;
        var rangeMax = calculadteMax > orderMaxLot ? orderMaxLot : calculadteMax;
        form.setFieldsValue({
            splitRangeMin: rangeMin,
            splitRangeMax: rangeMax
        });
        setSplitRange(rangeMin, rangeMax);
    };
    (0,react.useEffect)(function() {
        handleSetMinMaxRange();
        if (!isSplitOrderActive) {
            setQuantityValue(0);
        }
    }, [
        orderLot,
        quantityValue,
        isSplitOrderActive,
        splitMethod
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Split Order",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton, {
                            type: "button",
                            onClick: handleInfoIconClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: InfoSvg/* default */.Z,
                                style: {
                                    fontSize: 16,
                                    color: "#969696",
                                    marginLeft: 4
                                }
                            })
                        })
                    ]
                }),
                name: "isSplitOrderActive",
                initialValue: checkedInitialValue,
                valuePropName: "checked",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Switch, {
                    onChange: handleSwitchChange,
                    disabled: disabledToggle
                })
            }),
            isSplitOrderActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                        label: "Split Quantity",
                        name: "splitQuantity",
                        validateTrigger: "onChange",
                        rules: [
                            handleValidateQuantity
                        ],
                        initialValue: quantityInitialValue,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_InputNumberAddon, {
                            addonAfter: /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuantityAddon, {
                                children: [
                                    "order",
                                    quantityValue > 1 && "s"
                                ]
                            }),
                            min: minQuantity,
                            max: maxQuantity,
                            formatter: "0,0",
                            autoComplete: "off",
                            onChange: handleQuantityChange,
                            disableHighlight: true,
                            disableDecimal: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Split Method"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton, {
                                    type: "button",
                                    onClick: onSplitMethodInfoClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            fontSize: 16,
                                            color: "#969696",
                                            marginLeft: 4
                                        }
                                    })
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioButtonContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioButton, {
                                    htmlFor: "radio-random",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            id: "radio-random",
                                            name: "splitMethod",
                                            value: transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                                            checked: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                                            onChange: handleSplitMethodSelected,
                                            defaultChecked: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Random"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioButton, {
                                    htmlFor: "radio-equal",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            id: "radio-equal",
                                            name: "splitMethod",
                                            value: transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL,
                                            checked: splitMethod === transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL,
                                            onChange: handleSplitMethodSelected
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Equal"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemError, {
                            validateStatus: "",
                            label: "Split Range Lot",
                            name: "rangeInput",
                            validateTrigger: "onChange",
                            rules: [
                                handleValidateRange
                            ],
                            initialValue: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemRange, {
                                        name: "splitRangeMin",
                                        initialValue: minRangeInitialValue,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeInput, {
                                            min: minRange,
                                            max: maxRange,
                                            placeholder: "Min",
                                            formatter: "0,0",
                                            autoComplete: "off",
                                            zeroReplacer: "",
                                            onChange: handleValidateAllFields,
                                            allowEmptyField: true,
                                            disableDecimal: true,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapRightOutlined/* default */.Z, {
                                        style: {
                                            color: "#96969699"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemRange, {
                                        name: "splitRangeMax",
                                        initialValue: maxRangeInitialValue,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeInput, {
                                            min: minRange,
                                            max: maxRange,
                                            placeholder: "Max",
                                            formatter: "0,0",
                                            autoComplete: "off",
                                            zeroReplacer: "",
                                            onChange: handleValidateAllFields,
                                            allowEmptyField: true,
                                            disableDecimal: true,
                                            required: true
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionForm_SplitOrderFormItem = (SplitOrderFormItem);

// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
;// CONCATENATED MODULE: ./src/global/Securities/components/Tooltip/index.ts

function Tooltip_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Tooltip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Tooltip = (0,styled_components_browser_esm/* default */.ZP)(tooltip/* default */.Z).attrs({
    overlayStyle: {
        maxWidth: "unset"
    },
    overlayClassName: "tooltip-overlay-green",
    overlayInnerStyle: {
        background: "#00ab6b",
        padding: "12px",
        maxWidth: "unset",
        lineHeight: "16px",
        fontSize: "12px",
        fontWeight: 700
    }
}).withConfig({
    componentId: "sc-6aa290c9-0"
})(Tooltip_templateObject());
/* harmony default export */ var components_Tooltip = (Tooltip);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/TriggerPriceTooltip.tsx









function TriggerPriceTooltip() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        justify: "flex-end",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                align: "right",
                children: "Trigger Price"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styled/* CustomTooltip */.WH, {
                overlayStyle: {
                    maxWidth: "281px"
                },
                overlayInnerStyle: {
                    padding: "12px",
                    borderRadius: "4px"
                },
                color: color/* default.highempahis */.Z.highempahis,
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styled/* TooltipContainer */.DY, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            size: "12px",
                            family: "bold",
                            color: "inherit",
                            children: "Trigger Price"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                height: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            size: "12px",
                            color: "inherit",
                            children: "Trigger Price adalah kondisi harga yang harus terpenuhi agar order beli dapat dikirim."
                        })
                    ]
                }),
                placement: "bottom",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/info.svg",
                    alt: "type-info",
                    style: {
                        marginLeft: "5px",
                        width: "12px",
                        cursor: "pointer"
                    },
                    onMouseEnter: autoOrder/* trackAutoBuyTriggerPriceInfoSelected */.gT,
                    "data-cy": constant/* DATA_CY_MODAL_TRADING.TRIGGER_PRICE_BUTTON_INFO */.eG.TRIGGER_PRICE_BUTTON_INFO
                })
            })
        ]
    });
}
/* harmony default export */ var components_TriggerPriceTooltip = (TriggerPriceTooltip);

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useEnableSplitOrder.ts








function useEnableSplitOrder(formType) {
    var ref = (0,RealTradingModal_store/* default */.Z)(), expiry = ref.expiry, orderType = ref.type;
    var ref1 = (0,TradingModal_store/* default */.Z)(), modalOrderType = ref1.orderType;
    var splitOrderInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.splitOrder;
    });
    var isSplitOrderFeatureEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.SPLIT_ORDER */.O.SPLIT_ORDER);
    var isShowSplitOrder = (0,react.useMemo)(function() {
        // set to true in case we have failed to get splitorder info
        var isMarketOpen = true;
        if (splitOrderInfo && typeof splitOrderInfo.remaining_trading_close === "number") {
            isMarketOpen = splitOrderInfo.remaining_trading_close !== 0;
        }
        if (formType === "buy") {
            return orderType === transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder && // Order type is not amend BUY
            modalOrderType !== trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY && // feature flag enabled
            isSplitOrderFeatureEnabled && // disable split order on GTC
            expiry !== transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled && // only show when market opens
            isMarketOpen;
        }
        // order is limit order BUY / SELL
        return orderType === transaction/* SellOrderType.LimitOrder */.qK.LimitOrder && // Order type is not amend SELL
        modalOrderType !== trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL && // feature flag enabled
        isSplitOrderFeatureEnabled && // disable split order on GTC
        expiry !== transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled && // only show when market opens
        isMarketOpen;
    }, [
        orderType,
        isSplitOrderFeatureEnabled,
        expiry,
        splitOrderInfo
    ]);
    return isShowSplitOrder;
};

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useTransactionBalance.ts






var useTransactionBalance = function() {
    var paymentMethod = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance;
    var portfolioTradingBalance = (0,tradingData/* default */.Z)(function(s) {
        var ref;
        return (ref = s.portfolio.data) === null || ref === void 0 ? void 0 : ref.tradingbalance;
    });
    var balanceList = (0,useCashInfoStore/* default */.Z)(function(s) {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance, s.tradingBalance || portfolioTradingBalance), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, s.tradingLimit), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, s.dayTrade), _obj;
    }, shallow/* default */.Z);
    return [
        balanceList[paymentMethod]
    ].concat((0,_to_consumable_array/* default */.Z)(Object.values(balanceList)));
};
/* harmony default export */ var hooks_useTransactionBalance = (useTransactionBalance);

// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts + 1 modules
var useIsUserSyariah = __webpack_require__(66940);
// EXTERNAL MODULE: ./src/hooks/useIsSecuritiesMainAccount.ts
var useIsSecuritiesMainAccount = __webpack_require__(87315);
;// CONCATENATED MODULE: ./src/global/Securities/utils/transactionBalance.ts


var getCashTracks = function(paymentMethod, tradingBalance, tradingLimit) {
    var minThreshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
        0.04,
        0.08
    ];
    // If payment method is not Trading Limit, return 100% TB and 0% TL
    if (paymentMethod !== transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit) {
        return [
            100,
            0
        ];
    }
    var _minThreshold = (0,_sliced_to_array/* default */.Z)(minThreshold, 2), leftMinThreshold = _minThreshold[0], rightMinThreshold = _minThreshold[1];
    var clampToZero = function(value) {
        return value < 0 ? 0 : value;
    };
    var tradingBalanceRatio = clampToZero(tradingBalance) / clampToZero(tradingLimit);
    var isTradingBalanceFinite = Number.isFinite(tradingBalanceRatio);
    // Will return max TB if TL actually 0 / ratio is infinity
    if (!isTradingBalanceFinite) return [
        100,
        0
    ];
    var tradingLimitRatio = 1 - tradingBalanceRatio;
    if (tradingBalanceRatio !== 0 && tradingBalanceRatio < leftMinThreshold) {
        return [
            leftMinThreshold * 100,
            (1 - leftMinThreshold) * 100
        ];
    }
    if (tradingLimitRatio !== 0 && tradingLimitRatio < rightMinThreshold) {
        return [
            (1 - rightMinThreshold) * 100,
            rightMinThreshold * 100
        ];
    }
    return [
        tradingBalanceRatio * 100,
        tradingLimitRatio * 100
    ];
};

// EXTERNAL MODULE: ./src/global/Securities/utils/transactionPrice.ts
var transactionPrice = __webpack_require__(98306);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormBuy.tsx














// components














// hooks





// lib





// stores




// utils







// constants



// types



// styles




var FormBuy = function(param) {
    var showOrderTypeModal = param.showOrderTypeModal, showAutoBuyTncModal = param.showAutoBuyTncModal, showSpecialMonitoringModal = param.showSpecialMonitoringModal, _onShowTradingLimitTnc = param.onShowTradingLimitTnc, onShowTradingLimitTnc = _onShowTradingLimitTnc === void 0 ? function() {} : _onShowTradingLimitTnc, _onShowSplitOrderInfo = param.onShowSplitOrderInfo, onShowSplitOrderInfo = _onShowSplitOrderInfo === void 0 ? function() {} : _onShowSplitOrderInfo, _onShowSplitOrderMethodInfo = param.onShowSplitOrderMethodInfo, onShowSplitOrderMethodInfo = _onShowSplitOrderMethodInfo === void 0 ? function() {} : _onShowSplitOrderMethodInfo, onSubmit = param.onSubmit, _onShowDayTradeOnboarding = param.onShowDayTradeOnboarding, onShowDayTradeOnboarding = _onShowDayTradeOnboarding === void 0 ? function() {} : _onShowDayTradeOnboarding, _onShowDayTradeUnavailable = param.onShowDayTradeUnavailable, onShowDayTradeUnavailable = _onShowDayTradeUnavailable === void 0 ? function() {} : _onShowDayTradeUnavailable;
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useUIConfigStore/* default */.Z)(function(s) {
        return [
            s.setUIValue,
            s.getUIValue("tradingLimitTooltip"),
            s.getUIValue("transactionPaymentMethod"),
            s.getUIValue("dayTradeSubAccountActive"), 
        ];
    }, shallow/* default */.Z), 4), setUIValue = ref1[0], isTradingLimitTooltipOpened = ref1[1], defaultPaymentMethod = ref1[2], isDayTradeSubAccountActive = ref1[3];
    var ref2 = (0,react.useState)(false), cashInfoLoaded = ref2[0], setCashInfoLoaded = ref2[1];
    var ref3 = (0,react.useState)(false), hasFormError = ref3[0], setHasFormError = ref3[1];
    var ref4 = (0,react.useState)(false), isPaymentMethodVisible = ref4[0], setPaymentMethodVisible = ref4[1];
    var ref5 = (0,react.useState)(defaultPaymentMethod || transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance), paymentMethod = ref5[0], setPaymentMethod = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(hooks_useTransactionBalance(paymentMethod), 4), activeTradingBalance = ref6[0], tradingBalance = ref6[1], tradingLimit = ref6[2], dayTradeBuyingPower = ref6[3];
    var loadTradingInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.loadTradingInfo;
    });
    var splitOrder = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.splitOrder;
    });
    var ref7 = splitOrder || {}, maxOrder = ref7.max_order;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useCashInfoStore/* default */.Z)(function(s) {
        return [
            s.error,
            s.isLoading,
            s.loadCashInfo
        ];
    }, shallow/* default */.Z), 3), cashInfoError = ref8[0], isCashInfoLoading = ref8[1], loadCashInfo = ref8[2];
    var ref9 = (0,TradingModal_store/* default */.Z)(), isAutoBuy = ref9.isAutoBuy, orderedPrice = ref9.orderedPrice, orderedLot = ref9.orderedLot, modalData = ref9.modalData, isDayTrade = ref9.isDayTrade, orderId = ref9.orderid, setAutoBuy = ref9.setAutoBuy, setModalState = ref9.setModalState;
    var ref10 = (0,useTradingStore/* default */.Z)(function(s) {
        return {
            symbol: s.symbol,
            orderType: s.orderType
        };
    }), symbol = ref10.symbol, orderType = ref10.orderType;
    var ref11 = modalData || {}, trigger_price = ref11.trigger_price, config_type = ref11.config_type, amount_open_fee = ref11.amount_open_fee, amount_matched_total = ref11.amount_matched_total;
    var ref12 = (0,tradingData/* default */.Z)(), _portfolio = ref12.portfolio, _data = _portfolio.data, showCreateSmartOrder = _data.show_create_smartorder, _company = ref12.company, _data1 = _company.data, tradeable = _data1.tradeable, productType = _data1.type_company, marketHour = _data1.market_hour, dayTradeInfo = _data1.day_trade_info, cashOnHand = ref12.cashOnHand, getCashOnHand = ref12.getCashOnHand, _configFormula = ref12.configFormula, configFormula = _configFormula.data;
    var multiplier = (dayTradeInfo || {}).multiplier;
    var ref13 = (0,RealTradingModal_store/* default */.Z)(), configType = ref13.configType, price = ref13.price, expiry = ref13.expiry, triggerPrice = ref13.triggerPrice, shares = ref13.shares, buyOrderType = ref13.type, isSplitOrderActive = ref13.isSplitOrderActive, splitQuantity = ref13.splitQuantity, splitRangeMin = ref13.splitRangeMin, splitRangeMax = ref13.splitRangeMax, splitMethod = ref13.splitMethod, setTriggerPrice = ref13.setTriggerPrice, setPrice = ref13.setPrice, setExpiry = ref13.setExpiry, setConfigType = ref13.setConfigType, setOrderType = ref13.setOrderType, setShares = ref13.setShares, setSplitOrderActive = ref13.setSplitOrderActive, setSplitQuantity = ref13.setSplitQuantity, setSplitRange = ref13.setSplitRange, setSplitMethod = ref13.setSplitMethod, setDayTradeActive = ref13.setDayTradeActive, setDayTadeMultiplier = ref13.setDayTadeMultiplier;
    var isShowSplitOrder = useEnableSplitOrder("buy");
    var isUserSyariah = (0,useIsUserSyariah/* default */.Z)();
    var isMainAccount = (0,useIsSecuritiesMainAccount/* default */.Z)();
    var isSaham = productType.toLowerCase() === trading/* STOCK_TYPE.saham */.L2.saham;
    var isRight = productType.toLowerCase() === trading/* STOCK_TYPE.right */.L2.right;
    var isAmend = orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY;
    var isShowOrderType = buyOrderType && isSaham && showCreateSmartOrder && !isAmend;
    var originalLot = shares / constant/* lotSize */.CQ;
    var isTradeable = tradeable === 1;
    // trigger price must be > 0, if order type is Auto Buy
    var triggerAutoBuy = buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy && Number(triggerPrice) === 0;
    var hideExpiry = !isSaham || isAmend;
    var dayTradeMultiplier = parseInt(multiplier, 10);
    var isPaymentDayTradeActive = paymentMethod === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
    var isPaymentTradingLimitActive = paymentMethod === transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit;
    // Disable day trade if multiplier is below 1
    var isPaymentDayTradeDisabled = (0,react.useMemo)(function() {
        return dayTradeMultiplier <= 1;
    }, [
        dayTradeMultiplier
    ]);
    // Hide or show payment leverage (Trading Limit / Day Trade) - Buy Order
    var isPaymentMethodDisabled = (0,react.useMemo)(function() {
        var isOrderTypeAutoBuy = buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy;
        var isExpiryGtc = expiry === transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled;
        return [
            isOrderTypeAutoBuy,
            isExpiryGtc,
            isAmend,
            !isSaham,
            isUserSyariah,
            !isMainAccount, 
        ].includes(true);
    }, [
        buyOrderType,
        expiry,
        dayTradeMultiplier,
        isAmend,
        isSaham,
        isUserSyariah,
        isMainAccount, 
    ]);
    // Hide or show payment leverage (Trading Limit / Day Trade) - Amend Order
    var isShowAmendLeverage = (0,react.useMemo)(function() {
        return isDayTrade && isAmend;
    }, [
        isDayTrade,
        isAmend
    ]);
    var isTradingLimitTooltipActive = (0,react.useMemo)(function() {
        return [
            !isPaymentMethodDisabled,
            !isTradingLimitTooltipOpened,
            isShowOrderType,
            false
        ].every(function(value) {
            return value;
        });
    }, [
        isPaymentMethodDisabled,
        isTradingLimitTooltipOpened,
        isShowOrderType
    ]);
    // Balance for payment method (leverage) modal
    var leverageBalanceList = (0,react.useMemo)(function() {
        var _obj;
        var balance = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, tradingLimit), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, dayTradeBuyingPower), _obj);
        // Remove day trade balance if multiplier is below 1
        if (dayTradeMultiplier <= 1) {
            delete balance[transaction/* PaymentMethod.DayTrade */.XL.DayTrade];
        }
        return balance;
    }, [
        tradingLimit,
        dayTradeBuyingPower,
        dayTradeMultiplier
    ]);
    var tracksWidth = (0,react.useMemo)(function() {
        return getCashTracks(paymentMethod, tradingBalance, tradingLimit);
    }, [
        paymentMethod,
        tradingBalance,
        tradingLimit
    ]);
    var ref14 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), username = ref14.data.username;
    var available_cash_on_hand = cashOnHand.data.available_cash_on_hand;
    var limitLot = (0,react.useMemo)(function() {
        var buyOrderDayTrade = isPaymentDayTradeActive;
        // New limit lot calculation for amend order
        // If user is day trade and day trade is active, use active trading balance (from buying power)
        // No need to add fee and matched total because it's already included in the buying power
        // Otherwise, use original trading balance plus fee and matched total
        if (isAmend) {
            var amendTradingBalance = isDayTrade ? activeTradingBalance : activeTradingBalance + (amount_open_fee || 0) + (amount_matched_total || 0);
            return (0,formula/* getLimitLot */.J0)(amendTradingBalance, price, buyOrderDayTrade) || 1;
        }
        // Set limit to 1 when limit lot equal zero to enable slider to 100%
        return (0,formula/* getLimitLot */.J0)(activeTradingBalance, price, buyOrderDayTrade) || 1;
    }, [
        activeTradingBalance,
        price,
        isPaymentDayTradeActive,
        isAmend
    ]);
    var ref15 = (0,TransactionModal_utils/* generateTradingVariable */.Jg)({
        configFormula: configFormula,
        cash_on_hand: available_cash_on_hand,
        trading_balance: activeTradingBalance,
        price: price,
        lot: originalLot,
        trigger_price: triggerPrice || 0,
        config_type: configType || 0,
        order_type: orderType,
        previous_buy_price: orderedPrice,
        previous_lot: orderedLot,
        stock_type: productType,
        trading_balance_amended: activeTradingBalance + (amount_open_fee || 0) + (amount_matched_total || 0),
        cash_onhand_amended: available_cash_on_hand + (amount_open_fee || 0) + (amount_matched_total || 0),
        isDayTrade: isPaymentDayTradeActive
    }), tradingbalance = ref15.TRADING_BALANCE, investmentPlusFee = ref15.BUY_AMOUNT_FEE, lot = ref15.LOT;
    var isOverlimit = investmentPlusFee > tradingbalance;
    var isDisabledBuySplitOrder = (0,react.useMemo)(function() {
        if (!isSplitOrderActive) {
            return false;
        }
        if (splitQuantity === null || splitQuantity < 1) {
            return true;
        }
        if (splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM && (!splitRangeMin || !splitRangeMax)) {
            return true;
        }
        return false;
    }, [
        isSplitOrderActive,
        splitQuantity,
        splitMethod,
        splitRangeMin,
        splitRangeMax, 
    ]);
    var disableBuy = (0,react.useMemo)(function() {
        return price === 0 || lot < 1 || !isTradeable || isOverlimit || triggerAutoBuy || hasFormError || isDisabledBuySplitOrder;
    }, [
        hasFormError,
        isTradeable,
        isOverlimit,
        price,
        lot,
        triggerAutoBuy,
        isDisabledBuySplitOrder, 
    ]);
    var showSplitOrderForm = (0,react.useMemo)(function() {
        return isShowSplitOrder && paymentMethod === transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance;
    }, [
        isShowSplitOrder,
        paymentMethod
    ]);
    // Get balance label based on payment method (leverage)
    var getBalanceLabel = (0,react.useCallback)(function() {
        if (isRight) return constants_transactionForm/* balanceLabel.cashOnHand */.Hg.cashOnHand;
        var dayTradeEnable = isPaymentDayTradeActive && dayTradeMultiplier > 1;
        if (dayTradeEnable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    constants_transactionForm/* balanceLabel.dayTrade */.Hg.dayTrade,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                        className: "multiplier-chip",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: Icons/* LightningSvg */.Sf
                            }),
                            "".concat(multiplier, "x")
                        ]
                    })
                ]
            });
        }
        return isPaymentTradingLimitActive ? constants_transactionForm/* balanceLabel.tradingLimit */.Hg.tradingLimit : constants_transactionForm/* balanceLabel.tradingBalance */.Hg.tradingBalance;
    }, [
        isRight,
        isPaymentDayTradeActive,
        dayTradeMultiplier,
        paymentMethod
    ]);
    var getMaxLot = function() {
        if (orderedPrice && price === orderedPrice) return orderedLot;
        return (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
    };
    var getSliderMaxLot = function() {
        var lotOrderLimit = (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
        return limitLot > lotOrderLimit ? lotOrderLimit : limitLot;
    };
    var getPercentage = function() {
        var percentage = Math.round(100 * lot / limitLot);
        if (Number.isNaN(percentage) || percentage === Infinity) {
            return "0";
        }
        return percentage;
    };
    var handleValidateAllFields = function() {
        form.validateFields();
    };
    var handleSetPaymentMethod = function(method) {
        setPaymentMethod(method);
        setUIValue("transactionPaymentMethod", method);
        if (method !== transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance) {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
        if (method !== paymentMethod && !isAmend) {
            setShares(0);
        }
    };
    var handleLoadCashInfo = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var cashOrderId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (!cashInfoLoaded) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    cashOrderId = isAmend && isDayTrade ? orderId : undefined;
                    _ctx.next = 6;
                    return loadCashInfo(symbol, cashOrderId);
                case 6:
                    setCashInfoLoaded(true);
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    })), [
        cashInfoLoaded,
        setCashInfoLoaded
    ]);
    var handleSaveFields = function() {
        var values = form.getFieldsValue();
        if (isShowSplitOrder && !isPaymentDayTradeActive) {
            setSplitOrderActive(!!values.isSplitOrderActive);
            setSplitQuantity(values.splitQuantity);
            setSplitRange(values.splitRangeMin, values.splitRangeMax);
        } else {
            setSplitOrderActive(false);
            setSplitQuantity(null);
            setSplitRange(null, null);
        }
        var DayTradeOrder = isDayTrade || isPaymentDayTradeActive;
        setDayTradeActive(DayTradeOrder);
        setDayTadeMultiplier(DayTradeOrder ? dayTradeMultiplier : 0);
    };
    var handleFieldsChange = function(_, allFields) {
        var hasEmpty = allFields.some(function(param) {
            var value = param.value;
            return value === undefined;
        });
        var hasError = allFields.some(function(param) {
            var errors = param.errors;
            return errors.length > 0;
        });
        setHasFormError(hasEmpty || hasError);
    };
    var handleOrderTypeChange = function(selectedOrderType) {
        var isSelectedAutoBuy = selectedOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy;
        if (isSelectedAutoBuy) {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
        if (isSelectedAutoBuy && !(0,TransactionModal_utils/* checkIsAutoOrderTncAgreed */.KK)(username, types_autoOrder/* AutoOrderProduct.AutoBuy */.V.AutoBuy)) {
            showAutoBuyTncModal();
            return;
        }
        setOrderType(selectedOrderType);
        setAutoBuy(isSelectedAutoBuy);
        if (isSelectedAutoBuy) handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        (0,autoOrder/* trackAutoBuyOrderTypeSelected */.dM)(selectedOrderType, symbol);
        (0,securities/* clevertapDayTradeOrderTypeSelected */.$v)(symbol, (0,analytics/* generateOrderTypeLabel */.JH)(selectedOrderType));
    };
    var handleBalanceLabelClick = function() {
        setPaymentMethodVisible(true);
        handleLoadCashInfo();
    };
    var handleTradingLimitTooltipChange = function(value) {
        if (!value) setUIValue("tradingLimitTooltip", !value);
    };
    var handlePriceChange = function(value) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        setPrice(value);
        handleValidateAllFields();
        if (isAmend) {
            var PRICE = Number(value);
            var LOT = Math.round(Number(originalLot));
            var lotAmend = (0,TransactionModal_utils/* calculateLotAmendTransaction */.xl)(orderedPrice, orderedLot, PRICE, LOT);
            setShares(lotAmend * constant/* lotSize */.CQ);
        }
    };
    var handleMethodChange = function(method) {
        // Handle when use click both tooltip and balance button
        if (isTradingLimitTooltipActive) setUIValue("tradingLimitTooltip", true);
        if (method === transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit) {
            onShowTradingLimitTnc();
        }
        setPaymentMethodVisible(false);
        handleSetPaymentMethod(method);
    };
    var handleMethodClose = function() {
        setPaymentMethodVisible(false);
    };
    var handleOrderTypeInfoClick = function() {
        showOrderTypeModal();
        (0,autoOrder/* trackAutoBuyOrderTypeInfoSelected */._E)(trading/* BUY_ORDER_TYPE_TEXT */.x4[orderType], symbol);
    };
    var handleLotChange = function(value) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        var roundLot = Math.floor(value);
        setShares(roundLot * constant/* lotSize */.CQ);
        handleValidateAllFields();
    };
    var handleExpiryChange = function(e) {
        var selectedExpiry = e.target.value;
        setExpiry(selectedExpiry);
        if (selectedExpiry === transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled) {
            handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        } else {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
        handleValidateAllFields();
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var day_trade, isTimeLimit, isUnavailable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleSaveFields();
                        if (!isPaymentDayTradeActive) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 4;
                        return loadTradingInfo([
                            types_trading/* TradingFeatureEnum.DAY_TRADE */.n5.DAY_TRADE, 
                        ]);
                    case 4:
                        day_trade = _ctx.sent.day_trade;
                        if (!day_trade) {
                            _ctx.next = 11;
                            break;
                        }
                        isTimeLimit = day_trade.remaining_trading_close <= 0;
                        isUnavailable = [
                            types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.by.EXCEED_DEBT_RATIO,
                            types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.by.OUTSIDE_MARKET_HOURS, 
                        ].includes(day_trade === null || day_trade === void 0 ? void 0 : day_trade.event_type);
                        if (!(isUnavailable || isTimeLimit)) {
                            _ctx.next = 11;
                            break;
                        }
                        onShowDayTradeUnavailable();
                        return _ctx.abrupt("return");
                    case 11:
                        onSubmit();
                        (0,securities/* clevertapOrderPlaced */.As)({
                            orderType: orderType,
                            symbol: symbol,
                            price: price,
                            lot: lot,
                            tradingBalancePercentage: getPercentage(),
                            status: disableBuy ? "failed" : "success",
                            expiry: constants_transactionForm/* expiryOptions */.Me[expiry],
                            type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading,
                            orderTypeStatus: (0,analytics/* generateOrderTypeLabel */.JH)(buyOrderType),
                            splitOrder: isSplitOrderActive,
                            dayTrade: isPaymentDayTradeActive
                        });
                        if (buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) (0,autoOrder/* trackAutoBuyOrderPlaced */.pR)();
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeSwitchSplitOrder = function(checked) {
        setSplitOrderActive(checked);
        if (!checked) {
            setSplitMethod(transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM);
        }
        if (isPaymentDayTradeActive && checked) {
            setPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        }
        (0,securities/* clevertapDayTradeSplitOrderSelected */.F9)(checked);
    };
    (0,react.useEffect)(function() {
        if (isRight) getCashOnHand();
        (0,autoOrder/* trackAutoBuyOrderView */.PH)();
    }, [
        isRight
    ]);
    (0,react.useEffect)(function() {
        if (isAmend) {
            if (orderedPrice) setPrice(orderedPrice);
            if (trigger_price) setTriggerPrice(trigger_price);
            if (orderedLot) setShares(orderedLot * constant/* lotSize */.CQ);
            if (constant/* triggerPriceOption */.mr) {
                setConfigType(constant/* triggerPriceOption */.mr[config_type - 1]);
            }
        }
        if (isAutoBuy) {
            setOrderType(transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy);
            handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        } else {
            setOrderType(transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder);
        }
        if (!isSaham) {
            setExpiry(transaction/* Expiry.GoodForDay */.ZM.GoodForDay);
            setAutoBuy(false);
            setOrderType(transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder);
        }
    }, [
        orderType,
        isAutoBuy
    ]);
    (0,react.useEffect)(function() {
        if (isOverlimit) (0,securities/* clevertapBuyError */.xC)();
    }, [
        isOverlimit
    ]);
    (0,react.useEffect)(function() {
        if (paymentMethod || isAmend) {
            handleLoadCashInfo();
        }
    }, [
        handleLoadCashInfo,
        paymentMethod,
        isAmend
    ]);
    (0,react.useEffect)(function() {
        if (isPaymentMethodDisabled || isPaymentDayTradeDisabled && defaultPaymentMethod === transaction/* PaymentMethod.DayTrade */.XL.DayTrade) {
            setPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        }
        if (isAmend && isDayTrade) {
            setPaymentMethod(transaction/* PaymentMethod.DayTrade */.XL.DayTrade);
        }
    }, [
        isPaymentMethodDisabled,
        isPaymentDayTradeDisabled,
        isAmend,
        isDayTrade
    ]);
    (0,react.useEffect)(function() {
        form.validateFields();
        (0,securities/* clevertapBuyOrderViewed */.A2)(symbol, modalData === null || modalData === void 0 ? void 0 : modalData.source);
        // Reset payment method if symbol changed from search
        if (modalData === null || modalData === void 0 ? void 0 : modalData.openFromSearch) {
            handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
            setModalState({
                modalData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalData), {
                    openFromSearch: false
                })
            });
        }
    }, []);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeLeverage */.g0, {
                zIndex: 1001,
                balance: leverageBalanceList,
                tradingBalance: tradingbalance,
                error: (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, !!cashInfoError), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, !!cashInfoError), _obj),
                methodValue: paymentMethod,
                visible: isPaymentMethodVisible,
                loading: isCashInfoLoading,
                onMethodChange: handleMethodChange,
                onCancel: handleMethodClose,
                onReloadClick: function() {
                    return loadCashInfo(symbol);
                },
                destroyOnClose: true,
                symbol: symbol,
                splitOrderActive: isSplitOrderActive,
                dayTradeAvailable: isDayTradeSubAccountActive,
                dayTradeMultiplier: dayTradeMultiplier,
                onShowDayTradeOnboarding: onShowDayTradeOnboarding
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: marketHour.suspend_info,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpecialMonitoringBanner, {
                    onClick: showSpecialMonitoringModal,
                    title: marketHour.suspend_info
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* TransactionForm */.vQ, {
                form: form,
                colon: false,
                labelCol: {
                    span: 12
                },
                onFinish: handleSubmit,
                onFieldsChange: handleFieldsChange,
                onBlur: handleSaveFields,
                onValuesChange: handleSaveFields,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* FieldsWrapper */.V$, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isShowOrderType,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_OrderTypeFormItem, {
                                    form: form,
                                    transactionType: transaction/* TransactionType.Buy */.iU.Buy,
                                    defaultValue: buyOrderType,
                                    onChange: handleOrderTypeChange,
                                    onInfoIconClick: handleOrderTypeInfoClick
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isPaymentMethodDisabled || isShowAmendLeverage,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: "Leverage",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeverageButton, {
                                        paymentMethod: paymentMethod,
                                        multiplier: dayTradeMultiplier,
                                        enableDayTrade: dayTradeMultiplier > 1,
                                        isAmend: isAmend,
                                        onMethodChange: handleMethodChange,
                                        onOpenModalLeverage: handleBalanceLabelClick
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* BalanceButton */.RP, {
                                    type: "button",
                                    onClick: handleBalanceLabelClick,
                                    disabled: true,
                                    children: [
                                        getBalanceLabel(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: !isPaymentMethodDisabled,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Tooltip, {
                                                placement: "bottom",
                                                title: "Tingkatkan buying power kamu dengan Trading Limit",
                                                visible: isTradingLimitTooltipActive,
                                                onVisibleChange: handleTradingLimitTooltipChange,
                                                trigger: "click",
                                                arrowPointAtCenter: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                    condition: isTradingLimitTooltipActive,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        component: ChevronDownSvg/* default */.Z,
                                                        style: {
                                                            color: "#969696"
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    family: "bold",
                                    children: (0,number/* formatNumber */.uf)(tradingbalance, true, isOverlimit ? "0,0.00" : "0,0")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isAmend || isAmend && (isAutoBuy || isSaham),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    className: "slider-form-item",
                                    label: "",
                                    wrapperCol: {
                                        xs: {
                                            offset: 0
                                        },
                                        sm: {
                                            span: 12,
                                            offset: 12
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                                                min: 0,
                                                max: getSliderMaxLot(),
                                                value: lot,
                                                tracksWidth: tracksWidth,
                                                tipFormatter: null,
                                                onChange: function(newLot) {
                                                    // If newLot is more than max Lot, don't update the value
                                                    if (isAmend && newLot > getMaxLot()) {
                                                        // if ordered price is same as price, set shares to ordered lot (max lot)
                                                        if (orderedPrice === price) {
                                                            setShares(orderedLot * constant/* lotSize */.CQ);
                                                        }
                                                        return;
                                                    }
                                                    (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
                                                        symbol: symbol,
                                                        orderType: orderType,
                                                        adjustedType: "slider"
                                                    });
                                                    setShares(Math.ceil(newLot) * constant/* lotSize */.CQ);
                                                    handleValidateAllFields();
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* SliderPercentText */.fx, {
                                                children: [
                                                    getPercentage(),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Investment (Plus Fee)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                    family: "bold",
                                    children: [
                                        "Rp",
                                        " ",
                                        (0,number/* formatNumber */.uf)(investmentPlusFee, true, isOverlimit ? "0,0.00" : "0,0")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isAutoBuy,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TriggerPriceTooltip, {}),
                                    "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_TRIGGER_PRICE */.eG.FORM_TRIGGER_PRICE,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TriggerPriceSelect */.d2, {
                                                value: constant/* triggerPriceOption */.mr[configType - 1],
                                                onChange: function(e) {
                                                    setConfigType(e.target.value);
                                                    (0,autoOrder/* trackAutoBuyTriggerConditionSelected */.ZY)({
                                                        1: "≥",
                                                        2: '"≤"'
                                                    }[e.target.value]);
                                                    handleValidateAllFields();
                                                },
                                                "data-cy": constant/* DATA_CY_MODAL_TRADING.TRIGGER_PRICE_SELECT */.eG.TRIGGER_PRICE_SELECT,
                                                children: constant/* triggerPriceOption.map */.mr.map(function(opt) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        children: opt
                                                    }, opt);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                                containerStyle: {
                                                    marginLeft: 4,
                                                    height: 32
                                                },
                                                defaultValue: triggerPrice,
                                                value: triggerPrice,
                                                min: 0,
                                                step: 1,
                                                onChange: function(trigger) {
                                                    setTriggerPrice(trigger);
                                                    handleValidateAllFields();
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: isAutoBuy ? "Buy Price" : "Price",
                                "data-cy": isAutoBuy ? constant/* DATA_CY_MODAL_TRADING.FORM_BUY_PRICE */.eG.FORM_BUY_PRICE : constant/* DATA_CY_MODAL_TRADING.FORM_PRICE */.eG.FORM_PRICE,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    value: price,
                                    min: 0,
                                    step: (0,transactionPrice/* getStepFractionByValue */.Z)(price),
                                    onChange: handlePriceChange,
                                    disableDecimal: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Buy Order Lot",
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_LOT */.eG.FORM_LOT,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    defaultValue: 0,
                                    min: 0,
                                    value: lot,
                                    max: getMaxLot(),
                                    onChange: handleLotChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isOverlimit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverLimitText/* default */.Z, {
                                    isRight: isRight
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !hideExpiry,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: "Expiry",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CustomSelect */.AP, {
                                        value: expiry,
                                        onChange: handleExpiryChange,
                                        style: {
                                            width: "160px"
                                        },
                                        disabled: isPaymentDayTradeActive,
                                        "daya-cy": constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT */.eG.EXPIRY_SELECT,
                                        children: Object.entries(constants_transactionForm/* expiryOptions */.Me).map(function(param) {
                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: key,
                                                children: value
                                            }, key);
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: showSplitOrderForm,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_SplitOrderFormItem, {
                                    form: form,
                                    orderLot: lot,
                                    checkedInitialValue: isSplitOrderActive,
                                    quantityInitialValue: splitQuantity,
                                    minRangeInitialValue: splitRangeMin,
                                    maxRangeInitialValue: splitRangeMax,
                                    maxQuantity: maxOrder,
                                    transactionType: transaction/* TransactionType.Buy */.iU.Buy,
                                    onInfoIconClick: onShowSplitOrderInfo,
                                    onSwitchChange: handleChangeSwitchSplitOrder,
                                    onSplitMethodInfoClick: onShowSplitOrderMethodInfo
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* ButtonWrapper */.W4, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* OrderButton */.sg, {
                            disabled: disableBuy,
                            type: "primary",
                            htmlType: "submit",
                            radius: "4px",
                            block: true,
                            height: "40px",
                            "data-cy": constant/* DATA_CY_MODAL_TRADING.BUTTON_PLACE_ORDER */.eG.BUTTON_PLACE_ORDER,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                children: "Place Order"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionModal_FormBuy = (/*#__PURE__*/(0,react.memo)(FormBuy));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/features/day-trade/components/SellLeverage/sell-levarage.styled.ts

function sell_levarage_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n"
    ]);
    sell_levarage_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & span.ant-radio {\n    top: 0;\n  }\n\n  & span.ant-radio-inner {\n    width: 16px;\n    height: 16px;\n  }\n\n  & span.ant-radio-inner::after {\n    top: 50%;\n    left: 50%;\n    width: 11px;\n    height: 11px;\n    transform: translate(-50%, -50%);\n  }\n"
    ]);
    sell_levarage_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    sell_levarage_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 8px;\n"
    ]);
    sell_levarage_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  min-height: 30px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    sell_levarage_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row;\n"
    ]);
    sell_levarage_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  font-size: 14px;\n  color: #333333;\n\n  p {\n    margin: 0;\n    text-wrap: nowrap;\n  }\n\n  svg {\n    color: #969696;\n  }\n"
    ]);
    sell_levarage_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding-top: 2px;\n\n  p {\n    margin: 0;\n    font-size: 12px;\n    text-wrap: nowrap;\n    color: #858585;\n    margin-top: 1px;\n  }\n"
    ]);
    sell_levarage_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var AntGroup = es_radio/* default.Group */.ZP.Group;
var RadioGroup = (0,styled_components_browser_esm/* default */.ZP)(AntGroup).withConfig({
    componentId: "sc-cbd8ca-0"
})(sell_levarage_styled_templateObject());
var Radio = (0,styled_components_browser_esm/* default */.ZP)(es_radio/* default */.ZP).withConfig({
    componentId: "sc-cbd8ca-1"
})(sell_levarage_styled_templateObject1());
var sell_levarage_styled_LeverageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbd8ca-2"
})(sell_levarage_styled_templateObject2());
var LeverageGroup = (0,styled_components_browser_esm/* default */.ZP)(RadioGroup).withConfig({
    componentId: "sc-cbd8ca-3"
})(sell_levarage_styled_templateObject3());
var LeverageItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbd8ca-4"
})(sell_levarage_styled_templateObject4(), function(param) {
    var isSelected = param.isSelected;
    return isSelected && "padding: 4px 8px; border: 1px solid #EDEDED;";
});
var LeverageTextContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbd8ca-5"
})(sell_levarage_styled_templateObject5());
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbd8ca-6"
})(sell_levarage_styled_templateObject6());
var LabelLot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbd8ca-7"
})(sell_levarage_styled_templateObject7());


;// CONCATENATED MODULE: ./src/features/day-trade/components/SellLeverage/sell-leverage.tsx






function SellLeverage(param) {
    var _dayTradeLot = param.dayTradeLot, dayTradeLot = _dayTradeLot === void 0 ? 0 : _dayTradeLot, _regularLot = param.regularLot, regularLot = _regularLot === void 0 ? 0 : _regularLot, isAmend = param.isAmend, leverage = param.leverage, handleChangeLeverage = param.handleChangeLeverage;
    var REGULAR = RealTradingModal_types/* LEVERAGE.REGULAR */.h$.REGULAR, DAY_TRADE = RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE;
    var isHidden = regularLot <= 0 || isAmend;
    var isRegularEmpty = function(value) {
        return value === REGULAR && isHidden;
    };
    var isDayTradeHidden = function(value) {
        return value === DAY_TRADE && isHidden;
    };
    var SellLeverageOptions = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                component: Icons/* LightningSvg */.Sf
            }),
            value: DAY_TRADE,
            label: "Day Trade",
            lot: dayTradeLot
        },
        {
            icon: null,
            value: REGULAR,
            label: "Regular",
            lot: regularLot
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sell_levarage_styled_LeverageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeverageGroup, {
            value: leverage,
            children: SellLeverageOptions.map(function(param) {
                var icon = param.icon, value = param.value, label = param.label, lot = param.lot;
                if (isRegularEmpty(value)) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageItem, {
                    onClick: function() {
                        return handleChangeLeverage(value);
                    },
                    isSelected: isDayTradeHidden(value),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                            condition: !isDayTradeHidden(value),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                                value: value
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageTextContent, {
                            onClick: function(e) {
                                return e.stopPropagation();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: label
                                        }),
                                        icon
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelLot, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            lot,
                                            " Lot"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }, value);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormSell.tsx









// components







// hooks


// libs



// stores



// utils





// constants



// types




// styles


var calculateSliderPercentage = function(lotTransaction, maxLot) {
    // Odd lot need to round down
    var lotAvailabletoSell = Math.floor(maxLot);
    var sliderValue = lotTransaction / lotAvailabletoSell;
    var percentage = !Number.isNaN(sliderValue) ? Math.round(sliderValue * 100) : 0;
    if (percentage === Infinity) return 0;
    if (percentage > 100) return 100;
    return percentage;
};
var calculateMaxLotInput = function(price, previous_sell_price, available_lot) {
    var original_available_lot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, isAmend = arguments.length > 4 ? arguments[4] : void 0;
    var isUserDoAmend = isAmend && previous_sell_price !== price;
    var maxLotToAmend = Math.floor(available_lot + original_available_lot);
    var maxLotToSell = Math.floor(original_available_lot);
    return isUserDoAmend ? maxLotToAmend : maxLotToSell;
};
var FormSell = function(param) {
    var showSpecialMonitoringModal = param.showSpecialMonitoringModal, _onShowSplitOrderInfo = param.onShowSplitOrderInfo, onShowSplitOrderInfo = _onShowSplitOrderInfo === void 0 ? function() {} : _onShowSplitOrderInfo, _onShowSplitOrderMethodInfo = param.onShowSplitOrderMethodInfo, onShowSplitOrderMethodInfo = _onShowSplitOrderMethodInfo === void 0 ? function() {} : _onShowSplitOrderMethodInfo, onSubmit = param.onSubmit, _onShowDayTradeUnavailable = param.onShowDayTradeUnavailable, onShowDayTradeUnavailable = _onShowDayTradeUnavailable === void 0 ? function() {} : _onShowDayTradeUnavailable;
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)(false), hasFormError = ref1[0], setHasFormError = ref1[1];
    var isShowSplitOrder = useEnableSplitOrder("sell");
    var ref2 = (0,tradingData/* default */.Z)(), _company = ref2.company, _data = _company.data, marketHour = _data.market_hour, productType = _data.type_company, dayTradeInfo = _data.day_trade_info, _portfolioDetailDayTrade = ref2.portfolioDetailDayTrade, detailDayTrade = _portfolioDetailDayTrade.data, getCashOnHand = ref2.getCashOnHand;
    var loadTradingInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.loadTradingInfo;
    });
    var splitOrder = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.splitOrder;
    });
    var ref3 = splitOrder || {}, maxOrder = ref3.max_order;
    var multiplier = (dayTradeInfo || {}).multiplier;
    var ref4 = (0,TradingModal_store/* default */.Z)(), orderedPrice = ref4.orderedPrice, orderedLot = ref4.orderedLot, isDayTrade = ref4.isDayTrade;
    var ref5 = (0,useTradingStore/* default */.Z)(function(s) {
        return {
            symbol: s.symbol,
            orderType: s.orderType
        };
    }), symbol = ref5.symbol, orderType = ref5.orderType;
    var ref6 = (0,RealTradingModal_store/* default */.Z)(), price = ref6.price, shares = ref6.shares, expiry = ref6.expiry, sellOrderType = ref6.type, isSplitOrderActive = ref6.isSplitOrderActive, splitQuantity = ref6.splitQuantity, splitRangeMin = ref6.splitRangeMin, splitRangeMax = ref6.splitRangeMax, splitMethod = ref6.splitMethod, leverage = ref6.sellLeverage, setPrice = ref6.setPrice, setShares = ref6.setShares, setExpiry = ref6.setExpiry, setOrderType = ref6.setOrderType, setSplitOrderActive = ref6.setSplitOrderActive, setSplitQuantity = ref6.setSplitQuantity, setSplitRange = ref6.setSplitRange, setSplitMethod = ref6.setSplitMethod, setLeverage = ref6.setSellLeverage, setDayTradeActive = ref6.setDayTradeActive, setDayTadeMultiplier = ref6.setDayTadeMultiplier;
    var getPortfolioDetail = (0,useGetPortfolioData/* default */.Z)(symbol);
    var isDayTradeActive = leverage === RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE;
    var isAmend = orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isSaham = productType.toLowerCase() === trading/* STOCK_TYPE.saham */.L2.saham;
    var isRight = productType.toLowerCase() === trading/* STOCK_TYPE.right */.L2.right;
    var isCorporateAction = (0,react.useMemo)(function() {
        return trading/* CorporateActionStockType.includes */.dB.includes(productType.toLowerCase());
    }, [
        productType
    ]);
    var hideExpiry = (0,react.useMemo)(function() {
        return !isSaham || isAmend || sellOrderType !== transaction/* SellOrderType.LimitOrder */.qK.LimitOrder;
    }, [
        isSaham,
        isAmend,
        sellOrderType
    ]);
    var showOrderType = (0,react.useMemo)(function() {
        return isSaham && sellOrderType;
    }, [
        isSaham,
        sellOrderType
    ]);
    var tmp = getPortfolioDetail.available_lot, availableLot = tmp === void 0 ? 0 : tmp, tmp1 = getPortfolioDetail.price_average_fee, priceAverageFee = tmp1 === void 0 ? 0 : tmp1;
    var tmp2 = detailDayTrade.available_lot, availableLotDayTrade = tmp2 === void 0 ? 0 : tmp2, tmp3 = detailDayTrade.price_average_fee, priceAverageFeeDayTrade = tmp3 === void 0 ? 0 : tmp3;
    // Get available lot and price average fee based on user day trade or user regular
    var ref7 = (0,react.useMemo)(function() {
        var RegularSell = [
            availableLot,
            priceAverageFee
        ];
        var DayTradeSell = [
            availableLotDayTrade,
            priceAverageFeeDayTrade
        ];
        // If order is amend, return based on order type, if not return based on user day trade
        // isDayTrade is true if user click amend button from order which is day trade
        if (isAmend) {
            return isDayTrade ? DayTradeSell : RegularSell;
        }
        // If order is not amend, return based on user day trade
        var regularLotAvailable = availableLot > 0;
        var dayTradeLotAvailable = availableLotDayTrade > 0;
        // If user have both regular and day trade lot, leverage will not selected
        if (!leverage) {
            // user have both regular and day trade lot, return 0 so user have to select leverage
            if (regularLotAvailable && dayTradeLotAvailable) {
                return [
                    0,
                    0
                ];
            }
        }
        // If user have day trade lot and leverage is selected, return day trade sell
        // Else return regular sell
        return isDayTradeActive && dayTradeLotAvailable ? DayTradeSell : RegularSell;
    }, [
        availableLot,
        priceAverageFee,
        availableLotDayTrade,
        priceAverageFeeDayTrade,
        isAmend,
        isDayTrade,
        leverage,
        isDayTradeActive, 
    ]), available_lot = ref7[0], price_average_fee = ref7[1];
    // originalAvailableLot is used to calculate max lot input
    // If user is day trade and not amend, available lot is based on day trade
    var originalAvailableLot = (0,react.useMemo)(function() {
        if (!isAmend) {
            return available_lot;
        }
        return orderedLot || available_lot;
    }, [
        isAmend,
        available_lot,
        orderedLot
    ]);
    // availableLotToSell is used to show available lot to sell
    var availableLotToSell = (0,react.useMemo)(function() {
        // Check if user is day trade and not amend, return day trade available lot if available
        if (!isAmend && !leverage && availableLotDayTrade > 0) {
            return availableLot <= 0 ? availableLotDayTrade : "-";
        }
        return isAmend ? available_lot + orderedLot : available_lot;
    }, [
        availableLot,
        availableLotDayTrade,
        isAmend,
        leverage,
        available_lot,
        orderedLot, 
    ]);
    // isDayTradeSell is used to check if user is day trade and sell order is active
    // isDayTrade is true if user click amend button from order which is day trade (amend)
    // isDayTradeActive is true if user have day trade lot and leverage is selected (new order)
    var isDayTradeSell = (0,react.useMemo)(function() {
        return isAmend ? isDayTrade : isDayTradeActive;
    }, [
        isAmend,
        isDayTrade,
        isDayTradeActive
    ]);
    // isLeverageEnabled is used to show sell leverage component
    var isLeverageEnabled = (0,react.useMemo)(function() {
        // If amend regular order, return false
        if (isAmend && !isDayTrade) {
            return false;
        }
        // If order is amend and day trade, return true
        if (isAmend && isDayTrade) {
            return true;
        }
        // If user have day trade lot and leverage is not selected, return true
        return availableLotDayTrade > 0;
    }, [
        isAmend,
        isDayTrade,
        availableLotDayTrade
    ]);
    // isDisabledInput is used to disable input if have day trade lot and leverage is not selected
    var isDisabledInput = (0,react.useMemo)(function() {
        return !isAmend && !leverage && availableLotDayTrade > 0;
    }, [
        isAmend,
        leverage,
        availableLotDayTrade,
        availableLot
    ]);
    var lot = (0,react.useMemo)(function() {
        var lotOrderLimit = (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
        var userLot = typeof shares === "number" ? Math.floor(shares / constant/* lotSize */.CQ) : available_lot;
        return Math.floor(userLot > lotOrderLimit ? lotOrderLimit : userLot);
    }, [
        shares,
        constant/* lotSize */.CQ,
        available_lot
    ]);
    var isDisabledSellSplitOrder = (0,react.useMemo)(function() {
        if (!isSplitOrderActive) {
            return false;
        }
        if (splitQuantity === null || splitQuantity < 1) {
            return true;
        }
        if (splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM && (!splitRangeMin || !splitRangeMax)) {
            return true;
        }
        return false;
    }, [
        isSplitOrderActive,
        splitQuantity,
        splitMethod,
        splitRangeMin,
        splitRangeMax, 
    ]);
    var isSubmitDisabled = (0,react.useMemo)(function() {
        return lot < 1 || price === 0 || hasFormError || isDisabledSellSplitOrder;
    }, [
        lot,
        price,
        hasFormError,
        isSplitOrderActive,
        isDisabledSellSplitOrder
    ]);
    var showSplitOrderForm = (0,react.useMemo)(function() {
        return isShowSplitOrder && !isDayTradeActive;
    }, [
        isShowSplitOrder,
        isDayTradeActive
    ]);
    var maxLot = calculateMaxLotInput(price, orderedPrice, available_lot, originalAvailableLot, isAmend);
    var lotPercentage = calculateSliderPercentage(lot, maxLot);
    var sellAmountInvestedFee = (0,formula/* getSellAmountInvestedFee */.B1)(lot, price, isCorporateAction, isDayTradeSell);
    var buyAmountInvestedAveragePriceFee = (0,formula/* getBuyAmountInvested */.yq)(lot, price_average_fee);
    var sellProfitLoss = (0,formula/* getProfitLoss */.fY)(sellAmountInvestedFee, buyAmountInvestedAveragePriceFee);
    var sellGain = (0,formula/* getSellGain */.Sd)(sellProfitLoss, buyAmountInvestedAveragePriceFee);
    var getMaxLot = function() {
        var lotOrderLimit = (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
        return maxLot > lotOrderLimit ? lotOrderLimit : maxLot;
    };
    var handleValidateAllFields = function() {
        form.validateFields();
    };
    var handleGtcChange = function(selectedExpiry) {
        setExpiry(selectedExpiry);
        if (selectedExpiry === transaction/* Expiry.GoodForDay */.ZM.GoodForDay) {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
    };
    var handlePriceChange = function(newPrice) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        setPrice(newPrice);
        handleValidateAllFields();
    };
    var handleLotChange = function(newLot) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        var roundLot = Math.floor(newLot);
        setShares(roundLot * constant/* lotSize */.CQ);
        handleValidateAllFields();
    };
    var handleOrderTypeChange = function(type) {
        setOrderType(type);
    };
    var handleFieldsChange = function(_, allFields) {
        var hasEmpty = allFields.some(function(param) {
            var value = param.value;
            return value === undefined;
        });
        var hasError = allFields.some(function(param) {
            var errors = param.errors;
            return errors.length > 0;
        });
        setHasFormError(hasEmpty || hasError);
    };
    var handleSaveFields = function() {
        var values = form.getFieldsValue();
        if (isShowSplitOrder && !isDayTradeActive) {
            setSplitOrderActive(!!values.isSplitOrderActive);
            setSplitQuantity(values.splitQuantity);
            setSplitRange(values.splitRangeMin, values.splitRangeMax);
        } else {
            setSplitOrderActive(false);
            setSplitQuantity(null);
            setSplitRange(null, null);
        }
        setDayTradeActive(isDayTradeSell);
        setDayTadeMultiplier(isAmend && isDayTrade ? parseInt(multiplier, 10) : 0);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var day_trade, isTimeLimit, isUnavailable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleSaveFields();
                        if (!isDayTradeSell) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 4;
                        return loadTradingInfo([
                            types_trading/* TradingFeatureEnum.DAY_TRADE */.n5.DAY_TRADE, 
                        ]);
                    case 4:
                        day_trade = _ctx.sent.day_trade;
                        if (!day_trade) {
                            _ctx.next = 11;
                            break;
                        }
                        isTimeLimit = day_trade.remaining_trading_close <= 0;
                        isUnavailable = [
                            types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.by.EXCEED_DEBT_RATIO,
                            types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.by.OUTSIDE_MARKET_HOURS, 
                        ].includes(day_trade === null || day_trade === void 0 ? void 0 : day_trade.event_type);
                        if (!(isUnavailable || isTimeLimit)) {
                            _ctx.next = 11;
                            break;
                        }
                        onShowDayTradeUnavailable();
                        return _ctx.abrupt("return");
                    case 11:
                        onSubmit();
                        (0,securities/* clevertapOrderPlaced */.As)({
                            orderType: orderType,
                            symbol: symbol,
                            price: price,
                            lot: lot,
                            gainLoss: "".concat(sellGain, "%"),
                            totalLot: "".concat(lotPercentage, "%"),
                            status: isSubmitDisabled ? "failed" : "success",
                            expiry: constants_transactionForm/* expiryOptions */.Me[expiry],
                            type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading,
                            dayTrade: isDayTradeSell
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeSwitchSplitOrder = function(checked) {
        if (!checked) {
            setSplitMethod(transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM);
        }
    };
    (0,react.useEffect)(function() {
        if (isRight) getCashOnHand();
        (0,securities/* clevertapSellOrderViewed */.B0)(symbol);
    }, [
        isRight
    ]);
    (0,react.useEffect)(function() {
        if (isAmend) {
            setShares(orderedLot * constant/* lotSize */.CQ);
        } else {
            setShares(Math.floor(available_lot) * constant/* lotSize */.CQ);
        }
    }, [
        isAmend,
        orderedLot,
        available_lot
    ]);
    (0,react.useEffect)(function() {
        if (!sellOrderType) setOrderType(transaction/* SellOrderType.LimitOrder */.qK.LimitOrder);
    }, [
        sellOrderType,
        setOrderType
    ]);
    (0,react.useEffect)(function() {
        if (isDayTradeActive) {
            setExpiry(transaction/* Expiry.GoodForDay */.ZM.GoodForDay);
            setSplitOrderActive(false);
            setSplitQuantity(null);
            setSplitRange(null, null);
        }
        if (!leverage) {
            if (detailDayTrade.available_lot > 0 && availableLot <= 0) {
                setLeverage(RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE);
                setDayTradeActive(true);
            }
            if (detailDayTrade.available_lot <= 0 && availableLot > 0) {
                setLeverage(RealTradingModal_types/* LEVERAGE.REGULAR */.h$.REGULAR);
                setDayTradeActive(false);
            }
        }
    }, [
        leverage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: marketHour.suspend_info,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpecialMonitoringBanner, {
                    onClick: showSpecialMonitoringModal,
                    title: marketHour.suspend_info
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* TransactionForm */.vQ, {
                form: form,
                colon: false,
                labelCol: {
                    span: 12
                },
                onFinish: handleSubmit,
                onFieldsChange: handleFieldsChange,
                onBlur: handleSaveFields,
                onValuesChange: handleSaveFields,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showOrderType,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_OrderTypeFormItem, {
                            form: form,
                            transactionType: transaction/* TransactionType.Sell */.iU.Sell,
                            defaultValue: sellOrderType,
                            onChange: handleOrderTypeChange,
                            hideInfoIcon: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* FieldsWrapper */.V$, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isLeverageEnabled,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: "Leverage",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SellLeverage, {
                                        dayTradeLot: isAmend ? availableLotToSell : detailDayTrade.available_lot,
                                        regularLot: getPortfolioDetail.available_lot,
                                        isAmend: isAmend,
                                        leverage: leverage,
                                        handleChangeLeverage: function(value) {
                                            setLeverage(value);
                                            setDayTradeActive(value === RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE);
                                            if (value === RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE && isSplitOrderActive) {
                                                setSplitOrderActive(false);
                                                form.setFieldsValue({
                                                    isSplitOrderActive: false
                                                });
                                            }
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Available Lot",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    align: "right",
                                    "data-cy": constant/* DATA_CY_MODAL_TRADING.AVAILABLE_LOT_VALUE */.eG.AVAILABLE_LOT_VALUE,
                                    children: availableLotToSell
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                className: "slider-form-item",
                                label: "Sell Order Lot",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                                            min: 0,
                                            max: getMaxLot(),
                                            value: lot,
                                            tipFormatter: null,
                                            disabled: isDisabledInput,
                                            onChange: function(newLot) {
                                                (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
                                                    symbol: symbol,
                                                    orderType: orderType,
                                                    adjustedType: "slider"
                                                });
                                                setShares(Math.floor(newLot) * constant/* lotSize */.CQ);
                                                handleValidateAllFields();
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* SliderPercentText */.fx, {
                                            children: [
                                                lotPercentage,
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "",
                                wrapperCol: {
                                    xs: {
                                        offset: 0
                                    },
                                    sm: {
                                        span: 12,
                                        offset: 12
                                    }
                                },
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_SELL_ORDER_LOT */.eG.FORM_SELL_ORDER_LOT,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    containerStyle: {
                                        width: 160
                                    },
                                    defaultValue: lot,
                                    value: lot,
                                    min: 0,
                                    max: getMaxLot(),
                                    step: 1,
                                    onChange: handleLotChange,
                                    disabled: isDisabledInput
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Price",
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_PRICE */.eG.FORM_PRICE,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    containerStyle: {
                                        width: 160
                                    },
                                    value: price,
                                    min: 0,
                                    step: (0,transactionPrice/* getStepFractionByValue */.Z)(price),
                                    onChange: handlePriceChange,
                                    disableDecimal: true,
                                    disabled: isDisabledInput
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Proceeds (Net Fee)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                    family: "bold",
                                    align: "right",
                                    children: [
                                        "Rp",
                                        (0,number/* formatNumber */.uf)(sellAmountInvestedFee, false)
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Profit/Loss",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                    align: "right",
                                    color: (0,general/* getColorBasedOnNumber */.pV)(sellProfitLoss),
                                    "data-cy": constant/* DATA_CY_MODAL_TRADING.PROFIT_LOSS_VALUE */.eG.PROFIT_LOSS_VALUE,
                                    children: [
                                        (0,number/* formatNumber */.uf)(sellProfitLoss, false),
                                        " (",
                                        sellProfitLoss > 0 && "+",
                                        sellGain === Infinity || sellGain === 0 ? "0.00%" : (0,number/* formatPercentage */.rl)(sellGain, false),
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: !hideExpiry,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                        label: "Expiry",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                            value: expiry,
                                            width: "100%",
                                            onChange: handleGtcChange,
                                            disabled: isDisabledInput || isDayTradeActive,
                                            "data-cy": constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT */.eG.EXPIRY_SELECT,
                                            getPopupContainer: function() {
                                                return document.getElementById(constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT_DROPDOWN */.eG.EXPIRY_SELECT_DROPDOWN);
                                            },
                                            children: Object.entries(constants_transactionForm/* expiryOptions */.Me).map(function(param) {
                                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default.Option */.Z.Option, {
                                                    value: key,
                                                    children: value
                                                }, key);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT_DROPDOWN */.eG.EXPIRY_SELECT_DROPDOWN,
                                        "data-cy": constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT_DROPDOWN */.eG.EXPIRY_SELECT_DROPDOWN
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: showSplitOrderForm,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_SplitOrderFormItem, {
                                    form: form,
                                    orderLot: lot,
                                    checkedInitialValue: isSplitOrderActive,
                                    quantityInitialValue: splitQuantity,
                                    minRangeInitialValue: splitRangeMin,
                                    maxRangeInitialValue: splitRangeMax,
                                    maxQuantity: maxOrder,
                                    transactionType: transaction/* TransactionType.Sell */.iU.Sell,
                                    onInfoIconClick: onShowSplitOrderInfo,
                                    disabledToggle: isDisabledInput,
                                    onSwitchChange: handleChangeSwitchSplitOrder,
                                    onSplitMethodInfoClick: onShowSplitOrderMethodInfo
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* ButtonWrapper */.W4, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* OrderButton */.sg, {
                            htmlType: "submit",
                            disabled: isSubmitDisabled,
                            type: "secondary",
                            radius: "4px",
                            block: true,
                            height: "40px",
                            "data-cy": constant/* DATA_CY_MODAL_TRADING.BUTTON_PLACE_ORDER */.eG.BUTTON_PLACE_ORDER,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                children: "Place Order"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionModal_FormSell = (/*#__PURE__*/(0,react.memo)(FormSell));

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/NativeModal.tsx






























var NativeModal_obj;
var NativeModal_transactionToOrderType = (NativeModal_obj = {}, (0,_define_property/* default */.Z)(NativeModal_obj, transaction/* TransactionType.Buy */.iU.Buy, trading/* ORDER_TYPE.BUY */.Jm.BUY), (0,_define_property/* default */.Z)(NativeModal_obj, transaction/* TransactionType.Sell */.iU.Sell, trading/* ORDER_TYPE.SELL */.Jm.SELL), NativeModal_obj);
var NativeTransactionModal = function(param) {
    var visible = param.visible, onUpdateSymbol = param.onUpdateSymbol, closeModal = param.closeModal, onSwitchTab = param.onSwitchTab, portfolioData = param.portfolioData, onSubmitExercise = param.onSubmitExercise;
    var isFastOrderEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.FAST_ORDER */.O.FAST_ORDER);
    var setModal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setModal;
    });
    var ref = (0,react.useState)(false), isSearchActive = ref[0], setIsSearchActive = ref[1];
    var resetCashInfo = (0,useCashInfoStore/* default */.Z)(function(s) {
        return s.resetCashInfo;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var ref1 = (0,TradingModal_store/* default */.Z)(), showOrderbook = ref1.showOrderbook, showTabs = ref1.showTabs;
    var orderType = (0,useTradingStore/* default */.Z)(function(s) {
        return s.orderType;
    });
    var resetOrderData = (0,RealTradingModal_store/* default */.Z)(function(s) {
        return s.resetOrderData;
    });
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var openBondsBuyModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openBuyModal;
    });
    var company = (0,tradingData/* default */.Z)(function(s) {
        return s.company.data;
    });
    var loadTnC = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadTnC;
    });
    var symbol = (0,useTradingStore/* default */.Z)(function(s) {
        return s.symbol;
    });
    var ref2 = (0,RealTradingModal_store/* default */.Z)(), price = ref2.price, expiry = ref2.expiry, shares = ref2.shares, type = ref2.type, triggerPrice = ref2.triggerPrice, isSplitOrderActive = ref2.isSplitOrderActive, splitQuantity = ref2.splitQuantity, splitRangeMin = ref2.splitRangeMin, splitRangeMax = ref2.splitRangeMax, dayTradeActive = ref2.dayTradeActive, dayTradeMultiplier = ref2.dayTradeMultiplier, configType = ref2.configType, availableLot = ref2.availableLot;
    var onSubmit = function() {
        var gtc = constant/* expiryOption.findIndex */.$r.findIndex(function(e) {
            return e === expiry;
        });
        var ref;
        var previewData = {
            price: price,
            shares: shares,
            triggerPrice: triggerPrice,
            gtc: gtc < 0 ? 0 : gtc,
            symbol: symbol,
            isSplitOrderActive: isSplitOrderActive,
            splitQuantity: splitQuantity,
            splitRangeMin: splitRangeMin,
            splitRangeMax: splitRangeMax,
            multiplier: String(dayTradeMultiplier),
            type: type,
            isDayTrade: dayTradeActive,
            orderType: orderType,
            configType: configType,
            availableLot: availableLot,
            companyType: (ref = company === null || company === void 0 ? void 0 : company.type_company) !== null && ref !== void 0 ? ref : ""
        };
        setModal(RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW, {
            previewData: previewData
        });
    };
    var available_lot = (portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.available_lot) || 0;
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY || orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY;
    var isSell = orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isExercise = orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE;
    var isAmend = (0,react.useMemo)(function() {
        return [
            trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL
        ].includes(orderType);
    }, [
        orderType
    ]);
    var isFormTypeSelectVisible = (0,react.useMemo)(function() {
        return isFastOrderEnabled && [
            trading/* ORDER_TYPE.BUY */.Jm.BUY,
            trading/* ORDER_TYPE.SELL */.Jm.SELL
        ].includes(orderType) && [
            stockType/* StockType.Saham */.Z.Saham,
            stockType/* StockType.Waran */.Z.Waran,
            stockType/* StockType.Right */.Z.Right,
            stockType/* StockType.Etf */.Z.Etf, 
        ].includes(company === null || company === void 0 ? void 0 : company.type_company.toLowerCase());
    }, [
        isFastOrderEnabled,
        isAmend
    ]);
    var defaultTabValue = (0,react.useMemo)(function() {
        if (available_lot <= 0 || [
            (trading/* ORDER_TYPE.BUY */.Jm.BUY, trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY)
        ].includes(orderType)) {
            return transaction/* TransactionType.Buy */.iU.Buy;
        }
        if ([
            trading/* ORDER_TYPE.SELL */.Jm.SELL,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL
        ].includes(orderType)) {
            return transaction/* TransactionType.Sell */.iU.Sell;
        }
        return transaction/* TransactionType.Buy */.iU.Buy;
    }, [
        orderType
    ]);
    var handleUpdateSymbol = function(selected, isBonds) {
        if (isBonds) {
            openBondsBuyModal(selected);
            FRBondActionTrackers.onOrderButtonClicked("Buy", selected, "Search Company Page");
            closeModal();
            return;
        }
        onUpdateSymbol(selected);
        setIsSearchActive(false);
    };
    var handleClose = function() {
        resetCashInfo();
        closeModal();
        resetOrderData();
        (0,autoOrder/* trackAutoBuyOrderCanceled */.fY)();
        setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
    };
    var handleFormTypeChange = function(value) {
        if (value === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder) handleClose();
    };
    var handleSwitchTab = function(value) {
        onSwitchTab(NativeModal_transactionToOrderType[value]);
    };
    var handleShowSplitOrderInfo = function() {
        setModal(RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_INFO */.fG.SPLIT_ORDER_INFO);
    };
    var handleShowSplitMethodInfo = function() {
        setModal(RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_METHOD_INFO */.fG.SPLIT_ORDER_METHOD_INFO);
    };
    var handleShowTradingLimitTnc = function() {
        loadTnC(termsAndCondition/* TnCFeatureIDEnum.FEATURE_TRADING_LIMIT */.hO.FEATURE_TRADING_LIMIT, /**
       * If user is not yet accepted the TnC,
       * then show the modal using the callback
       */ function() {
            setUIValue("tradingLimitTnc", false);
            setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
            setModal(RealTradingModal_types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC);
        }, /**
       * If user was accepted the TnC before,
       * then show continue their action to use the Trading limit as payment
       */ function() {
            setUIValue("tradingLimitTnc", true);
            setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit);
            setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* TransactionModalContainer */.md, {
        width: "auto",
        "data-cy": "transaction-modal-real",
        visible: visible,
        onCancel: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Flex */.kC, {
            style: {
                gap: 30
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: showOrderbook && !isExercise,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* ModalFormWrapper */.W_, {
                    children: [
                        isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* FreezeLayer */.VV, {
                            onClick: function() {
                                return setIsSearchActive(false);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* FormWrapper */.n5, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                    orderType: orderType,
                                    defaultTabsValue: defaultTabValue,
                                    showTabs: showTabs,
                                    isSearchActive: isSearchActive,
                                    disableTabs: available_lot <= 0,
                                    setIsSearchActive: function() {
                                        return setIsSearchActive(!isSearchActive);
                                    },
                                    formTypeSelectVisible: isFormTypeSelectVisible,
                                    onUpdateSymbol: handleUpdateSymbol,
                                    onFormTypeChange: handleFormTypeChange,
                                    onTabsChange: handleSwitchTab
                                }),
                                isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormBuy, {
                                    showOrderTypeModal: function() {
                                        return setModal(RealTradingModal_types/* MODAL_TYPE.ORDER_TYPE */.fG.ORDER_TYPE);
                                    },
                                    showAutoBuyTncModal: function() {
                                        return setModal(RealTradingModal_types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC);
                                    },
                                    showSpecialMonitoringModal: function() {
                                        return setModal(RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING);
                                    },
                                    onShowTradingLimitTnc: handleShowTradingLimitTnc,
                                    onShowSplitOrderInfo: handleShowSplitOrderInfo,
                                    onShowSplitOrderMethodInfo: handleShowSplitMethodInfo,
                                    onSubmit: onSubmit,
                                    onShowDayTradeOnboarding: function() {
                                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING);
                                    },
                                    onShowDayTradeUnavailable: function() {
                                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_UNAVAILABLE */.fG.DAY_TRADE_UNAVAILABLE);
                                    }
                                }),
                                isSell && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormSell, {
                                    showSpecialMonitoringModal: function() {
                                        return setModal(RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING);
                                    },
                                    onShowSplitOrderInfo: handleShowSplitOrderInfo,
                                    onShowSplitOrderMethodInfo: handleShowSplitMethodInfo,
                                    onSubmit: onSubmit,
                                    onShowDayTradeUnavailable: function() {
                                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_UNAVAILABLE */.fG.DAY_TRADE_UNAVAILABLE);
                                    }
                                }),
                                isExercise && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormExercise/* default */.Z, {
                                    onSubmit: onSubmitExercise
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var NativeModal = (/*#__PURE__*/(0,react.memo)(NativeTransactionModal));

;// CONCATENATED MODULE: ./src/assets/customIcon/CheckSpot.tsx

var CheckSpot = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "84",
        height: "84",
        fill: "none",
        viewBox: "0 0 84 84",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#pattern0_833_119086)",
                d: "M0 0h84v84H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_833_119086",
                        width: "1",
                        height: "1",
                        patternContentUnits: "objectBoundingBox",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_833_119086",
                            transform: "scale(.0119)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAEnklEQVR4Ae2dTW7TQBTHX6ACBAIK9AbcgBNwA1ZsOUCcoCLxzcZbOAGcoFLiFoEgAoGUBa3UBTvKBXqCcoKivy0746nHmZn4jZ36WapiO87MvF/ep9s+E9lvA5qNL9MsvkHzeJO+xbdpHm+dy59Mts1UVshMNLDHtOzKycOLtP/8+rkE56IQYBDHF5bhMr9/SgP6/vQa/Xx1p/cwc/Bg8Tu+SmDjtM3jDfry8paANLg0sIHlWm3z+IpopQFkrql4hbZm/rUGK6iLidsH2ozVhonogH6JmTu7OTCrzAIQgFSVln17TQW70oYgJKZuD1BXNrArBanDNFn3H1CfoI/HKHjSDcmqaOfqygSGqS9F6O+jRnHI/De+RPRJysrGFAos6ceLm40NyPGtr9OYYCm5p0VVZPulpjmpBKTVA1IOPA1M+YG8NgNW/GeDJg+lFKACtBnT5HJxoqGioaKhvbKCXgnL5TfVcc8l0Nmzu7Q7ekvJaJ92o/eEY1Vozv1gE3EKoY89Gf6haXRa/OD44/b9ILIGmUQXmPN4Gu0UIFWo0+iE9p48YJeXfQJOePrYyeM3BpgLbZ2OX7PKzDq4LjDnMbSvrJEKRMX8cU0SvWOTm21gTnj62PCPMGlboLiOK1CtPVCA0YOQDVgBaigRk+irk2amsIcHbIrENrBulhzHSfTBGeYk+keft++xyc02MAdAdczpaOwME9rJnY+uJdAsCJmjuNGHjsbs8rJPoGpVE/sIJq4RHYB3RztBZA0ySRMgMYZvRJ8yBiFdtrUCai4rzeafRMdsOacOE8drA9SqrNQqIkR07iCkQw0GFKkKbqmhlnZNqvfGj7wiOj6nC8x9HGTCrM5WS8MTa83xKSsRhKDR3PCqxmef1AzkhJZpUBaEjp21M1REDw7UCkhNbog77sacUvOXi+uOnF1KFRjfc2wa6pbinM0RfSI6gpCrf/YFZ/ocG1DXOhs3OXIYXS0rTRDV8yxAAWZhguYcUb8Gt+FcbhSXPl/jOlSBufdZgCJFKglr9Hf2sOvGgzVwg7Idn20hyXAWBCrmsRU2xHVsi4HZ80NtN6JXfUFsQPPJkBPWmavve22UlblMda/sQDG5b9Sugx3id+x14EzvBQGKyQEAWlUHyfa9tspKE0T1fDCgmBRlKG6n2YKruq7NslIFZ9oPChSLyHLUI0+oR8HXawJnOt/KAgHVNViFvlFsArbsfCtA80XZlqddjei5HOprq0CxEKsMoCNlpQrOtN86UCysLgPg/MMuE5RVzncCKASoygC6HtGrwHcGKBZXBKvhQWu/wqiC5HKuU0BdFt7VawWo4a/6fL8wASpA5T/pemUFvRLW1y+6fE6Aig8VH9orK5A2Qw2afNpmSBphNedC0kZY0qqtOaBpqzZpJtgc0LQns7S7bAYouooVfe6lIevqUMGw2KRl8GpAs/6BWrdwaWrtD/VMU+tMVaXtukvNnl9rbLsOqGL6bloKUy91By+cqLKDPsI5fXmtBzxBz2WbTR6uUg/S6eEqC+DZ439ES8twswDk+PifBVRKfYQ8oGorfUhXkbirgPz35RFqFuz+A8bFGiZ6p4NPAAAAAElFTkSuQmCC",
                        id: "image0_833_119086",
                        width: "84",
                        height: "84"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/SmartOrderPlacedModal.tsx






var SmartOrderPlacedModal_getOrderType = function(type) {
    var textLIT = "Limit If Touched";
    return [
        "Auto Buy",
        "AutoBuy"
    ].includes(type) ? textLIT : type;
};
var SmartOrderPlacedModal = function(param) {
    var visible = param.visible, orderType = param.orderType, onSubmit = param.onSubmit, onCloseModal = param.onCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Modal/* default */.Z, {
        visible: visible,
        width: "420px",
        onCancel: onCloseModal,
        centered: true,
        closable: false,
        type: "transparent",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* ModalLitContent */.hK, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckSpot, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                                size: "18px",
                                family: "bold",
                                align: "center",
                                children: [
                                    SmartOrderPlacedModal_getOrderType(orderType),
                                    " Berhasil Dipasang"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: onSubmit,
                    type: "primary",
                    radius: "4px",
                    block: true,
                    height: "44px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        align: "inherit",
                        color: "inherit",
                        family: "bold",
                        size: "14px",
                        children: "Done"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var TradingModal_SmartOrderPlacedModal = (SmartOrderPlacedModal);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/index.tsx






















































function RealTradingModal(param) {
    var onSwitchTab = param.onSwitchTab, closeModal = param.closeModal;
    var router = (0,next_router.useRouter)();
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var getUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue;
    });
    var loadTradingInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.loadTradingInfo;
    });
    var openBuyBonds = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openBuyModal;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var ref = (0,react.useState)(""), amendOrderType = ref[0], setAmendOrderType = ref[1];
    var visible = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.visible;
    });
    var modal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.openModal;
    });
    var setModal = (0,useTradingStore/* default */.Z)(function(s) {
        return s.setModal;
    });
    var previewData = (0,useTradingStore/* default */.Z)(function(s) {
        return s.previewData;
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTransactionFormStore/* default */.Z)(function(s) {
        return [
            s.formType,
            s.setFormType, 
        ];
    }), 2), formType = ref1[0], setFormType = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useGlobalModalStore/* default */.Z)(function(s) {
        return [
            s.activeModal,
            s.setActiveModal, 
        ];
    }), 2), activeModal = ref2[0], setActiveModal = ref2[1];
    var setFastOrderSymbol = (0,useFastOrderStore/* default */.Z)(function(s) {
        return s.setSymbol;
    });
    var symbol = (0,useTradingStore/* default */.Z)(function(s) {
        return s.symbol;
    });
    var orderType = (0,useTradingStore/* default */.Z)(function(s) {
        return s.orderType;
    });
    var openFromWidget = (0,useTradingStore/* default */.Z)(function(s) {
        return s.openFromWidget;
    });
    var company = (0,tradingData/* default */.Z)(function(s) {
        return s.company.data;
    });
    var useModuleFederation = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.MARKET_ORDER */.O.MARKET_ORDER);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,TradingModal_store/* default */.Z)(function(s) {
        return [
            s.price,
            s.orderedPrice,
            s.modalData,
            s.onClose,
            s.showModal,
            s.showTabs,
            s.showOrderbook,
            s.setModalState, 
        ];
    }, shallow/* default */.Z), 8), priceProps = ref3[0], orderedPrice = ref3[1], modalData = ref3[2], onClose = ref3[3], showTradingModal = ref3[4], showTabs = ref3[5], showOrderbook = ref3[6], setModalState = ref3[7];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,tradingData/* default */.Z)(function(s) {
        return [
            s.checkRightTradeable,
            s.getExercise,
            s.getCompany,
            s.getOrderHistory,
            s.getPortfolio,
            s.getConfigFormula,
            s.resetModalData,
            s.resetCompany, 
        ];
    }, shallow/* default */.Z), 8), checkRightTradeable = ref4[0], getExercise = ref4[1], getCompany = ref4[2], getOrderHistory = ref4[3], getPortfolio = ref4[4], getConfigFormula = ref4[5], resetModalData = ref4[6], resetCompany = ref4[7];
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY;
    var isSell = orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL;
    var setOrderTab = (0,store/* default */.Z)(function(s) {
        return s.setOrderTab;
    });
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,RealTradingModal_store/* default */.Z)(function(s) {
        return [
            s.setPrice,
            s.setStockCode,
            s.type,
            s.dayTradeActive
        ];
    }, shallow/* default */.Z), 4), setPrice = ref5[0], setStockCode = ref5[1], buyOrderType = ref5[2], dayTradeActive = ref5[3];
    var portfolioData = (0,useGetPortfolioData/* default */.Z)(symbol, true, false, dayTradeActive);
    var termsData = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.termsData;
    });
    var loadTnCAcceptance = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadTnCAcceptance;
    });
    var loadSubAccountStatus = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadSubAccountStatus;
    });
    var resetOrderDetail = (0,useOrderDetailStore/* default */.Z)(function(s) {
        return s.resetOrderDetail;
    });
    var ref6 = (0,useSyariah/* default */.Z)(), isUserSyariah = ref6.isUserSyariah, checkSyariahTradeableStatus = ref6.checkSyariahTradeableStatus, hideSyariahRestrictionModal = ref6.hideSyariahRestrictionModal;
    var backToTransaction = function(payload) {
        if (!openFromWidget) {
            setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION, payload);
        } else {
            setModal("");
        }
    };
    var loadCompanyData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getCompany(symbol);
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCompanyData() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadRightTradeableStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return checkRightTradeable();
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.is_tradeable);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadRightTradeableStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadExercisableData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getExercise(symbol);
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", {
                            isExercisable: data === null || data === void 0 ? void 0 : data.is_exerciseable,
                            isExerciseTradeable: data === null || data === void 0 ? void 0 : data.is_tradeable
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadExercisableData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getTradeableStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(emittenInfo) {
            var type, isRight, isWarrant, isRightTradeable, isRightTradeable1, isExerciseTradeable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = emittenInfo.type_company;
                        isRight = type.toLowerCase() === trading/* STOCK_TYPE.right */.L2.right;
                        isWarrant = type.toLowerCase() === trading/* STOCK_TYPE.waran */.L2.waran;
                        if (!(isRight && isSell)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 6;
                        return loadRightTradeableStatus();
                    case 6:
                        isRightTradeable = _ctx.sent;
                        return _ctx.abrupt("return", isRightTradeable);
                    case 8:
                        if (!(![
                            isRight,
                            isWarrant
                        ].includes(true) || !isBuy)) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 10:
                        if (!isRight) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 13;
                        return loadRightTradeableStatus();
                    case 13:
                        isRightTradeable1 = _ctx.sent;
                        if (isRightTradeable1) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 16:
                        _ctx.next = 18;
                        return loadExercisableData();
                    case 18:
                        isExerciseTradeable = _ctx.sent.isExerciseTradeable;
                        return _ctx.abrupt("return", isExerciseTradeable);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getTradeableStatus(emittenInfo) {
            return _ref.apply(this, arguments);
        };
    }();
    var getTransactionStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(emittenInfo) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 3;
                        return loadExercisableData();
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent.isExercisable);
                    case 4:
                        return _ctx.abrupt("return", getTradeableStatus(emittenInfo));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getTransactionStatus(emittenInfo) {
            return _ref.apply(this, arguments);
        };
    }();
    var setInitialPrice = function(emittenInfo) {
        var tradeable = emittenInfo.tradeable;
        if (tradeable) {
            setPrice(priceProps || (0,RealTradingModal_utils/* getInitialPrice */.Tx)(emittenInfo, orderType, orderedPrice));
            setStockCode(symbol);
        }
    };
    var handleResetData = function() {
        var isPreventCloseModal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        setModal(null);
        resetModalData();
        resetCompany();
        resetOrderDetail();
        if (!isPreventCloseModal) closeModal();
    };
    var handleSubmitOrderPlaced = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        backToTransaction();
                        (0,securities/* clevertapOrderDone */.v8)({
                            orderType: orderType
                        });
                        if (buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) (0,autoOrder/* trackAutoBuyOrderDone */.Rj)();
                        handleResetData();
                        if (orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE) setOrderTab("exercise");
                        if ([
                            "/securities/order/",
                            "/securities/order"
                        ].includes(router === null || router === void 0 ? void 0 : router.asPath)) {
                            getPortfolio(isRealTrading);
                            getOrderHistory(true);
                        } else router.push("/securities/order");
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitOrderPlaced() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadDayTradeTncStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", loadTnCAcceptance([
                            termsAndCondition/* TnCFeaturesIDEnum.TRADING_LIMIT */.el.TRADING_LIMIT,
                            termsAndCondition/* TnCFeaturesIDEnum.DAY_TRADE */.el.DAY_TRADE, 
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadDayTradeTncStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadDayTradeSubAccountStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var subAccountActive;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        subAccountActive = getUIValue("dayTradeSubAccountActive");
                        if (!subAccountActive) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", subAccountActive);
                    case 3:
                        return _ctx.abrupt("return", loadSubAccountStatus(termsAndCondition/* SubAccountType.DAY_TRADE */.RD.DAY_TRADE));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadDayTradeSubAccountStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var getDayTradeTncStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var checkShown, isActive, dayTradeTncShown, dayTradeTnc, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        checkShown = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                        if (!isUserSyariah) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 3:
                        if (termsData) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return loadDayTradeTncStatus();
                    case 6:
                        _ctx.next = 8;
                        return loadDayTradeSubAccountStatus();
                    case 8:
                        isActive = _ctx.sent;
                        if (!isActive) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 11:
                        dayTradeTncShown = getUIValue("dayTradeTncShown");
                        if (!(dayTradeTncShown !== undefined && checkShown)) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", dayTradeTncShown);
                    case 14:
                        dayTradeTnc = getUIValue("dayTradeTnc");
                        if (!(dayTradeTnc !== undefined)) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", dayTradeTnc);
                    case 17:
                        return _ctx.abrupt("return", loadDayTradeTncStatus());
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getDayTradeTncStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseModalDayTrade = function() {
        setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
        setUIValue("dayTradeTncShown", true);
    };
    var getShariaTradableStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isShariaTradable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!isUserSyariah || !isBuy)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 2:
                        _ctx.next = 4;
                        return checkSyariahTradeableStatus(symbol);
                    case 4:
                        isShariaTradable = _ctx.sent;
                        if (isShariaTradable) {
                            _ctx.next = 8;
                            break;
                        }
                        setModal(RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE);
                        return _ctx.abrupt("return", false);
                    case 8:
                        return _ctx.abrupt("return", true);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getShariaTradableStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseModalSharia = function() {
        setModal(null);
        hideSyariahRestrictionModal();
        handleResetData();
    };
    var handlePlaceExercise = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getShariaTradableStatus();
                    case 2:
                        if (_ctx.sent) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (symbol) setStockCode(symbol);
                        setModal(RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW, {
                            // @ts-expect-error: only need symbol and orderType
                            previewData: {
                                symbol: symbol,
                                orderType: trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE
                            }
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePlaceExercise() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoadInitialData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var isSwitchToClassic, companyData, isTransactionable;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getShariaTradableStatus();
                case 3:
                    if (_ctx.sent) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 5:
                    if (!(!symbol || (modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget) || modal === RealTradingModal_types/* MODAL_TYPE.AUTO_ORDER */.fG.AUTO_ORDER)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 7:
                    isSwitchToClassic = [
                        trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
                        trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL,
                        trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE, 
                    ].includes(orderType);
                    if (!(formType === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder)) {
                        _ctx.next = 12;
                        break;
                    }
                    if (isSwitchToClassic) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 11:
                    setFormType(transactionForm/* TransactionFormType.Classic */.b.Classic);
                case 12:
                    _ctx.next = 14;
                    return getConfigFormula();
                case 14:
                    _ctx.next = 16;
                    return loadCompanyData();
                case 16:
                    companyData = _ctx.sent;
                    _ctx.next = 19;
                    return getTransactionStatus(companyData);
                case 19:
                    isTransactionable = _ctx.sent;
                    if (isTransactionable) {
                        _ctx.next = 23;
                        break;
                    }
                    setModal(RealTradingModal_types/* MODAL_TYPE.ANNOUNCEMENT */.fG.ANNOUNCEMENT);
                    return _ctx.abrupt("return");
                case 23:
                    _ctx.next = 25;
                    return loadTradingInfo([
                        types_trading/* TradingFeatureEnum.SPLIT_ORDER */.n5.SPLIT_ORDER
                    ]);
                case 25:
                    if (!(!router.asPath.includes("portfolio") && !router.asPath.includes("chartbit"))) {
                        _ctx.next = 28;
                        break;
                    }
                    _ctx.next = 28;
                    return getPortfolio(true);
                case 28:
                    setInitialPrice(companyData);
                    _ctx.next = 31;
                    return getDayTradeTncStatus();
                case 31:
                    if (_ctx.sent) {
                        _ctx.next = 34;
                        break;
                    }
                    setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING);
                    return _ctx.abrupt("return");
                case 34:
                    backToTransaction();
                    _ctx.next = 40;
                    break;
                case 37:
                    _ctx.prev = 37;
                    _ctx.t0 = _ctx["catch"](0);
                    handleResetData();
                case 40:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                37
            ]
        ]);
    })), [
        symbol
    ]);
    // Handle show modal from outside transaction
    var handleLoadRestriction = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var showShariaRestrictionBuy;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!modalData || (modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget))) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    showShariaRestrictionBuy = (modalData || {}).showShariaRestrictionBuy;
                    if (!isUserSyariah) {
                        _ctx.next = 8;
                        break;
                    }
                    if (!showShariaRestrictionBuy) {
                        _ctx.next = 7;
                        break;
                    }
                    setModal(RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE);
                    return _ctx.abrupt("return");
                case 7:
                    setModalState({
                        modalData: {
                            showShariaRestrictionBuy: false
                        }
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isUserSyariah,
        modalData === null || modalData === void 0 ? void 0 : modalData.showShariaRestrictionBuy,
        modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget, 
    ]);
    var handleReturnToTransaction = function() {
        handleLoadInitialData();
        (0,securities/* clevertapOrderDone */.v8)({
            orderType: orderType
        });
        if (buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) {
            (0,autoOrder/* trackAutoBuyOrderDone */.Rj)();
        }
    };
    var handleCloseOrderPlacedModal = function() {
        handleResetData();
        (0,securities/* clevertapOrderDone */.v8)({
            orderType: orderType
        });
        if (buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) {
            (0,autoOrder/* trackAutoBuyOrderDone */.Rj)();
        }
    };
    (0,react.useEffect)(function() {
        handleLoadInitialData();
        return function() {
            handleResetData(true);
        };
    }, [
        handleLoadInitialData
    ]);
    (0,react.useEffect)(function() {
        handleLoadRestriction();
    }, [
        handleLoadRestriction
    ]);
    // Redirect to Fast Order modal and closing classic modal
    // This due to too many tradingModalStore.showModal reference to be refactored
    (0,react.useEffect)(function() {
        var isSwitchToClassic = [
            trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL,
            trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE, 
        ].includes(orderType);
        var isFastOrder = formType === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder && activeModal !== types/* GlobalModalType.FastOrder */.C.FastOrder;
        var isShouldOpenFastOrder = symbol && isFastOrder && !isSwitchToClassic;
        if (isShouldOpenFastOrder) {
            setFastOrderSymbol(symbol);
            setActiveModal(types/* GlobalModalType.FastOrder */.C.FastOrder, {
                switchFormConfig: {
                    orderType: orderType,
                    showTabs: showTabs,
                    showOrderbook: showOrderbook
                }
            });
            handleResetData();
            return;
        }
        // Switch back to classic form if condition to open fast order not met
        setFormType(transactionForm/* TransactionFormType.Classic */.b.Classic);
    }, [
        symbol,
        formType,
        orderType,
        showTabs
    ]);
    var getTransactionModalVisible = (0,react.useCallback)(function(value) {
        return modal === RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION && formType === value;
    }, [
        formType,
        modal
    ]);
    var isClassicFormVisible = (0,react.useMemo)(function() {
        return getTransactionModalVisible(transactionForm/* TransactionFormType.Classic */.b.Classic) && visible && !openFromWidget && Boolean(company);
    }, [
        getTransactionModalVisible,
        visible
    ]);
    if (!modal) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.ANNOUNCEMENT */.fG.ANNOUNCEMENT,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_AnnouncementModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.ANNOUNCEMENT */.fG.ANNOUNCEMENT,
                    orderType: orderType,
                    closeModal: handleResetData,
                    onSubmit: onClose,
                    showTransactionModal: backToTransaction
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isClassicFormVisible && !useModuleFederation && company,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeModal, {
                    visible: isClassicFormVisible,
                    onUpdateSymbol: function(newSymbol, isBonds) {
                        if (isBonds) {
                            openBuyBonds(newSymbol);
                            FRBondActionTrackers.onOrderButtonClicked("Buy", newSymbol, "Search Company Page");
                            onClose();
                            return;
                        }
                        showTradingModal({
                            symbol: newSymbol,
                            orderType: orderType,
                            modalData: {
                                openFromSearch: true
                            }
                        });
                    },
                    closeModal: handleResetData,
                    onSwitchTab: onSwitchTab,
                    portfolioData: portfolioData,
                    onSubmitExercise: handlePlaceExercise
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isClassicFormVisible && useModuleFederation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_TransactionMFModal, {
                    visible: isClassicFormVisible,
                    onUpdateSymbol: function(newSymbol, isBonds) {
                        if (isBonds) {
                            openBuyBonds(newSymbol);
                            FRBondActionTrackers.onOrderButtonClicked("Buy", newSymbol, "Search Company Page");
                            onClose();
                            return;
                        }
                        showTradingModal({
                            symbol: newSymbol,
                            orderType: orderType,
                            modalData: {
                                openFromSearch: true
                            }
                        });
                    },
                    onSubmitExercise: handlePlaceExercise,
                    closeModal: handleResetData,
                    onSwitchTab: onSwitchTab
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_TYPE */.fG.ORDER_TYPE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_OrderTypeModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_TYPE */.fG.ORDER_TYPE,
                    closeModal: backToTransaction
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_SpecialMonitoringModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING,
                    closeModal: backToTransaction
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW && previewData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_PreviewOrderModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW,
                    showExchangeFee: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.EXCHANGE_FEE */.fG.EXCHANGE_FEE);
                    },
                    onCancel: function() {
                        backToTransaction({
                            previewData: undefined
                        });
                    },
                    onSubmit: function(modalType, amendType) {
                        setModal(modalType);
                        setAmendOrderType(amendType);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.EXCHANGE_FEE */.fG.EXCHANGE_FEE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_ExchangeFeeModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.EXCHANGE_FEE */.fG.EXCHANGE_FEE,
                    closeModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW);
                    },
                    orderType: orderType
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPlacedModal/* default */.Z, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED,
                    onSubmit: handleSubmitOrderPlaced,
                    orderType: orderType,
                    symbol: symbol,
                    onReturnToTransaction: handleReturnToTransaction,
                    onCloseModal: handleCloseOrderPlacedModal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SMART_ORDER_PLACED */.fG.SMART_ORDER_PLACED,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_SmartOrderPlacedModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SMART_ORDER_PLACED */.fG.SMART_ORDER_PLACED,
                    orderType: amendOrderType,
                    onSubmit: handleSubmitOrderPlaced,
                    onCloseModal: handleCloseOrderPlacedModal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.AUTO_ORDER */.fG.AUTO_ORDER,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoOrder/* default */.Z, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.AUTO_ORDER */.fG.AUTO_ORDER,
                    symbol: symbol,
                    onCancel: handleResetData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_AutoOrderTncModal, {
                    autoOrderType: types_autoOrder/* AutoOrderProduct.AutoBuy */.V.AutoBuy,
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC,
                    closeModal: backToTransaction,
                    onAccept: backToTransaction
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_TradingLimitTncModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC,
                    onCancel: function() {
                        return backToTransaction();
                    },
                    onSubmit: function() {
                        return backToTransaction();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_INFO */.fG.SPLIT_ORDER_INFO,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_SplitOrderInfoModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_INFO */.fG.SPLIT_ORDER_INFO,
                    onCancel: function() {
                        return backToTransaction();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeOnboarding */.B7, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING,
                    maskClosable: false,
                    onCancel: handleCloseModalDayTrade,
                    onSubmit: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_TNC */.fG.DAY_TRADE_TNC);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_TNC */.fG.DAY_TRADE_TNC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeTnc */.md, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_TNC */.fG.DAY_TRADE_TNC,
                    maskClosable: false,
                    onCancel: handleCloseModalDayTrade,
                    onSubmit: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_CONFIRMATION */.fG.DAY_TRADE_CONFIRMATION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_CONFIRMATION */.fG.DAY_TRADE_CONFIRMATION,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeConfirmation */.S$, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_CONFIRMATION */.fG.DAY_TRADE_CONFIRMATION,
                    maskClosable: false,
                    onCancel: handleCloseModalDayTrade,
                    onSubmit: handleCloseModalDayTrade
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_UNAVAILABLE */.fG.DAY_TRADE_UNAVAILABLE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeUnavailable */.TI, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_UNAVAILABLE */.fG.DAY_TRADE_UNAVAILABLE,
                    onCancel: function() {
                        return backToTransaction();
                    },
                    onSubmit: function() {
                        return backToTransaction();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_METHOD_INFO */.fG.SPLIT_ORDER_METHOD_INFO,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_SplitOrderInfoModal, {
                    title: "Split Method",
                    description: "",
                    info: SPLIT_ORDER_MODAL_CONTENT.SPLIT_METHOD,
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_METHOD_INFO */.fG.SPLIT_ORDER_METHOD_INFO,
                    onCancel: function() {
                        return backToTransaction();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_ShariaUnavailableModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE,
                    onClose: handleCloseModalSharia
                })
            })
        ]
    });
}
/* harmony default export */ var TradingModal_RealTradingModal = (RealTradingModal);


/***/ }),

/***/ 53616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29097);





var initialState = {
    configType: 2,
    expiry: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay,
    price: 0,
    shares: 0,
    stockCode: "",
    triggerPrice: 0,
    availableLot: 0,
    type: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.LimitOrder */ .dY.LimitOrder,
    typeDescription: "Limit Order",
    isSplitOrderActive: false,
    splitQuantity: null,
    splitRangeMin: null,
    splitRangeMax: null,
    splitMethod: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SplitOrderMethodEnum.RANDOM */ .PH.RANDOM,
    sellLeverage: null,
    dayTradeActive: false,
    dayTradeMultiplier: 0
};
var realTradingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        setConfigType: function(payload) {
            var index = _constant__WEBPACK_IMPORTED_MODULE_1__/* .triggerPriceOption.indexOf */ .mr.indexOf(payload);
            set({
                configType: index + 1
            });
        },
        setExpiry: function(expiry) {
            set({
                expiry: expiry
            });
        },
        setOrderType: function(type) {
            set({
                type: type
            });
        },
        setPrice: function(payload) {
            var value = Number(payload);
            set({
                price: value
            });
        },
        setAvailableLot: function(payload) {
            var value = Number(payload);
            set({
                availableLot: value
            });
        },
        setShares: function(payload) {
            var value = Number(payload);
            set({
                shares: value
            });
        },
        setStockCode: function(payload) {
            set({
                stockCode: payload
            });
        },
        setTriggerPrice: function(payload) {
            var value = Number(payload);
            set({
                triggerPrice: value
            });
        },
        resetOrderData: function() {
            set(initialState);
        },
        setTradingData: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, payload));
        },
        setSplitOrderActive: function(isSplitOrderActive) {
            set({
                isSplitOrderActive: isSplitOrderActive
            });
        },
        setSplitQuantity: function(splitQuantity) {
            set({
                splitQuantity: splitQuantity
            });
        },
        setSplitRange: function(splitRangeMin, splitRangeMax) {
            set({
                splitRangeMin: splitRangeMin,
                splitRangeMax: splitRangeMax
            });
        },
        setSellLeverage: function(sellLeverage) {
            set({
                sellLeverage: sellLeverage
            });
        },
        setDayTradeActive: function(active) {
            set({
                dayTradeActive: active
            });
        },
        setDayTadeMultiplier: function(multiplier) {
            set({
                dayTradeMultiplier: multiplier
            });
        },
        setSplitMethod: function setSplitMethod(splitMethod) {
            set({
                splitMethod: splitMethod
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (realTradingStore);


/***/ }),

/***/ 61227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ CustomSelect; },
/* harmony export */   "Jm": function() { return /* binding */ TabPane; },
/* harmony export */   "UE": function() { return /* binding */ TabWrapper; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "av": function() { return /* binding */ TriggerPriceInfo; },
/* harmony export */   "d2": function() { return /* binding */ TriggerPriceSelect; },
/* harmony export */   "hv": function() { return /* binding */ DayTradeInfoBanner; },
/* harmony export */   "iR": function() { return /* binding */ Slider; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; },
/* harmony export */   "yJ": function() { return /* binding */ AutoBuySubmitButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22613);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76750);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-nav-list {\n    width: 100%;\n  }\n  .ant-tabs-nav-list {\n    .ant-tabs-tab {\n      width: 50%;\n      text-align: center;\n      font-family: var(--bold-font);\n\n      &.ant-tabs-tab-active {\n        color: ",
        ";\n        .ant-tabs-tab-btn {\n          color: ",
        ";\n        }\n      }\n\n      .ant-tabs-tab-btn {\n        width: 100%;\n        color: ",
        ";\n\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    background-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: solid 1px ",
        ";\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 2px;\n\n  /* Add style when disabled*/\n  &:disabled {\n    color: #b5b5b5;\n    background: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 36px;\n  width: 36px;\n  margin-right: 0px;\n  text-indent: 0;\n  padding-left: 5px;\n  padding-right: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -55px;\n  width: 100%;\n\n  :disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #bcbcbc;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: ",
        " !important;\n  }\n\n  .ant-tabs-tab-active {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-slider-step {\n    background-color: ",
        " !important;\n    height: 4px;\n    top: 4px;\n    z-index: 0;\n    border-radius: 2px;\n  }\n\n  .ant-slider-track {\n    border-radius: 2px;\n    height: 4px;\n    z-index: 1;\n  }\n\n  .ant-slider-handle {\n    z-index: 2;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-checked .ant-checkbox-inner,\n  .ant-checkbox-indeterminate .ant-checkbox-inner {\n    background-color: #0bba7a;\n    border-color: #0bba7a;\n  }\n\n  .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 318px;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f2f1fe;\n  border-radius: 4px;\n  margin-top: 16px;\n  color: #333333;\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2px;\n\n  .icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var BaseTabPane = antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TabPane */ .Z.TabPane;
var TabWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be087765-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mountainMeadow */ .Z.mountainMeadow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mountainMeadow */ .Z.mountainMeadow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray);
var CustomSelect = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-be087765-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var TriggerPriceSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(CustomSelect).withConfig({
    componentId: "sc-be087765-2"
})(_templateObject2());
var AutoBuySubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-3"
})(_templateObject3());
var TabPane = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(BaseTabPane).withConfig({
    componentId: "sc-be087765-4"
})(_templateObject4());
var Tabs = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var Slider = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-7"
})(_templateObject7());
var DayTradeInfoBanner = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be087765-8"
})(_templateObject8());
var TriggerPriceInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be087765-9"
})(_templateObject9());



/***/ }),

/***/ 67964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sz": function() { return /* binding */ generateStopOrderAmendParams; },
  "qz": function() { return /* binding */ generateStopOrderParams; },
  "Tx": function() { return /* binding */ getInitialPrice; },
  "PS": function() { return /* binding */ getLotOrderLimit; },
  "xb": function() { return /* binding */ getSplitOrderPayload; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
;// CONCATENATED MODULE: ./src/global/Securities/types/api/smartOrder.ts
/**
 * Request Payload Interfaces
 *
 * There are 2 Smart Order main type :
 * 1. Auto Buy (AB)
 * 2. Auto Sell (AS)
 *   2.1 Take Profit (TP)
 *   2.2 Stop Loss (TS)
 */ var StopOrderProductCode;
(function(StopOrderProductCode) {
    StopOrderProductCode["Unspecified"] = "ORDER_PRODUCT_CODE_UNSPECIFIED";
    StopOrderProductCode["StopLoss"] = "ORDER_PRODUCT_CODE_STOP_LOSS";
    StopOrderProductCode["TakeProfit"] = "ORDER_PRODUCT_CODE_TAKE_PROFIT";
    StopOrderProductCode["LimitIfTouched"] = "ORDER_PRODUCT_CODE_LIMIT_IF_TOUCHED";
})(StopOrderProductCode || (StopOrderProductCode = {}));
var StopOrderAssetType;
(function(StopOrderAssetType) {
    StopOrderAssetType["Unspecified"] = "ASSET_TYPE_UNSPECIFIED";
    StopOrderAssetType["Stock"] = "ASSET_TYPE_STOCK_REGULAR";
    StopOrderAssetType["Right"] = "ASSET_TYPE_STOCK_RIGHT";
    StopOrderAssetType["Warrant"] = "ASSET_TYPE_STOCK_WARRANT";
    StopOrderAssetType["Bond"] = "ASSET_TYPE_FR_BOND";
})(StopOrderAssetType || (StopOrderAssetType = {}));
var StopOrderAssetMarketBoard;
(function(StopOrderAssetMarketBoard) {
    StopOrderAssetMarketBoard["Unspecified"] = "MARKET_BOARD_UNSPECIFIED";
    StopOrderAssetMarketBoard["Reguler"] = "MARKET_BOARD_REGULER";
    StopOrderAssetMarketBoard["Tunai"] = "MARKET_BOARD_TUNAI";
})(StopOrderAssetMarketBoard || (StopOrderAssetMarketBoard = {}));
var StopOrderTriggerType;
(function(StopOrderTriggerType) {
    StopOrderTriggerType["Unspecified"] = "ORDER_TRIGGER_TYPE_UNSPECIFIED";
    StopOrderTriggerType["LessThanEqual"] = "ORDER_TRIGGER_TYPE_LTE";
    StopOrderTriggerType["GreaterThanEqual"] = "ORDER_TRIGGER_TYPE_GTE";
})(StopOrderTriggerType || (StopOrderTriggerType = {}));
var StopOrderSide;
(function(StopOrderSide) {
    StopOrderSide["Unspecified"] = "ORDER_SIDE_UNSPECIFIED";
    StopOrderSide["Buy"] = "ORDER_SIDE_BUY";
    StopOrderSide["Sell"] = "ORDER_SIDE_SELL";
})(StopOrderSide || (StopOrderSide = {}));
var StopOrderOrderType;
(function(StopOrderOrderType) {
    StopOrderOrderType["Unspecified"] = "ORDER_TYPE_UNSPECIFIED";
    StopOrderOrderType["Limit"] = "ORDER_TYPE_LIMIT";
    StopOrderOrderType["Market"] = "ORDER_TYPE_MARKET";
})(StopOrderOrderType || (StopOrderOrderType = {}));
var StopOrderExpiryType;
(function(StopOrderExpiryType) {
    StopOrderExpiryType["Unspecified"] = "ORDER_EXPIRY_TYPE_UNSPECIFIED";
    StopOrderExpiryType["GFD"] = "ORDER_EXPIRY_TYPE_GFD";
    StopOrderExpiryType["GTC"] = "ORDER_EXPIRY_TYPE_GTC";
    StopOrderExpiryType["Market"] = "ORDER_EXPIRY_TYPE_FAK";
})(StopOrderExpiryType || (StopOrderExpiryType = {}));

// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var types_trading = __webpack_require__(6421);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/utils.ts
/* eslint-disable import/prefer-default-export */ 






var getInitialPrice = function(companyData, orderType, amendPreviousPrice) {
    var price = companyData.price, orderbook = companyData.orderbook;
    var ref = orderbook || {}, bid = ref.bid, offer = ref.offer;
    var defaultPrice = Number(price) || 0;
    var isAmend = [
        trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
        trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL
    ].includes(orderType);
    if (isAmend) return amendPreviousPrice || defaultPrice;
    var bidPrice = Number(bid === null || bid === void 0 ? void 0 : bid.price);
    var offerPrice = Number(offer === null || offer === void 0 ? void 0 : offer.price);
    var isARB = Number.isNaN(bidPrice);
    var isARA = Number.isNaN(offerPrice);
    // Return orderbook price when autoreject or fallback to price field
    if (isARB) return offerPrice || defaultPrice;
    if (isARA) return bidPrice || defaultPrice;
    if (orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY && offerPrice) return offerPrice;
    if (orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL && bidPrice) return bidPrice;
    return defaultPrice;
};
var getLotOrderLimit = function() {
    return trading/* LOT_ORDER_LIMIT */.Ik[(0,utils/* getTargetAPI */.Ai)()];
};
var getSplitOrderPayload = function(param) {
    var splitOrderActive = param.splitOrderActive, splitQuantity = param.splitQuantity, splitRangeMin = param.splitRangeMin, splitRangeMax = param.splitRangeMax, splitMethod = param.splitMethod;
    if (!splitOrderActive) return {};
    var isRandom = splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM;
    var splitOrder = {
        qty: splitQuantity,
        method: splitMethod
    };
    if (isRandom) {
        splitOrder = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, splitOrder), {
            min_lot: splitRangeMin,
            max_lot: splitRangeMax
        });
    }
    return {
        split_order: splitOrder
    };
};
var getProductCode = function(type) {
    switch(type){
        case types_trading/* SmartOrderLabel.SL */.D0.SL:
            return StopOrderProductCode.StopLoss;
        case types_trading/* SmartOrderLabel.TP */.D0.TP:
            return StopOrderProductCode.TakeProfit;
        case types_trading/* SmartOrderLabel.AB */.D0.AB:
            return StopOrderProductCode.LimitIfTouched;
        default:
            return StopOrderProductCode.Unspecified;
    }
};
var getAssetType = function(assetType) {
    switch(assetType){
        case "Saham":
            return StopOrderAssetType.Stock;
        case "Right":
            return StopOrderAssetType.Right;
        case "Waran":
            return StopOrderAssetType.Warrant;
        case "Bond":
            return StopOrderAssetType.Bond;
        default:
            return StopOrderAssetType.Unspecified;
    }
};
var getAssetMarketBoard = function(assetType) {
    switch(assetType){
        case "Right":
            return StopOrderAssetMarketBoard.Tunai;
        default:
            return StopOrderAssetMarketBoard.Reguler;
    }
};
var getTriggerType = function(type) {
    switch(type){
        case types_trading/* SmartOrderLabel.SL */.D0.SL:
            return StopOrderTriggerType.LessThanEqual;
        case types_trading/* SmartOrderLabel.TP */.D0.TP:
            return StopOrderTriggerType.GreaterThanEqual;
        default:
            return StopOrderTriggerType.Unspecified;
    }
};
var generateStopOrderParams = function(symbol, shares, price, type, type_company, triggerPrice, config_type, expiry_type) {
    var triggerType = config_type === 2 ? StopOrderTriggerType.LessThanEqual : StopOrderTriggerType.GreaterThanEqual;
    var finalTriggerType = config_type !== undefined && triggerType ? triggerType : getTriggerType(type);
    var expiryType = expiry_type === "1" ? StopOrderExpiryType.GTC : StopOrderExpiryType.GFD;
    var finalExpiryType = expiry_type !== undefined && expiryType ? expiryType : StopOrderExpiryType.GTC;
    return {
        product_code: getProductCode(type),
        asset: {
            code: symbol,
            type: getAssetType(type_company),
            market_board: getAssetMarketBoard(type_company)
        },
        shares: String(shares),
        trigger_type: finalTriggerType,
        trigger_price: String(triggerPrice),
        order_price: String(price),
        order_side: StopOrderSide.Buy,
        order_expiry_type: finalExpiryType,
        order_type: StopOrderOrderType.Limit
    };
};
var generateStopOrderAmendParams = function(shares, price, triggerPrice, config_type) {
    var triggerType = config_type === 2 ? StopOrderTriggerType.LessThanEqual : StopOrderTriggerType.GreaterThanEqual;
    return {
        new_order_price: String(price !== null && price !== void 0 ? price : 0),
        new_shares: String(shares !== null && shares !== void 0 ? shares : 0),
        new_trigger_price: String(triggerPrice !== null && triggerPrice !== void 0 ? triggerPrice : 0),
        new_trigger_type: triggerType
    };
};


/***/ }),

/***/ 3215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TradingModal_TableOrderbook; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/features/transaction/useTradingStore.ts
var useTradingStore = __webpack_require__(93918);
// EXTERNAL MODULE: ./src/global/Securities/components/SkeletonWrapper/index.tsx
var SkeletonWrapper = __webpack_require__(27607);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/hooks/useBestBidData.ts
var useBestBidData = __webpack_require__(88259);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLC.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  background: #ffffff;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  table-layout: fixed;\n  width: 331px;\n\n  tbody {\n    display: block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 330px;\n  }\n\n  thead,\n  tbody tr,\n  tfoot {\n    display: table;\n    width: 330px;\n    table-layout: fixed;\n  }\n\n  tbody,\n  tfoot {\n    .blurred {\n      opacity: 0.4;\n    }\n  }\n\n  tbody > tr.best-bid-offer {\n    border-width: 5px 3px;\n    border-style: solid;\n    border-color: #ededed;\n\n    td > p {\n      line-height: 14px;\n      font-weight: normal;\n      text-align: center;\n      padding: 4px 0px;\n    }\n  }\n\n  thead {\n    th:first-child,\n    th:last-child {\n      width: 40px;\n    }\n\n    th:nth-child(2),\n    th:nth-child(5) {\n      width: 66.5px;\n    }\n\n    th:nth-child(3),\n    th:nth-child(4) {\n      width: 50px;\n    }\n  }\n\n  tbody {\n    td:first-child,\n    td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2),\n    td:nth-child(5) {\n      width: 66.5px;\n    }\n\n    td:nth-child(3),\n    td:nth-child(4) {\n      width: 50px;\n    }\n  }\n\n  tfoot {\n    td:nth-child(3) {\n      width: 100px;\n    }\n\n    td:first-child,\n    td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2),\n    td:nth-child(4) {\n      width: 66.5px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid #dadada;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f7f7f7;\n  padding: 8px 0;\n  color: #333333;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  min-width: ",
        ";\n  max-width: ",
        ";\n  margin: 0;\n  padding: 8px 0;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  white-space: nowrap;\n\n  &:empty::before {\n    content: '';\n    display: inline-block;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid #dadada;\n  background: #f7f7f7;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #333333;\n  margin: 0;\n  padding: 8px 0;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  & > .ant-skeleton-button {\n    vertical-align: middle;\n    width: 80%;\n    height: 16px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var OHLCContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3729a139-0"
})(_templateObject());
var OHLCTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-3729a139-1"
})(_templateObject1());
var OHLCTableHead = styled_components_browser_esm/* default.thead.withConfig */.ZP.thead.withConfig({
    componentId: "sc-3729a139-2"
})(_templateObject2());
var OHLCTableHeadData = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-3729a139-3"
})(_templateObject3());
var OHLCTableBodyData = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-3729a139-4"
})(_templateObject4());
var OHLCCellText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3729a139-5"
})(_templateObject5(), function(param) {
    var color = param.color;
    return color || "#333333";
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth ? "".concat(minWidth, "px") : "unset";
}, function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth ? "".concat(maxWidth, "px") : "unset";
});
var OHLCTableFoot = styled_components_browser_esm/* default.tfoot.withConfig */.ZP.tfoot.withConfig({
    componentId: "sc-3729a139-6"
})(_templateObject6());
var OHLCTableFootData = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-3729a139-7"
})(_templateObject7());
var TableOHLCTextSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-3729a139-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLCSkeleton.tsx


var TableOHLCSkeleton = function(param) {
    var _rows = param.rows, rows = _rows === void 0 ? 10 : _rows, _columns = param.columns, columns = _columns === void 0 ? 6 : _columns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OHLCTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHead, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: new Array(columns).fill("").map(function(_, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCTextSkeleton, {
                                    active: true
                                })
                            }, idx.toString());
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    style: {
                        padding: "11px 0"
                    },
                    children: new Array(rows).fill("").map(function(_, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: new Array(6).fill("").map(function(__, subIdx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCTextSkeleton, {
                                            active: true
                                        })
                                    })
                                }, subIdx.toString());
                            })
                        }, idx.toString());
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFoot, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: new Array(columns).fill("").map(function(_, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCTextSkeleton, {
                                    active: true
                                })
                            }, idx.toString());
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var TableOrderbook_TableOHLCSkeleton = (TableOHLCSkeleton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/types.ts
var StockPriceMovement;
(function(StockPriceMovement) {
    StockPriceMovement["Up"] = "Up";
    StockPriceMovement["Down"] = "Down";
    StockPriceMovement["Flat"] = "Flat";
})(StockPriceMovement || (StockPriceMovement = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/constants.ts



var _obj;
var stockPriceMovementColor = (_obj = {}, (0,_define_property/* default */.Z)(_obj, StockPriceMovement.Flat, "#94B041"), (0,_define_property/* default */.Z)(_obj, StockPriceMovement.Down, color/* default.sunsetOrange */.Z.sunsetOrange), (0,_define_property/* default */.Z)(_obj, StockPriceMovement.Up, color/* default.primary */.Z.primary), _obj);
var orderbookDataKey = {
    price: "price",
    frequency: "que_num",
    volume: "volume"
};
var bidOfferRowQuantity = 10;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/utils.tsx




var getLengthOrderbook = function() {
    var bid = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, offer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var newBid = bid || {};
    var newOffer = offer || {};
    var bidLength = (ref = Object.keys(newBid).filter(function(key) {
        return key.includes("price");
    })) === null || ref === void 0 ? void 0 : ref.length;
    var offerLength = Object.keys(newOffer).filter(function(key) {
        return key.includes("price");
    }).length;
    var dataLength = Math.max(bidLength, offerLength);
    var dataShowedLength = dataLength <= 10 ? 10 : dataLength;
    return dataShowedLength;
};
var getStockPriceMovement = function(currentPrice, previousPrice) {
    if (currentPrice === previousPrice) return StockPriceMovement.Flat;
    return currentPrice < previousPrice ? StockPriceMovement.Down : StockPriceMovement.Up;
};
var getBidOfferList = function(item, length) {
    var itemList = {
        frequency: [],
        volume: [],
        price: []
    };
    if (!item) return itemList;
    for(var i = 1; i <= length; i += 1){
        itemList.frequency = (0,_to_consumable_array/* default */.Z)(itemList.frequency).concat([
            Number(item === null || item === void 0 ? void 0 : item["".concat(orderbookDataKey.frequency).concat(i)]) || 0, 
        ]);
        itemList.price = (0,_to_consumable_array/* default */.Z)(itemList.price).concat([
            Number(item === null || item === void 0 ? void 0 : item["".concat(orderbookDataKey.price).concat(i)]) || 0, 
        ]);
        itemList.volume = (0,_to_consumable_array/* default */.Z)(itemList.volume).concat([
            (Number(item === null || item === void 0 ? void 0 : item["".concat(orderbookDataKey.volume).concat(i)]) || 0) / constant/* lotSize */.CQ, 
        ]);
    }
    return itemList;
};
var getTotalFrequencyVolume = function(bid, offer, lengthRow) {
    var frequencyVolume = {
        bid: {
            frequency: 0,
            volume: 0
        },
        offer: {
            frequency: 0,
            volume: 0
        }
    };
    var newBid = frequencyVolume.bid, newOffer = frequencyVolume.offer;
    for(var i = 0; i < lengthRow; i += 1){
        if (bid.frequency[i]) newBid.frequency += bid.frequency[i];
        if (bid.volume[i]) newBid.volume += bid.volume[i];
        if (offer.frequency[i]) newOffer.frequency += offer.frequency[i];
        if (offer.volume[i]) newOffer.volume += offer.volume[i];
    }
    return frequencyVolume;
};
var getTextColor = function(currentPrice, previousPrice) {
    return stockPriceMovementColor[getStockPriceMovement(currentPrice, previousPrice)];
};
var formatNumber = function(value) {
    return value.toLocaleString(undefined, {
        maximumFractionDigits: 0
    });
};
var formatCellValue = function(value) {
    return !value ? "-" : formatNumber(value);
};

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLCBestBidOffer.tsx



var OHLCBestBidOffer = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var data = props.data, previous = props.previous;
    if (!data) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: "best-bid-offer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 40,
                    maxWidth: 55,
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 50,
                    children: formatCellValue((ref = data.bid) === null || ref === void 0 ? void 0 : (ref1 = ref.quantity) === null || ref1 === void 0 ? void 0 : ref1.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    "data-cy": "bid-price",
                    minWidth: 50,
                    maxWidth: 55,
                    color: getTextColor((ref2 = data.bid) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.raw, previous),
                    children: formatCellValue((ref4 = data.bid) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.price) === null || ref5 === void 0 ? void 0 : ref5.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    "data-cy": "offer-price",
                    minWidth: 50,
                    maxWidth: 55,
                    color: getTextColor((ref6 = data.offer) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.price) === null || ref7 === void 0 ? void 0 : ref7.raw, previous),
                    children: formatCellValue((ref8 = data.offer) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.price) === null || ref9 === void 0 ? void 0 : ref9.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 50,
                    children: formatCellValue((ref10 = data.offer) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.quantity) === null || ref11 === void 0 ? void 0 : ref11.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 40,
                    maxWidth: 55,
                    children: "-"
                })
            })
        ]
    });
};
/* harmony default export */ var TableOHLCBestBidOffer = (OHLCBestBidOffer);

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLC.tsx










var TableOHLC = function(param) {
    var bid = param.bid, offer = param.offer, previous = param.previous, loading = param.loading, _isEmpty = param.isEmpty, isEmpty = _isEmpty === void 0 ? false : _isEmpty, bestBidOffer = param.bestBidOffer, _marketStatus = param.marketStatus, marketStatus = _marketStatus === void 0 ? "close" : _marketStatus;
    var lengthOrderbook = (0,react.useMemo)(function() {
        if (bid && offer) {
            return getLengthOrderbook(bid, offer);
        }
        return bidOfferRowQuantity;
    }, [
        bid,
        offer
    ]);
    var bidList = (0,react.useMemo)(function() {
        return getBidOfferList(bid, lengthOrderbook);
    }, [
        bid,
        lengthOrderbook
    ]);
    var offerList = (0,react.useMemo)(function() {
        return getBidOfferList(offer, lengthOrderbook);
    }, [
        offer,
        lengthOrderbook
    ]);
    var ref = (0,react.useMemo)(function() {
        return getTotalFrequencyVolume({
            frequency: bidList.frequency,
            volume: bidList.volume
        }, {
            frequency: offerList.frequency,
            volume: offerList.volume
        }, lengthOrderbook);
    }, [
        bidList.frequency.join(),
        bidList.volume.join(),
        offerList.frequency.join(),
        offerList.volume.join(),
        lengthOrderbook, 
    ]), bidTotal = ref.bid, offerTotal = ref.offer;
    var initialBestBidOffer = (0,react.useMemo)(function() {
        return bestBidOffer;
    }, []);
    var ref1 = (0,useBestBidData/* default */.Z)(initialBestBidOffer, null, marketStatus), isBlured = ref1.isBlured, showBestBid = ref1.showBestBid;
    var getRowClassName = (0,react.useCallback)(function() {
        if (isBlured) {
            return "blurred";
        }
        return "";
    }, [
        isBlured
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableOHLCSkeleton, {}),
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCContainer, {
            "data-cy": "ohlc-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OHLCTable, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !isEmpty || showBestBid,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHead, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Freq"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Lot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Bid"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Offer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Lot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Freq"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: showBestBid,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCBestBidOffer, {
                                    data: bestBidOffer,
                                    previous: previous
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isEmpty,
                                children: new Array(lengthOrderbook).fill("").map(function(_, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        "data-cy": "ohlc-row-".concat(i),
                                        className: getRowClassName(),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    color: "#8277F8",
                                                    minWidth: 40,
                                                    maxWidth: 55,
                                                    children: formatCellValue(bidList.frequency[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 50,
                                                    children: formatCellValue(bidList.volume[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    "data-cy": "bid-price",
                                                    minWidth: 50,
                                                    maxWidth: 55,
                                                    color: getTextColor(bidList.price[i], previous),
                                                    children: formatCellValue(bidList.price[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    "data-cy": "offer-price",
                                                    minWidth: 50,
                                                    maxWidth: 55,
                                                    color: getTextColor(offerList.price[i], previous),
                                                    children: formatCellValue(offerList.price[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 50,
                                                    children: formatCellValue(offerList.volume[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 40,
                                                    maxWidth: 55,
                                                    color: "#8277F8",
                                                    children: formatCellValue(offerList.frequency[i])
                                                })
                                            })
                                        ]
                                    }, "rows-".concat(i.toString()));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isEmpty && showBestBid,
                                children: Array.from({
                                    length: 10
                                }).map(function(_, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        children: Array.from({
                                            length: 6
                                        }).map(function(__, idy) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 40,
                                                    maxWidth: 55,
                                                    children: "-"
                                                })
                                            }, "empty-".concat(idy.toString()));
                                        })
                                    }, "empty-row-".concat(idx.toString()));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !isEmpty,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFoot, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: getRowClassName(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-bid-frequency",
                                        children: formatNumber(bidTotal.frequency)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-bid-volume",
                                        children: formatNumber(bidTotal.volume)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        colSpan: 2,
                                        children: "TOTAL"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-offer-volume",
                                        children: formatNumber(offerTotal.volume)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-offer-frequency",
                                        children: formatNumber(offerTotal.frequency)
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isEmpty && showBestBid,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFoot, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        colSpan: 2,
                                        children: "TOTAL"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TableOrderbook_TableOHLC = (TableOHLC);

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/global/Datafeed/modal/datafeed-modal.store.ts
var datafeed_modal_store = __webpack_require__(48481);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableSecure.styled.ts

function TableSecure_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px;\n"
    ]);
    TableSecure_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-spacing: 0 8px;\n  border-collapse: separate;\n  margin: -8px 0;\n\n  & tr {\n    & > td:nth-child(odd) {\n      white-space: nowrap;\n      padding-left: 30px;\n    }\n    & > td:nth-child(even) {\n      padding-left: 2px;\n    }\n    & > td:first-child {\n      padding-left: 0;\n      white-space: nowrap;\n    }\n  }\n\n  &.expand-ara {\n    & tr {\n      & td:nth-child(3) {\n        padding-left: 25px;\n      }\n\n      & td:nth-child(4) {\n        padding-left: 10px;\n        padding-right: 4px;\n      }\n    }\n  }\n"
    ]);
    TableSecure_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    TableSecure_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: ",
        ";\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  padding: 0;\n  white-space: nowrap;\n\n  &.single-line {\n    padding-right: 0 !important;\n  }\n\n  &.single-line > div:hover {\n    cursor: pointer;\n  }\n"
    ]);
    TableSecure_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    TableSecure_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & tr > td {\n    width: 40px;\n    height: 16px;\n\n    &:nth-child(odd) {\n      padding: 0;\n    }\n\n    & > div {\n      padding: 0 2px;\n      display: flex;\n      width: 100%;\n      & > span.ant-skeleton-button {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    TableSecure_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .ant-skeleton-button {\n    height: 16px;\n    vertical-align: middle;\n  }\n"
    ]);
    TableSecure_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var SecureTableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17b0b5c6-0"
})(TableSecure_styled_templateObject());
var SecureTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-17b0b5c6-1"
})(TableSecure_styled_templateObject1());
var SecureTableRow = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-17b0b5c6-2"
})(TableSecure_styled_templateObject2(), function(param) {
    var _minWidth = param.minWidth, minWidth = _minWidth === void 0 ? [] : _minWidth;
    return minWidth.map(function(width, idx) {
        return "\n        & > td:nth-child(".concat(idx + 1, ") {\n          min-width: ").concat(width, "px;\n        }");
    });
});
var SecureTableData = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-17b0b5c6-3"
})(TableSecure_styled_templateObject3(), function(param) {
    var color = param.color;
    return "".concat(color || "#333333");
}, function(param) {
    var align = param.align;
    return align;
});
var SecureTableDataClickable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17b0b5c6-4"
})(TableSecure_styled_templateObject4());
var SecureTableTbodySkeleton = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
    componentId: "sc-17b0b5c6-5"
})(TableSecure_styled_templateObject5());
var TableSecureColumnSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-17b0b5c6-6"
})(TableSecure_styled_templateObject6());

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableSecureSkeleton.tsx


var TableSecureSkeleton = function(param) {
    var _row = param.row, row = _row === void 0 ? 3 : _row, _column = param.column, column = _column === void 0 ? 6 : _column;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTable, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableTbodySkeleton, {
                children: new Array(row).fill("").map(function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: new Array(column).fill("").map(function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSecureColumnSkeleton, {
                                    active: true
                                })
                            });
                        })
                    });
                })
            })
        })
    }, "skeleton-comp");
};
/* harmony default export */ var TableOrderbook_TableSecureSkeleton = (TableSecureSkeleton);

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableSecure.tsx














var TableSecure_getTextColor = function(currentPrice, previousPrice) {
    return stockPriceMovementColor[getStockPriceMovement(currentPrice, previousPrice)];
};
var FourthRow = function(param) {
    var showIepIev = param.showIepIev, Iep = param.Iep, Iev = param.Iev, data = param.data;
    if (showIepIev) {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                    children: "IEP"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                    align: "right",
                    "data-cy": "iep-content",
                    color: TableSecure_getTextColor((ref = data.iepiev) === null || ref === void 0 ? void 0 : (ref1 = ref.iep) === null || ref1 === void 0 ? void 0 : ref1.raw, data.previous),
                    children: Iep
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                    children: "IEV"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                    align: "right",
                    "data-cy": "iev-content",
                    children: number/* default.kNumberFormatter */.ZP.kNumberFormatter(Iev, 0, true)
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                children: "F Buy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                align: "right",
                "data-cy": "fbuy-content",
                color: color/* default.primary */.Z.primary,
                children: number/* default.numberFormatter */.ZP.numberFormatter({
                    num: data.fbuy,
                    fixed: 1
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                children: "F Sell"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                align: "right",
                "data-cy": "fsell-content",
                color: color/* default.sunsetOrange */.Z.sunsetOrange,
                children: number/* default.numberFormatter */.ZP.numberFormatter({
                    num: data.fsell,
                    fixed: 1
                })
            })
        ]
    });
};
var defaultColumnsWidth = [
    24,
    53.3,
    30,
    47.33,
    21,
    56.3
];
var TableSecure = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data, _columnsWidth = param.columnsWidth, columnsWidth = _columnsWidth === void 0 ? defaultColumnsWidth : _columnsWidth, loading = param.loading, _isStock = param.isStock, isStock = _isStock === void 0 ? false : _isStock;
    var ref, ref1, ref2, ref3, ref4;
    var formatNumber = function(value) {
        var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0,0";
        return numeral_default()(value).format(format);
    };
    var ref5 = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!((ref = data.iepiev) === null || ref === void 0 ? void 0 : ref.iep) && !((ref1 = data.iepiev) === null || ref1 === void 0 ? void 0 : ref1.iev)) return [];
        var iepRaw = data.iepiev.iep.raw;
        var ievRaw = data.iepiev.iev.raw;
        var iep = formatNumber(iepRaw);
        var iev = data.iepiev.iev.raw ? (0,number/* parseCountAbbrv2 */.St)(ievRaw, 1, ",", true) : 0;
        var timeleft = data.iepiev.time_left_seconds;
        var showiepiev = iep && iev && (timeleft !== undefined ? timeleft > 0 : true);
        return [
            iep,
            iev,
            showiepiev
        ];
    }, [
        data.iepiev
    ]), Iep = ref5[0], Iev = ref5[1], showIepIev = ref5[2];
    var fourthRowExist = (0,react.useMemo)(function() {
        return showIepIev || data.is_foreignbs_exist;
    }, [
        showIepIev,
        data.is_foreignbs_exist
    ]);
    var lot = (0,react.useMemo)(function() {
        return data.volume ? number/* default.parseCountAbbrv2 */.ZP.parseCountAbbrv2(number/* default.parseLot */.ZP.parseLot(data.volume), 2, ",", true) : "NA";
    }, [
        data.volume
    ]);
    var showAraArbEstimation = (data === null || data === void 0 ? void 0 : (ref = data.auto_reject_estimation) === null || ref === void 0 ? void 0 : ref.length) > 0;
    var setModal = (0,datafeed_modal_store/* default */.Z)(function(state) {
        return state.openModal;
    });
    var handleOpenAra = function() {
        if (showAraArbEstimation) {
            setModal(datafeed_modal_store/* ModalNames.ARA_ARB_ESTIMATION */.s.ARA_ARB_ESTIMATION, {
                symbol: data === null || data === void 0 ? void 0 : data.symbol,
                data: (data === null || data === void 0 ? void 0 : data.auto_reject_estimation) || []
            });
        }
    };
    var getColor = function(num) {
        return TableSecure_getTextColor(num, data.previous);
    };
    if (!loading && !data) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableSecureSkeleton, {}),
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTable, {
                className: (0,clsx_m/* default */.Z)({
                    "expand-ara": showAraArbEstimation
                }),
                children: isStock ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Open"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.open),
                                    "data-cy": "open-content",
                                    children: formatNumber(data.open)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Prev"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.previous),
                                    "data-cy": "previous-content",
                                    children: formatNumber(data.previous)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: TableSecure_getTextColor(data.change, 0),
                                    "data-cy": "volume-content",
                                    children: lot
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "High"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.high),
                                    "data-cy": "high-content",
                                    children: formatNumber(data.high)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "ARA"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "ara-content",
                                    className: (0,clsx_m/* default */.Z)({
                                        "single-line": showAraArbEstimation
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableDataClickable, {
                                        className: (0,clsx_m/* default */.Z)({
                                            "item-clickable": showAraArbEstimation
                                        }),
                                        onClick: handleOpenAra,
                                        children: [
                                            (data === null || data === void 0 ? void 0 : (ref1 = data.ara) === null || ref1 === void 0 ? void 0 : ref1.visible) ? data === null || data === void 0 ? void 0 : (ref2 = data.ara) === null || ref2 === void 0 ? void 0 : ref2.value : "-",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                                condition: showAraArbEstimation,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: "/icon/chevron-down.svg",
                                                    alt: "",
                                                    height: 14,
                                                    width: 14
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Val"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: TableSecure_getTextColor(data.change, 0),
                                    "data-cy": "value-content",
                                    children: number/* default.numberFormatter */.ZP.numberFormatter({
                                        num: data.value,
                                        fixed: 1
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Low"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.low),
                                    "data-cy": "low-content",
                                    children: formatNumber(data.low)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "ARB"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "arb-content",
                                    className: (0,clsx_m/* default */.Z)({
                                        "single-line": showAraArbEstimation
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableDataClickable, {
                                        className: (0,clsx_m/* default */.Z)({
                                            "item-clickable": showAraArbEstimation
                                        }),
                                        onClick: handleOpenAra,
                                        children: [
                                            (data === null || data === void 0 ? void 0 : (ref3 = data.arb) === null || ref3 === void 0 ? void 0 : ref3.visible) ? data === null || data === void 0 ? void 0 : (ref4 = data.arb) === null || ref4 === void 0 ? void 0 : ref4.value : "-",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                                condition: showAraArbEstimation,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: "/icon/chevron-down.svg",
                                                    alt: "",
                                                    height: 14,
                                                    width: 14
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Avg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.average),
                                    "data-cy": "average-content",
                                    children: formatNumber(data.average)
                                })
                            ]
                        }),
                        fourthRowExist && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FourthRow, {
                                    data: data,
                                    showIepIev: showIepIev,
                                    Iep: Iep,
                                    Iev: Iev
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Freq"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "frequency-content",
                                    children: formatNumber(data.frequency)
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Prev"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.previous),
                                    "data-cy": "previous-content",
                                    children: formatNumber(data.previous)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Open"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.open),
                                    "data-cy": "open-content",
                                    children: formatNumber(data.open)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: TableSecure_getTextColor(data.change, 0),
                                    "data-cy": "volume-content",
                                    children: lot
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Chg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableData, {
                                    align: "right",
                                    color: TableSecure_getTextColor(data.change, 0),
                                    "data-cy": "change-content",
                                    children: [
                                        data.change > 0 && "+",
                                        formatNumber(data.change)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "High"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.high),
                                    "data-cy": "high-content",
                                    children: formatNumber(data.high)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Val"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: TableSecure_getTextColor(data.change, 0),
                                    "data-cy": "value-content",
                                    children: number/* default.numberFormatter */.ZP.numberFormatter({
                                        num: data.value,
                                        fixed: 1
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableData, {
                                    align: "right",
                                    color: TableSecure_getTextColor(data.percentage_change, 0),
                                    "data-cy": "percentage_change-content",
                                    children: [
                                        formatNumber(data.percentage_change, "0.00"),
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Low"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.low),
                                    "data-cy": "low-content",
                                    children: formatNumber(data.low)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Avg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getColor(data.average),
                                    "data-cy": "average-content",
                                    children: formatNumber(data.average)
                                })
                            ]
                        }),
                        fourthRowExist && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Freq"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "frequency-content",
                                    children: formatNumber(data.frequency)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FourthRow, {
                                    data: data,
                                    showIepIev: showIepIev,
                                    Iep: Iep,
                                    Iev: Iev
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var TableOrderbook_TableSecure = (TableSecure);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border-bottom: 1px solid ",
        ";\n  padding: 20px 16px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  border-radius: 4px;\n  position: relative;\n\n  @media ",
        " {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 15px;\n\n  & .ant-skeleton-content {\n    & > .ant-skeleton-title {\n      margin: 0 0 7.5px;\n    }\n\n    & > .ant-skeleton-paragraph {\n      margin: 0;\n    }\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 225px;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var CardHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    padding: "9px 12px",
    align: "center"
}).withConfig({
    componentId: "sc-4573d71f-0"
})(styled_templateObject(), color/* default.downgray */.Z.downgray);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4573d71f-1"
})(styled_templateObject1(), color/* default.light */.Z.light, color/* default.downgray */.Z.downgray, device/* default.tablet */.Z.tablet);
var TableHeaderTextSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).withConfig({
    componentId: "sc-4573d71f-2"
})(styled_templateObject2());
var SubCompanyText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4573d71f-3"
})(styled_templateObject3());


// EXTERNAL MODULE: ./src/global/TradingModal/components/styled.ts
var styled = __webpack_require__(80713);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableHeader.tsx









var TableHeaderSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeader, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Avatar */.Z.Avatar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderTextSkeleton, {
                    paragraph: {
                        rows: 1
                    }
                })
            ]
        })
    });
};
function TableHeader(param) {
    var data = param.data, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    if (!data) return null;
    var _icon_url = data.icon_url, icon_url = _icon_url === void 0 ? "" : _icon_url, _symbol = data.symbol, symbol = _symbol === void 0 ? "" : _symbol, _name = data.name, name = _name === void 0 ? "" : _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderSkeleton, {}),
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "flex-start",
                children: [
                    !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SymbolAvatar */.Mu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "white",
                            family: "bold",
                            size: "16px",
                            children: symbol[0]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: icon_url,
                        style: {
                            width: "40px",
                            height: "40px",
                            background: "white"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        pl: "15px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    size: "16px",
                                    children: symbol
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                mt: "3px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCompanyText, {
                                    size: "14px",
                                    color: color/* default.midgray */.Z.midgray,
                                    mr: "5px",
                                    children: name
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var TableOrderbook_TableHeader = (TableHeader);

// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePrice.ts
var useLivePrice = __webpack_require__(39767);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.types.ts
var orderbook_store_types = __webpack_require__(52781);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookReceiver.ts
var useOrderbookReceiver = __webpack_require__(49816);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookSender.ts
var useOrderbookSender = __webpack_require__(64579);
;// CONCATENATED MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbook.ts


var useOrderbook = function(symbols, stateKey, actionKey, onMessage) {
    (0,useOrderbookSender/* useOrderbookSender */.J)(stateKey, symbols);
    (0,useOrderbookReceiver/* useOrderbookReceiver */.q)(symbols, actionKey, onMessage);
};

// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderbookCompanies.ts + 1 modules
var useOrderbookCompanies = __webpack_require__(32293);
// EXTERNAL MODULE: ./src/global/Datafeed/useOrderbookIEPIEV.ts
var useOrderbookIEPIEV = __webpack_require__(28398);
// EXTERNAL MODULE: ./src/global/Datafeed/useBestBidOffer.ts
var useBestBidOffer = __webpack_require__(11562);
;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useSecuritiesOrderbook.ts










var useSecuritiesOrderbook = function(symbol) {
    var disableOrderbook = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOrderbookCompanies/* default */.Z)(function(s) {
        return [
            s.data,
            s.isLoading,
            s.loadOrderbookCompanies,
            s.resetOrderbookCompanies,
            s.setBidOffer,
            s.setHeader,
            s.setIepIev,
            s.setBestBidOffer, 
        ];
    }, shallow/* default */.Z), 8), orderbookData = ref[0], isLoading = ref[1], loadOrderbookCompanies = ref[2], resetOrderbookCompanies = ref[3], setBidOffer = ref[4], setHeader = ref[5], setIepIev = ref[6], setBestBidOffer = ref[7];
    (0,useLivePrice/* useLivePrice */.L)([
        symbol
    ], liveprice_store_types/* LivePriceSymbolsKeyEnum.SECURITIES_TRANSACTION */.j.SECURITIES_TRANSACTION, "securities_transaction", setHeader);
    useOrderbook(!disableOrderbook ? [
        symbol
    ] : [], orderbook_store_types/* OrderbookSymbolsKeyEnum.SECURITIES_TRANSACTION */.E.SECURITIES_TRANSACTION, "securities_transaction", setBidOffer);
    (0,useOrderbookIEPIEV/* useOrderbookIEPIEV */.Jj)([
        symbol
    ], "securities_transaction", setIepIev);
    (0,useBestBidOffer/* default */.ZP)([
        symbol
    ], "securities_transaction", setBestBidOffer);
    var ref1;
    var ref2 = (ref1 = orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.iepiev) !== null && ref1 !== void 0 ? ref1 : {}, iepIevTimeLeft = ref2.time_left_seconds;
    (0,react.useEffect)(function() {
        if (iepIevTimeLeft) {
            var timeoutId = setTimeout(function() {
                setIepIev(null);
            }, iepIevTimeLeft * 1000);
            return function() {
                return clearTimeout(timeoutId);
            };
        }
    }, [
        symbol,
        iepIevTimeLeft
    ]);
    (0,react.useEffect)(function() {
        if (symbol) loadOrderbookCompanies(symbol);
        else resetOrderbookCompanies();
        return function() {
            resetOrderbookCompanies();
        };
    }, [
        symbol
    ]);
    return [
        orderbookData,
        isLoading
    ];
};
/* harmony default export */ var hooks_useSecuritiesOrderbook = (useSecuritiesOrderbook);

// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/index.tsx












var TableOrderbook = function() {
    var showOrderbook = (0,store/* default */.Z)().showOrderbook;
    var symbol = (0,useTradingStore/* default */.Z)(function(s) {
        return s.symbol;
    });
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_useSecuritiesOrderbook(symbol, !showOrderbook), 2), orderbookData = ref[0], loading = ref[1];
    var companyData = (0,tradingData/* default */.Z)(function(s) {
        return s.company.data;
    });
    var isBidOfferEmpty = (0,react.useMemo)(function() {
        return !loading && !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.bid) && !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.offer);
    }, [
        loading,
        !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.bid),
        !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.offer)
    ]);
    // check if not loading and orderbookData is not empty before render orderbook table
    if (!loading && Object.keys(orderbookData).length > 0) {
        var ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableHeader, {
                    data: companyData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableSecure, {
                    data: orderbookData,
                    loading: loading,
                    isStock: (companyData === null || companyData === void 0 ? void 0 : (ref1 = companyData.type_company) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === trading/* STOCK_TYPE.saham */.L2.saham
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableOHLC, {
                    bid: orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.bid,
                    offer: orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.offer,
                    previous: orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.previous,
                    loading: loading,
                    isEmpty: isBidOfferEmpty,
                    bestBidOffer: orderbookData === null || orderbookData === void 0 ? void 0 : (ref2 = orderbookData.iepiev) === null || ref2 === void 0 ? void 0 : ref2.best_bid_offer,
                    marketStatus: companyData === null || companyData === void 0 ? void 0 : (ref3 = companyData.market_hour) === null || ref3 === void 0 ? void 0 : ref3.status
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var TradingModal_TableOrderbook = (TableOrderbook);


/***/ }),

/***/ 75671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62974);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80713);




function BidOfferBox(param) {
    var orderbook = param.orderbook;
    var bid = orderbook.bid, offer = orderbook.offer;
    var bidPrice = bid.price ? (0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(bid.price, false) : "-";
    var offerPrice = offer.price ? (0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(offer.price, false) : "-";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .BidOfferWrapper */ .VU, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .BidOffer */ .cg, {
                mr: "10px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .LeftBox */ .j2, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            children: "B"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .RightBox */ .Tw, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            children: bidPrice
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .BidOffer */ .cg, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .LeftBox */ .j2, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            children: "O"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .RightBox */ .Tw, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            children: offerPrice
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BidOfferBox);


/***/ }),

/***/ 27892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76805);



function FormItem(param) {
    var className = param.className, label = param.label, children = param.children;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: className,
        py: "10px",
        align: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lX, {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    width: 210
                },
                children: children
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (FormItem);


/***/ }),

/***/ 93951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_TradingModal_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76805);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62974);





function NumberInput(_param) {
    var value = _param.value, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "value"
    ]);
    var min = props.min, max = props.max;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_TradingModal_styled__WEBPACK_IMPORTED_MODULE_1__/* .InputNumber */ .Rn, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        value: value,
        onKeyUp: function(e) {
            // @ts-expect-error
            var newVal = e.target.value || min;
            // @ts-expect-error
            newVal = Number(e.target.value.replace(/\D/g, ""));
            if (min && newVal < min) newVal = min;
            if (max && newVal > max) newVal = max;
            // @ts-expect-error
            // eslint-disable-next-line no-param-reassign
            e.target.value = (0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(newVal, false);
        }
    }, props));
}
/* harmony default export */ __webpack_exports__["Z"] = (NumberInput);


/***/ }),

/***/ 68890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);




function OverLimitText(param) {
    var isRight = param.isRight;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ml: "180px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: "20px",
                className: "icon-toolbar_error"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                size: "13px",
                color: "red",
                ml: "3px",
                mb: "10px",
                children: [
                    "Nilai pembelian kamu tidak dapat diproses karena melebihi",
                    " ",
                    isRight ? "cash on hand" : "trading limit"
                ]
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (OverLimitText);


/***/ }),

/***/ 77017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SearchCompany; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var slice = __webpack_require__(33908);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: fit-content;\n  :hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 16px;\n  z-index: 2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  border-left: none;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 99999 !important;\n  .rc-virtual-list-holder-inner > :first-child {\n    display: none !important;\n  }\n\n  .ant-select-dropdown {\n    width: 60% !important;\n    top: -55px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:focus {\n    border-right-width: 0px !important;\n  }\n  &:hover {\n    border-right-width: 0px !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  right: 60px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b956054-0"
})(_templateObject(), color/* default.light */.Z.light);
var CatalogItem = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "13px",
    p: "3px 5px"
}).withConfig({
    componentId: "sc-1b956054-1"
})(_templateObject1(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light);
var SearchBarWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1b956054-2"
})(_templateObject2(), // @ts-expect-error
function(param) {
    var _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible;
    return isVisible ? "flex" : "none";
}, color/* default.light */.Z.light);
var IconClose = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1b956054-3"
})(_templateObject3(), color/* default.lowgray */.Z.lowgray, color/* default.light */.Z.light);
var styled_Autocomplete = (0,styled_components_browser_esm/* default */.ZP)(Autocomplete/* default */.Z).withConfig({
    componentId: "sc-1b956054-4"
})(_templateObject4());
var CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-1b956054-5"
})(_templateObject5());
var IconmoonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b956054-6"
})(_templateObject6());


;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 













var SearchCompany_Tag = Tag/* default.Tag */.Z.Tag;
var checkIsBonds = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.indexOf("FR") >= 0;
};
var SearchCompany = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var updateSymbol = param.updateSymbol, isInTradingModal = param.isInTradingModal, _isBonds = param.isBonds, isBonds = _isBonds === void 0 ? false : _isBonds;
    var dispatch = (0,es/* useDispatch */.I0)();
    var _$ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), searchResult = _$ref.result;
    var result = isBonds ? searchResult === null || searchResult === void 0 ? void 0 : searchResult.filter(function(item) {
        return checkIsBonds(item === null || item === void 0 ? void 0 : item.desc);
    }) : searchResult;
    var debouncedSearch = (0,react.useCallback)(lodash_debounce_default()(function(value) {
        dispatch(slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500), []);
    var onChange = function(e) {
        var value = e.target.value;
        debouncedSearch(value);
    };
    var onSelect = function(name, isSelectedBonds) {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
        updateSymbol(name, isSelectedBonds);
    };
    var onPressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _result, item;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (result) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _result = (0,_sliced_to_array/* default */.Z)(result, 1), item = _result[0];
                        if (item) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (!isBonds) {
                            _ctx.next = 8;
                            break;
                        }
                        updateSymbol(item.name, isBonds);
                        return _ctx.abrupt("return");
                    case 8:
                        updateSymbol(item.name, checkIsBonds(item.desc));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onPressEnter() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderLabel = function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return onSelect(item.name, checkIsBonds(item.desc));
            },
            "aria-hidden": true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany_Tag, {
                        size: "xs",
                        type: "grey",
                        children: item.keyword || item.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        pl: "10px",
                        size: "13px",
                        children: item.desc || item.name
                    })
                ]
            })
        });
    };
    var options = function(suggestions) {
        if (!suggestions) {
            return [];
        }
        var company = suggestions.length > 0 ? {
            options: suggestions.map(function(item) {
                return {
                    value: item.keyword || item.name,
                    label: renderLabel(item)
                };
            })
        } : undefined;
        var list = [
            company
        ];
        return list.filter(function(item) {
            return item !== undefined;
        });
    };
    (0,react.useEffect)(function() {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Autocomplete, {
        options: options(result),
        width: "100%",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        children: [
            isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                // @ts-expect-error
                ref: ref,
                placeholder: "Type company symbol here",
                height: "40px",
                onChange: onChange,
                width: "100%",
                loading: true,
                onPressEnter: onPressEnter,
                style: {
                    maxWidth: "460px"
                },
                "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_SEARCH_COMPANY */.eG.HEADER_SEARCH_COMPANY
            }),
            !isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {
                // @ts-expect-error
                ref: ref,
                placeholder: "",
                height: "60px",
                onChange: onChange,
                width: "100%",
                onPressEnter: onPressEnter,
                style: {
                    outline: 0,
                    fontSize: "26px",
                    padding: "0px",
                    borderWidth: "0 0 2px"
                }
            })
        ]
    });
});
/* harmony default export */ var components_SearchCompany = (SearchCompany);


/***/ }),

/***/ 33908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);




// Action type
var CONTEXT = "@global/searchCompany";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: []
};
var searchCompanyState = function(state) {
    return state.searchCompany;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(searchCompanyState, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result
    };
}, function(state) {
    return state;
});
// Effects
var effects = {
    getSearchResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(keyword) {
            var response;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearch */ .Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    resetResult: function(state) {
        state.result = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state, action) {
        state.isLoading = true;
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        var ref, ref1;
        state.result = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.company;
        state.isLoading = false;
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload;
    });
};
// Slice
var searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "searchCompany",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (searchSlice);


/***/ }),

/***/ 80713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": function() { return /* binding */ NotationCodeBox; },
/* harmony export */   "DY": function() { return /* binding */ TooltipContainer; },
/* harmony export */   "Mu": function() { return /* binding */ SymbolAvatar; },
/* harmony export */   "SD": function() { return /* binding */ NotationPopoverWrapper; },
/* harmony export */   "SX": function() { return /* binding */ SyariahLabelWrapper; },
/* harmony export */   "Tw": function() { return /* binding */ RightBox; },
/* harmony export */   "UF": function() { return /* binding */ NotationDesc; },
/* harmony export */   "VU": function() { return /* binding */ BidOfferWrapper; },
/* harmony export */   "WH": function() { return /* binding */ CustomTooltip; },
/* harmony export */   "cg": function() { return /* binding */ BidOffer; },
/* harmony export */   "j2": function() { return /* binding */ LeftBox; },
/* harmony export */   "vN": function() { return /* binding */ PriceWrapper; }
/* harmony export */ });
/* unused harmony export TransactionFormSelect */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39211);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 30px;\n  max-width: 150px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 10px;\n  display: flex;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 110px;\n  left: -5%;\n  z-index: 9999;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n\n  @media ",
        " {\n    top: 95px;\n    left: -15%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(255, 199, 116, 0.1);\n  border: 1px solid #eba031;\n  border-radius: 4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #3a645c;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 120px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}







var PriceWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    wrap: "wrap",
    align: "flex-end",
    justify: "flex-end",
    width: "100%",
    direction: "column"
}).withConfig({
    componentId: "sc-89f2b45c-0"
})(_templateObject());
var BidOfferWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-89f2b45c-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var BidOffer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "70px",
    height: "30px"
}).withConfig({
    componentId: "sc-89f2b45c-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var LeftBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "40%",
    height: "100%",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-89f2b45c-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var RightBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "60%",
    height: "100%",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-89f2b45c-4"
})(_templateObject4());
var SyariahLabelWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center",
    px: "5px",
    py: "2px",
    ml: "5px"
}).withConfig({
    componentId: "sc-89f2b45c-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var NotationPopoverWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    align: "center",
    justify: "center",
    padding: "20px",
    width: "350px"
}).withConfig({
    componentId: "sc-89f2b45c-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var NotationCodeBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "30px",
    align: "center",
    justify: "center",
    mr: "10px"
}).withConfig({
    componentId: "sc-89f2b45c-7"
})(_templateObject7());
var NotationDesc = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    margin: "0 0 10px 10px",
    py: "5px"
}).withConfig({
    componentId: "sc-89f2b45c-8"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray);
var SymbolAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-89f2b45c-9"
})(_templateObject9());
var CustomTooltip = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-89f2b45c-10"
})(_templateObject10());
var TooltipContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-89f2b45c-11"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light);
var TransactionFormSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-89f2b45c-12"
})(_templateObject12());



/***/ }),

/***/ 54202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ generateBuyFeeData; },
/* harmony export */   "z": function() { return /* binding */ generateSellData; }
/* harmony export */ });
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29097);
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable no-eval */ 

var generateBuyFeeData = function(configFormula, lot, price) {
    var isDayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var formula = configFormula.formula, preview_fee = configFormula.preview_fee, day_trade = configFormula.day_trade;
    var previewFee = isDayTrade ? day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee : preview_fee;
    // don't delete these variables! needed for eval below.
    var LOT = lot;
    var PRICE = price;
    var FEE_BUY = isDayTrade ? formula.fee_buy_day_trade : formula.fee_buy;
    var BROKER_FEE = previewFee.broker_fee;
    var EXCHANGE_FEE_TOTAL_BUY = previewFee.exchange.exchange_fee_total_buy;
    var investment = eval(formula.buy_amount_invested); // nosemgrep
    var investmentPlusFee = eval(formula.buy_amount_invested_fee); // nosemgrep
    var brokerFee = eval(formula.buy_amount_broker_fee); // nosemgrep
    var exchangeFee = eval(formula.buy_amount_exchange_fee); // nosemgrep
    return {
        investment: investment,
        investmentPlusFee: investmentPlusFee,
        brokerFee: brokerFee,
        exchangeFee: exchangeFee
    };
};
var generateSellData = function(configFormula, lot, price, averagePrice) {
    var isDayTrade = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, companyType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var isStockCorporateActions = constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .CORPORATE_ACTION_STOCK_TYPE.indexOf */ .Do.indexOf(companyType.toUpperCase()) > -1;
    var formula = configFormula.formula, preview_fee = configFormula.preview_fee, day_trade = configFormula.day_trade;
    var previewFee = isDayTrade ? day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee : preview_fee;
    var LOT = lot;
    var PRICE = price;
    var FEE_BUY = isDayTrade ? formula.fee_buy_day_trade : formula.fee_buy;
    var FEE_SELL = isDayTrade ? formula.fee_sell_day_trade : formula.fee_sell;
    FEE_SELL = isStockCorporateActions ? FEE_BUY : FEE_SELL;
    var compositions = previewFee.exchange.compositions;
    compositions = isStockCorporateActions ? compositions.filter(function(com) {
        return com.type !== 2;
    }) : compositions;
    var exchangeFee = compositions.reduce(function(total, param) {
        var value = param.value;
        return total + value;
    }, 0);
    var TOTAL_EXCHANGE_FEE = LOT * PRICE * exchangeFee;
    var SELL_AMOUNT_INVESTED_FEE = eval(formula.sell_amount_invested_fee);
    var BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE = averagePrice * lot * _constant__WEBPACK_IMPORTED_MODULE_1__/* .lotSize */ .CQ;
    var BROKER_FEE = previewFee.broker_fee;
    var EXCHANGE_FEE_TOTAL_BUY = previewFee.exchange.exchange_fee_total_buy;
    var EXCHANGE_FEE_TOTAL_SELL = previewFee.exchange.exchange_fee_total_sell;
    var SELL_FEE = eval(formula.ca_sell_amount_fee);
    var SELL_AMOUNT = eval(formula.ca_sell_amount_invested);
    var STOCKBIT_FEE = eval(formula.ca_sell_amount_broker_fee);
    var EXCHANGE_FEE = eval(formula.ca_sell_amount_exchange_fee);
    var CA_SELL_AMOUNT_INVESTED_FEE = eval(formula.ca_sell_amount_invested_fee);
    var SELL_PROFITLOSS = eval(formula.sell_profit_loss);
    var SELL_GAIN = eval(formula.sell_gain) * _constant__WEBPACK_IMPORTED_MODULE_1__/* .lotSize */ .CQ;
    return {
        SELL_FEE: SELL_FEE,
        SELL_AMOUNT: SELL_AMOUNT,
        STOCKBIT_FEE: STOCKBIT_FEE,
        TOTAL_EXCHANGE_FEE: TOTAL_EXCHANGE_FEE,
        CA_SELL_AMOUNT_INVESTED_FEE: CA_SELL_AMOUNT_INVESTED_FEE,
        SELL_PROFITLOSS: SELL_PROFITLOSS,
        SELL_GAIN: SELL_GAIN
    };
};


/***/ }),

/***/ 97103:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var generateStepPrice = function(price) {
    var newStep = 1;
    if (price > 200 && price <= 500) {
        newStep = 2;
    } else if (price > 500 && price <= 2000) {
        newStep = 5;
    } else if (price > 2000 && price <= 5000) {
        newStep = 10;
    } else if (price > 5000) {
        newStep = 25;
    }
    return newStep;
};
/* harmony default export */ __webpack_exports__["Z"] = (generateStepPrice);


/***/ }),

/***/ 62544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useFormulaStore */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var _api_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86408);







var initialState = {
    formula: {}
};
var useFormulaStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadFormula: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, axiosData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,_api_config__WEBPACK_IMPORTED_MODULE_1__/* .getFormula */ .p)();
                    case 3:
                        ref = _ctx.sent;
                        axiosData = ref.data;
                        data = axiosData.data;
                        set({
                            formula: data
                        });
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }))
    });
}, {
    name: "virtualFormula"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useFormulaStore);


/***/ }),

/***/ 72965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useVirtualOrderStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _api_order__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79397);




var useVirtualOrderStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return {
        isLoading: false,
        message: "",
        data: [],
        error: "",
        createVirtualOrder: function createVirtualOrder(orderType, symbol, form) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isLoading, response, data, orderIds;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isLoading = get().isLoading;
                            if (!isLoading) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_1__/* .postVirtualOrder */ .$C)(orderType, symbol, form);
                        case 7:
                            response = _ctx.sent;
                            data = response.data.data;
                            orderIds = "order_id" in data ? [
                                data.order_id
                            ] : data.order_ids;
                            set({
                                isLoading: false,
                                data: orderIds
                            });
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        },
        createVirtualAmendOrder: function createVirtualAmendOrder(form) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isLoading, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isLoading = get().isLoading;
                            if (!isLoading) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_1__/* .postVirtualAmendOrder */ .__)(form);
                        case 7:
                            response = _ctx.sent;
                            data = response.data.data;
                            set({
                                isLoading: false,
                                data: [
                                    data.order_id
                                ]
                            });
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 41150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ getSellProfitLoss; },
/* harmony export */   "K1": function() { return /* binding */ getSellLot; },
/* harmony export */   "Sd": function() { return /* binding */ getSellGain; },
/* harmony export */   "V$": function() { return /* binding */ getBuyLot; }
/* harmony export */ });
/* unused harmony export getFormula */
/* harmony import */ var _stores_useFormulaStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62544);
/* eslint-disable no-new-func */ 
var getFormula = function() {
    return _stores_useFormulaStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().formula;
};
var getBuyLot = function(lot, price) {
    var buy = getFormula().buy;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price), "return ".concat(buy === null || buy === void 0 ? void 0 : buy.lot))();
};
var getSellLot = function(lot, price) {
    var sell = getFormula().sell;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price), "return ".concat(sell === null || sell === void 0 ? void 0 : sell.lot))();
};
var getSellProfitLoss = function(lot, price, buyAmount) {
    var sell = getFormula().sell;
    return Function("LOT=".concat(lot, ",PRICE=").concat(price, ",BUYAMOUNT=").concat(buyAmount), "return ".concat(sell === null || sell === void 0 ? void 0 : sell.profit_loss))();
};
var getSellGain = function(sellProfitLoss, buyAmount) {
    var sell = getFormula().sell;
    return Function("SELL_PROFITLOSS=".concat(sellProfitLoss, ",BUYAMOUNT=").concat(buyAmount), "return ".concat(sell === null || sell === void 0 ? void 0 : sell.gain))();
};


/***/ }),

/***/ 45939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ji": function() { return /* reexport */ useCustomEvent; }
});

// UNUSED EXPORTS: useEmitter, useListener

;// CONCATENATED MODULE: ./src/hooks/useCustomEvent/useEmitter.ts
var useEmitter = function(eventName) {
    var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : window;
    var callEvent = function(data) {
        var event = new CustomEvent(eventName, {
            detail: data
        });
        element.dispatchEvent(event);
    };
    return callEvent;
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useCustomEvent/useListener.ts

var useListener = function(eventName, onSignal) {
    var element = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : window, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    (0,react.useEffect)(function() {
        if (typeof onSignal === "function") {
            var handleSignal = function(e) {
                onSignal(e);
            };
            element.addEventListener(eventName, handleSignal, options);
            return function() {
                return element.removeEventListener(eventName, handleSignal, options);
            };
        }
    }, [
        element,
        eventName,
        onSignal,
        options
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useCustomEvent/useCustomEvent.ts


/**
 * useCustomEvent generic hooks with custom event emitter and listener.
 * attach event detail to first generic types. **ex: useCustomEvent\<EventDetail\>()**;
 */ var useCustomEvent = function(param) {
    var eventName = param.eventName, onSignal = param.onSignal, _element = param.element, element = _element === void 0 ? window : _element, _options = param.options, options = _options === void 0 ? {} : _options;
    var handleSignal = onSignal || function() {
        return null;
    };
    useListener(eventName, handleSignal, element, options);
    return useEmitter(eventName, element);
};

;// CONCATENATED MODULE: ./src/hooks/useCustomEvent/index.ts





/***/ }),

/***/ 87315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsSecuritiesMainAccount; }
/* harmony export */ });
/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);

function useIsSecuritiesMainAccount() {
    var accountNumber = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountNumber;
    });
    var mainAccountNumber = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.mainAccountNumber;
    });
    return accountNumber === mainAccountNumber;
};


/***/ }),

/***/ 34737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ FLIPT_URL_HOST; },
/* harmony export */   "HZ": function() { return /* binding */ FLIPT_TOKEN; },
/* harmony export */   "Ii": function() { return /* binding */ FLIPT_CHARTBIT_NAMESPACE; },
/* harmony export */   "S3": function() { return /* binding */ FLIPT_DESKTOP_NAMESPACE; },
/* harmony export */   "Vr": function() { return /* binding */ FLIPT_CHARTBIT_TOKEN; },
/* harmony export */   "WQ": function() { return /* binding */ FLIPT_FINANCIAL_DATA_NAMESPACE; },
/* harmony export */   "ad": function() { return /* binding */ FLIPT_NAMESPACE; },
/* harmony export */   "g0": function() { return /* binding */ FLIPT_FINANCIAL_DATA_TOKEN; },
/* harmony export */   "uL": function() { return /* binding */ FLIPT_DESKTOP_TOKEN; }
/* harmony export */ });
// Environment variables
var _NEXT_PUBLIC_FLIPT_URL_HOST;
var FLIPT_URL_HOST = (_NEXT_PUBLIC_FLIPT_URL_HOST = "https://flipt.stockbit.com") !== null && _NEXT_PUBLIC_FLIPT_URL_HOST !== void 0 ? _NEXT_PUBLIC_FLIPT_URL_HOST : "";
var _NEXT_PUBLIC_FLIPT_NAMESPACE;
var FLIPT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_NAMESPACE = "transaction") !== null && _NEXT_PUBLIC_FLIPT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_TOKEN;
var FLIPT_TOKEN = (_NEXT_PUBLIC_FLIPT_TOKEN = "3m1ehM_SYRRg0NDWbzixtn4O5ZcVWaaQW7ytx7NAm0A=") !== null && _NEXT_PUBLIC_FLIPT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE;
var FLIPT_CHARTBIT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE = "chartbit") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN;
var FLIPT_CHARTBIT_TOKEN = (_NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN = "N58pKzjn1zMJNwH5pGTOwy3-ufiL1Xdb0VQmRCl5kek=") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN;
var FLIPT_FINANCIAL_DATA_TOKEN = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN = "7BcKXp5uJ9xPlBrKLorMCGWnzM4zE6PoPkYXdh5iMys=") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE;
var FLIPT_FINANCIAL_DATA_NAMESPACE = (_NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE = "financial-data") !== null && _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_FINANCIAL_DATA_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN;
var FLIPT_DESKTOP_TOKEN = (_NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN = "Kmho-j0dflXhQTvnnNA7y_tkuUN16W-Sg7pUo2hWPUg=") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE;
var FLIPT_DESKTOP_NAMESPACE = (_NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE = "desktop-production") !== null && _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_DESKTOP_NAMESPACE : "";


/***/ }),

/***/ 34540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FeatureFlagKeys; }
/* harmony export */ });
/**
 * Flag conventions
 * [platform]-[flag-type]-[feature-name]
 *
 * Platform:
 *   - all: all platform
 *   - android: android only
 *   - ios: ios only
 *   - web: web only
 * Flag Type:
 *   - b: boolean
 *   - v: variant
 * Feature name:
 *   - name of the feature with dash as separator
 *
 * Example:
 *   - web-b-split-order
 *   - all-v-language
 */ var FeatureFlagKeys;
(function(FeatureFlagKeys) {
    FeatureFlagKeys["SPLIT_ORDER"] = "all-b-split-order-eligibility";
    FeatureFlagKeys["FAST_ORDER"] = "web-b-fast-trade-eligibility";
    FeatureFlagKeys["TRAILING_STOP"] = "web-b-trailing-stop-eligibility";
    FeatureFlagKeys["DAY_TRADE"] = "all-b-day-trade-eligibility";
    FeatureFlagKeys["MARKET_ORDER"] = "enable-market-order";
    FeatureFlagKeys["FAST_ORDER_DUPLICATE_BIDOFFER"] = "web-b-fast-trade-duplicate-bidoffer";
    FeatureFlagKeys["CHARTBIT_MAINTENANCE"] = "chartbit_maintenance";
    FeatureFlagKeys["CHARTBIT_DEBUG"] = "chartbit_debug";
    FeatureFlagKeys["CHARTBIT_DISABLE_AUTOSAVE"] = "chartbit_disable_autosave";
    FeatureFlagKeys["CHARTBIT_IFRAME_LOGGING"] = "chartbit_iframe_logging";
    FeatureFlagKeys["CHARTBIT_TRADE_FROM_CHART"] = "chartbit_trade_from_chart";
    FeatureFlagKeys["TOP_STOCKS"] = "all-b-top-stock-eligibility";
    FeatureFlagKeys["DISABLE_DATE_BEFORE"] = "disable-date-before";
    FeatureFlagKeys["RUNNING_TRADE_CHART"] = "all-b-running-trade-chart-eligibility";
    FeatureFlagKeys["RUNNING_TRADE_CHART_FILTER"] = "all-b-running-trade-chart-date-filter-eligibility";
    FeatureFlagKeys["KEYSTAT_DIVIDEND"] = "all-b-keystat-dividend";
    FeatureFlagKeys["WEB_TRENDING_CHART"] = "web-b-trending-chart";
})(FeatureFlagKeys || (FeatureFlagKeys = {}));


/***/ }),

/***/ 62514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ useFliptBoolean; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
;// CONCATENATED MODULE: ./src/lib/flipt/hooks/useFliptBoolean.ts



function useFliptBoolean(flagKey, alwaysLoad, namespaceKey) {
    var featureFlags = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue("featureFlags");
    });
    var loadBooleanEvaluation = (0,useFliptStore/* default */.Z)(function(s) {
        return s.loadBooleanEvaluation;
    });
    var namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : undefined;
    var flag = featureFlags ? featureFlags[flagKey] : undefined;
    (0,react.useEffect)(function() {
        if (flag && !alwaysLoad) {
            return;
        }
        loadBooleanEvaluation(flagKey, namespace);
    }, [
        flagKey,
        flag,
        alwaysLoad
    ]);
    return flag ? flag.isEnabled : false;
};

;// CONCATENATED MODULE: ./src/lib/flipt/hooks/index.ts



/***/ }),

/***/ 90060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_useFliptStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/lib/flipt/constants/endpoints.ts
// endpoints
var endpoints = {
    evaluate: {
        boolean: "evaluate/v1/boolean",
        variant: "evaluate/v1/variant",
        batch: "evaluate/v1/batch"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/lib/flipt/constants/env.ts
var env = __webpack_require__(34737);
;// CONCATENATED MODULE: ./src/lib/flipt/instance.ts




var fliptApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_TOKEN */.HZ) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_TOKEN */.HZ)
        });
    }
    return config;
});
var fliptChartbitApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptChartbitApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_CHARTBIT_TOKEN */.Vr) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_CHARTBIT_TOKEN */.Vr)
        });
    }
    return config;
});
var fliptFinancialDataApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptFinancialDataApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_FINANCIAL_DATA_TOKEN */.g0)
        });
    }
    return config;
});
var fliptDesktopApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptDesktopApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_DESKTOP_NAMESPACE */.S3) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_DESKTOP_TOKEN */.uL)
        });
    }
    return config;
});

;// CONCATENATED MODULE: ./src/lib/flipt/helpers.ts

var createEntityID = function(userId) {
    return "web-".concat(userId);
};
var createEvaluationPayload = function(userId, flagKey, namespaceKey) {
    return {
        context: {
            user_id: userId
        },
        entityId: createEntityID(userId),
        flagKey: flagKey,
        namespaceKey: namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad
    };
};

;// CONCATENATED MODULE: ./src/lib/flipt/endpoints.ts




var getService = function(service) {
    if (service === "chartbit") {
        return fliptChartbitApi;
    }
    if (service === "financial-data") {
        return fliptFinancialDataApi;
    }
    if (service.includes("desktop")) {
        return fliptDesktopApi;
    }
    return fliptApi;
};
// endpoints handlers
var evaluateBoolean = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.boolean, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};
var evaluateVariant = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.variant, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};

;// CONCATENATED MODULE: ./src/lib/flipt/store/useFliptStore.ts





var useFliptStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        setUserId: function setUserId(userId) {
            set({
                userId: String(userId)
            });
        },
        loadBooleanEvaluation: function loadBooleanEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, featureFlags, namespace, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            featureFlags = getUIValue("featureFlags");
                            if (!(featureFlags && featureFlags[flagKey])) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", featureFlags[flagKey].isEnabled);
                        case 9:
                            namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : "transaction";
                            _ctx.next = 12;
                            return evaluateBoolean(userId, flagKey, namespace);
                        case 12:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    isEnabled: response.data.enabled
                                };
                            });
                            return _ctx.abrupt("return", response.data.enabled);
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadVariantEvaluation: function loadVariantEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            _ctx.next = 8;
                            return evaluateVariant(userId, flagKey, namespaceKey);
                        case 8:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    variance: response.data
                                };
                            });
                            return _ctx.abrupt("return", response.data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    };
});
/* harmony default export */ var store_useFliptStore = (useFliptStore);


/***/ }),

/***/ 25610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_orderbook__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83384);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12902);








var initialState = {
    data: {},
    isLoading: {}
};
var useGetCompanyInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        getCompanyInfo: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
                var response;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!get().isLoading[symbol]) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, draft.isLoading), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, symbol, true));
                                });
                            });
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyInfo */ .Z.getCompanyInfo(symbol);
                        case 6:
                            response = _ctx.sent;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(state, function(draft) {
                                    if (draft.data[symbol]) {
                                        draft.data[symbol] = response.data.data;
                                    } else {
                                        draft.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.data), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, symbol, response.data.data));
                                    }
                                    draft.isLoading[symbol] = false;
                                });
                            });
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](3);
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading[symbol] = false;
                                });
                            });
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        10
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useGetCompanyInfo);


/***/ }),

/***/ 33270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ThemeMode; }
/* harmony export */ });
var ThemeMode;
(function(ThemeMode) {
    ThemeMode["Dark"] = "dark";
    ThemeMode["Light"] = "light";
})(ThemeMode || (ThemeMode = {}));


/***/ })

}]);